import { db } from "../firebase";
import {
  addDoc,
  collection,
  doc,
  setDoc,
  arrayUnion,
  increment,
} from "@firebase/firestore";

const fireIcon = require("../components/image/elements/fire.webp");
const iceIcon = require("../components/image/elements/ice.webp");
const imaginaryIcon = require("../components/image/elements/imaginary.webp");
const lightningIcon = require("../components/image/elements/lightning.webp");
const physicalIcon = require("../components/image/elements/physical.webp");
const quantumIcon = require("../components/image/elements/quantum.webp");
const windIcon = require("../components/image/elements/wind.webp");

const threeStarsIcon = require("../components/image/rarity/three-star.webp");
const fourStarsIcon = require("../components/image/rarity/four-star.webp");
const fiveStarsIcon = require("../components/image/rarity/five-star.webp");

const abundanceIcon = require("../components/image/path/abundance.webp");
const destructionIcon = require("../components/image/path/destruction.webp");
const eruditionIcon = require("../components/image/path/erudition.webp");
const harmonyIcon = require("../components/image/path/harmony.webp");
const huntIcon = require("../components/image/path/hunt.webp");
const nihilityIcon = require("../components/image/path/nihility.webp");
const preservationIcon = require("../components/image/path/preservation.webp");
const remembranceIcon = require("../components/image/path/remembrance.webp");
const elationIcon = require("../components/image/path/elation.webp");

const debugMode = false;

function loadRelicImage(imageId) {
  return require(`../components/image/relic/${imageId}.webp`);
}

function loadLightconeImage(lightconeId) {
  try{
    return require(`../components/image/lightcone/${lightconeId}.webp`);
  }
  catch(e){
    if(debugMode === true) console.log(e.message + "\nLightcone : " + lightconeId);
    return require(`../components/image/lightcone/${lightconeId}.webp`);
  }
}

export async function calculateRelic(
  characterData,
  language,
  displayCharacterId
) {
  const translationLanguage = {
    score: {
      "zh-cn": "分数",
      "zh-tw": "分數",
      "en-us": "Score",
    },
  };
    //if(debugMode === true) console.log(displayCharacterId);

  if (typeof characterData.lc.i !== "undefined" && characterData.lc.i !== "") {
    characterData.lightcone = lightConeRows.find(
      (element) => element.id === characterData.lc.i
    );

    characterData.lightcone.image = await loadLightconeImage(
      characterData.lightcone.id
    );


    switch (characterData.lc.r) {
      case 1:
        characterData.lc.rank_font_color = "#CCAF84";
        characterData.lc.rank_bg_color = "black";
        characterData.lc.rank = "I";
        break;
      case 2:
        characterData.lc.rank_font_color = "#CCAF84";
        characterData.lc.rank_bg_color = "black";
        characterData.lc.rank = "II";
        break;
      case 3:
        characterData.lc.rank_font_color = "#CCAF84";
        characterData.lc.rank_bg_color = "black";
        characterData.lc.rank = "III";
        break;
      case 4:
        characterData.lc.rank_font_color = "#CCAF84";
        characterData.lc.rank_bg_color = "black";
        characterData.lc.rank = "IV";
        break;
      case 5:
        characterData.lc.rank_font_color = "black";
        characterData.lc.rank_bg_color = "#FFD472";
        characterData.lc.rank = "V";
        break;
      default:
        break;
    }
  }

  var maxLevel = 0;
  switch (characterData.a) {
    case 6:
      maxLevel = 80;
      break;
    case 5:
      maxLevel = 70;
      break;
    case 4:
      maxLevel = 60;
      break;
    case 3:
      maxLevel = 50;
      break;
    case 2:
      maxLevel = 40;
      break;
    case 1:
      maxLevel = 30;
      break;
    case 0:
      maxLevel = 20;
      break;
    default:
      break;
  }
  characterData.maxLevel = maxLevel;

  var lightConeProperties = [];
  if (typeof characterData.lc.p !== "undefined") {
    for (let i = 0; i < characterData.lc.p.length; i++) {
      switch (characterData.lc.p[i].n) {
        case "Base HP":
          characterData.lc.p[i].n = "H";
          break;
        case "Base ATK":
          characterData.lc.p[i].n = "A";
          break;
        case "Base DEF":
          characterData.lc.p[i].n = "D";
          break;
        case "H":
        case "A":
        case "D":
          break;
        default:
          lightConeProperties.push({
            n: characterData.lc.p[i].n,
            a: characterData.lc.p[i].a * 100,
          });
          break;
      }
    }
  }

  var propertyArray = [];
  for (let i = 0; i < characterData.p.length; i++) {
    switch (characterData.p[i].n) {
      case "Base HP":
        characterData.p[i].n = "H";
        break;
      case "Base ATK":
        characterData.p[i].n = "A";
        break;
      case "Base DEF":
        characterData.p[i].n = "D";
        break;
      default:
        break;
    }

    if (characterData.p[i].n === "") continue;

    var addition = characterData.p[i].a;
    var base = characterData.p[i].b;
    var total = 0;

    if (addition === null) addition = 0;

    if (base === null) base = 0;

    if (base < 1) {
      total = Math.floor((addition + base) * 1000) / 10;
      addition = Math.floor(addition * 1000) / 10;
      base = Math.floor(base * 1000) / 10;
    } else {
      total = Math.floor(addition + base).toFixed(0);

      if (addition !== null) {
        addition = Math.floor(addition).toFixed(0);
      }

      if (base !== null) {
        base = Math.floor(base).toFixed(0);
      }
    }

    var currentProperty = {};

    if (lightConeProperties.length > 0) {
      var foundProperty = false;

      for (let j = 0; j < lightConeProperties.length; j++) {
        if (lightConeProperties[j].n === characterData.p[i].n) {
          if (lightConeProperties[j].n === "S") {
            lightConeProperties[j].a = lightConeProperties[j].a / 100;
            currentProperty = {
              id: characterData.p[i].n,
              name: revertProperty(characterData.p[i].n, language),
              image: property.find((prop) => prop.id === characterData.p[i].n)
                .image,
              addition: (addition - lightConeProperties[j].a).toFixed(0),
              base: base,
              total: Number(total).toFixed(1),
              lightcone: lightConeProperties[j].a.toFixed(0),
            };
          } else {
            currentProperty = {
              id: characterData.p[i].n,
              name: revertProperty(characterData.p[i].n, language),
              image: property.find((prop) => prop.id === characterData.p[i].n)
                .image,
              addition: (addition - lightConeProperties[j].a).toFixed(1),
              base: base,
              total: Number(total).toFixed(1),
              lightcone: lightConeProperties[j].a.toFixed(0),
            };
          }

          foundProperty = true;
          break;
        }
      }

      if (foundProperty === false) {
        currentProperty = {
          id: characterData.p[i].n,
          name: revertProperty(characterData.p[i].n, language),
          image: property.find((prop) => prop.id === characterData.p[i].n)
            .image,
          addition: addition,
          base: base,
          total: total,
        };
      }
    } else {
      currentProperty = {
        id: characterData.p[i].n,
        name: revertProperty(characterData.p[i].n, language),
        image: property.find((prop) => prop.id === characterData.p[i].n).image,
        addition: addition,
        base: base,
        total: total,
      };
    }

    if (currentProperty.id === "DB") {
      continue;
    }

    // Sub Value Arrangement
    if (currentProperty.base !== 0) {
      if (
        (currentProperty.addition === "0" || currentProperty.addition === 0) &&
        typeof currentProperty.lightcone === "undefined"
      ) {
        // No need display
        currentProperty.arrangement = 0;
      } else {
        // Base + Addition? + Lightcone?
        currentProperty.arrangement = 1;
      }
    } else {
      if (typeof currentProperty.lightcone === "undefined") {
        // Display Addition Only
        currentProperty.arrangement = 2;
      } else {
        if (currentProperty.addition !== "0.0") {
          // Lightcone + Addition?
          currentProperty.arrangement = 3;
        } else {
          // Light Cone only
          currentProperty.arrangement = 4;
        }
      }
    }

    if (currentProperty.addition === null) currentProperty.addition = 0;

    propertyArray.push(currentProperty);
  }
  characterData.property = propertyArray;

  var totalScore = 0;
  // Make sure all Relic Set existed
  for (let i = 0; i < characterData.rs.length; i++) {

    var currentRelic = relic.find(
      (prop) => prop.code === characterData.rs[i].n
    );

    if (typeof currentRelic === "undefined") {
      var nameRelic = relic.find((prop) => prop.set === characterData.rs[i].n);

      if (typeof nameRelic !== "undefined") {
        characterData.rs[i].n = nameRelic.code;
      }
    }
  }

  for (let i = 0; i < characterData.rl.length; i++) {
    var scoreText = "";
    var score = 0;

    var currentRelic = relic.find((prop) => prop.id === characterData.rl[i].i);

    // Add Colour and Set Effect to All Relics
    for (let j = 0; j < characterData.rs.length; j++) {
      if (currentRelic.code === characterData.rs[j].n) {
        characterData.rl[i].set = characterData.rs[j].d;
        characterData.rl[i].set_color = currentRelic.colour;
      }
    }

    characterData.rl[i].name = currentRelic.translation[language];
    characterData.rl[i].image = await loadRelicImage(currentRelic.id);

    characterData.rl[i].m.name = revertProperty(
      characterData.rl[i].m.n,
      language
    );
    characterData.rl[i].m.image = property.find(
      (prop) => prop.id === characterData.rl[i].m.n
    ).image;

    if (isPropertyPercentage(characterData.rl[i].m.n) === true) {
      // Guessing 0.0001 Adjustment

      if (characterData.rl[i].m.n === "S") {
        characterData.rl[i].m.v = Number(characterData.rl[i].m.v).toFixed(1);
      } else {
        characterData.rl[i].m.v =
          (Math.floor((characterData.rl[i].m.v + 0.0001) * 1000) / 10).toFixed(
            1
          ) + "%";
      }
    } else {
      characterData.rl[i].m.v = Math.floor(characterData.rl[i].m.v).toFixed(0);
    }

    // Ignore Main
    if (
      currentRelic.type === "Cavern Relics" &&
      (currentRelic.id.includes("_1") || currentRelic.id.includes("_0"))
    ) {
      var mainScore = (characterData.rl[i].r / 10) * characterData.rl[i].l;

      scoreText +=
        characterData.rl[i].m.name +
        " : " +
        mainScore.toFixed(1) +
        " " +
        translationLanguage.score[language] +
        "\n-----------------------\n";
      score += mainScore;
    } else if (typeof displayCharacterId.formula !== "undefined") {
      var rate = 0.2;
      if (displayCharacterId.formula.stats[characterData.rl[i].m.n] >= 1) {
        if (
          characterData.rl[i].m.n === "EG" ||
          characterData.rl[i].m.n === "O" ||
          String(characterData.rl[i].m.n).startsWith("DB")
        ) {
          rate = 1;
        } else {
          rate = 1.6;
        }
      }

      var mainScore =
        ((rate * characterData.rl[i].r) / 10) * characterData.rl[i].l;

      scoreText +=
        characterData.rl[i].m.name +
        " : " +
        mainScore.toFixed(1) +
        " " +
        translationLanguage.score[language] +
        "\n--------------------\n";
      score += mainScore;
    }

    if (characterData.rl[i].m.n === "HR") {
      characterData.rl[i].m.n = "H";
    } else if (characterData.rl[i].m.n === "DR") {
      characterData.rl[i].m.n = "D";
    } else if (characterData.rl[i].m.n === "AR") {
      characterData.rl[i].m.n = "A";
    }

    var enhancementCount = 0;
    if (characterData.rl[i].l === 15) {
      enhancementCount = 5;
    } else if (characterData.rl[i].l >= 12) {
      enhancementCount = 4;
    } else if (characterData.rl[i].l >= 9) {
      enhancementCount = 3;
    } else if (characterData.rl[i].l >= 6) {
      enhancementCount = 2;
    } else if (characterData.rl[i].l >= 3) {
      enhancementCount = 1;
    }
    var updateEnhancement = false;

    for (let j = 0; j < characterData.rl[i].s.length; j++) {
      if (typeof characterData.rl[i].s[j].e !== "undefined") {
        updateEnhancement = true;
        enhancementCount = enhancementCount - characterData.rl[i].s[j].e + 1;
      }

      characterData.rl[i].s[j].name = revertProperty(
        characterData.rl[i].s[j].n,
        language
      );

      characterData.rl[i].s[j].image = property.find(
        (prop) => prop.id === characterData.rl[i].s[j].n
      ).image;

      if (isPropertyPercentage(characterData.rl[i].s[j].n) === true) {
        if (characterData.rl[i].s[j].n === "S") {
          characterData.rl[i].s[j].v = Number(
            characterData.rl[i].s[j].v
          ).toFixed(1);
        } else {
          characterData.rl[i].s[j].v =
            String(
              (Math.floor(characterData.rl[i].s[j].v * 1000) / 10).toFixed(1)
            ) + "%";
        }
      } else {
        characterData.rl[i].s[j].v = Math.floor(
          characterData.rl[i].s[j].v
        ).toFixed(0);
      }

      if (typeof displayCharacterId.formula !== "undefined") {
        var subScore =
          displayCharacterId.formula.stats[characterData.rl[i].s[j].n] *
          Number(characterData.rl[i].s[j].v.replace("%", ""));
        scoreText +=
          characterData.rl[i].s[j].name +
          " : " +
          subScore.toFixed(1) +
          " " +
          translationLanguage.score[language] +
          "\n";
        if (subScore >= 10) {
          characterData.rl[i].s[j].score = "10";
        } else if (subScore >= 5) {
          characterData.rl[i].s[j].score = "5";
        } else {
          characterData.rl[i].s[j].score = "0";
        }
        score += subScore;
      }

      if (characterData.rl[i].s[j].n === "HR") {
        characterData.rl[i].s[j].n = "H";
      } else if (characterData.rl[i].s[j].n === "DR") {
        characterData.rl[i].s[j].n = "D";
      } else if (characterData.rl[i].s[j].n === "AR") {
        characterData.rl[i].s[j].n = "A";
      }
    }

    if (updateEnhancement) {
      if (enhancementCount === 1 && characterData.rl[i].s.length >= 1) {
        characterData.rl[i].s[characterData.rl[i].s.length - 1].e += 1;
      } else if (enhancementCount === 2 && characterData.rl[i].s.length >= 2) {
        characterData.rl[i].s[characterData.rl[i].s.length - 1].e += 1;
        characterData.rl[i].s[characterData.rl[i].s.length - 2].e += 1;
      } else if (enhancementCount === 3 && characterData.rl[i].s.length >= 3) {
        characterData.rl[i].s[characterData.rl[i].s.length - 1].e += 1;
        characterData.rl[i].s[characterData.rl[i].s.length - 2].e += 1;
        characterData.rl[i].s[characterData.rl[i].s.length - 3].e += 1;
      }
    }

    var grade = "E";
    if (Number(score.toFixed(1)) >= 52) {
      grade = "S+";
    } else if (Number(score.toFixed(1)) >= 42) {
      grade = "S";
    } else if (Number(score.toFixed(1)) >= 32) {
      grade = "A";
    } else if (Number(score.toFixed(1)) >= 25) {
      grade = "B";
    } else if (Number(score.toFixed(1)) >= 20) {
      grade = "C";
    } else if (Number(score.toFixed(1)) >= 15) {
      grade = "D";
    }
    totalScore += Number(score.toFixed(1));
    characterData.rl[i].grade = grade;
    characterData.rl[i].score = score.toFixed(1);
    characterData.rl[i].score_text = scoreText;
  }

  var newSkillList = [];

  for (let i = 0; i < characterData.s.length; i++) {

    if(String(characterData.s[i].i).startsWith("1402_") || String(characterData.s[i].i).startsWith("8007_") || String(characterData.s[i].i).startsWith("8008_"))
    {
      characterData.s[i].i = "";
    }
    
    switch (characterData.s[i].i) {
      case "b":
        characterData.s[i].image = displayCharacterId.basic_attack;
        break;
      case "s":
        characterData.s[i].image = displayCharacterId.skill;
        break;
      case "u":
        characterData.s[i].image = displayCharacterId.ultimate;
        break;
      case "t":
        characterData.s[i].image = displayCharacterId.talent;
        break;
      case "q":
        characterData.s[i].image = displayCharacterId.technique;
        continue;
      case "1402_servant.png":
      case "1402_servant1.png":
      case "8007_servant.png":
      case "8007_servant1.png":
      case "8008_servant.png":
      case "8008_servant1.png":
      case "8008_basic_atk2.png":
      case "":
        characterData.s[i].image = null;
        break;
      default:
        if(String(characterData.s[i].i).includes("Joy") || String(characterData.s[i].i).includes("elation.png"))
        {
          characterData.s[i].image = elationIcon;
        }
        else{
          characterData.s[i].image = property.find(
            (id) => id.id === characterData.s[i].i
          ).image;
        }
        break;
    }

    if (characterData.s[i].i === "HR") {
      characterData.s[i].i = "H";
    } else if (characterData.s[i].i === "DR") {
      characterData.s[i].i = "D";
    } else if (characterData.s[i].i === "AR") {
      characterData.s[i].i = "A";
    }

    if (characterData.s[i].image !== null)
      newSkillList.push(characterData.s[i]);
  }

  var total_grade = "E";
  if (totalScore >= 312) {
    total_grade = "S+";
  } else if (totalScore >= 252) {
    total_grade = "S";
  } else if (totalScore >= 192) {
    total_grade = "A";
  } else if (totalScore >= 150) {
    total_grade = "B";
  } else if (totalScore >= 120) {
    total_grade = "C";
  } else if (totalScore >= 90) {
    total_grade = "D";
  }

  characterData.total_score = Number(totalScore.toFixed(1));
  characterData.total_grade = total_grade;
  characterData.s = newSkillList;

  return characterData;
}

export function isPropertyPercentage(target) {
  var bool = false;
  switch (target) {
    case "AR":
    case "BE":
    case "CR":
    case "CD":
    case "DR":
    case "DB":
    case "DBF":
    case "DBI":
    case "DBM":
    case "DBP":
    case "DBL":
    case "DBQ":
    case "DBW":
    case "EG":
    case "EH":
    case "EL":
    case "ER":
    case "HR":
    case "O":
    case "S":
      bool = true;
      break;
    default:
      break;
  }

  return bool;
}

const translation = {
  check_profile_1: {
    "en-us": "Do you want to check profile ",
    "zh-cn": "您想查前往查看 ",
    "zh-tw": "您想查前往查看",
  },
  check_profile_2: {
    "en-us": " ?",
    "zh-cn": " 吗？",
    "zh-tw": " 嗎？",
  },
};

export async function searchUID(validUid, alertNotification, language) {
  var world_level = 0;
  var character_list = [];
  await fetch(
    "https://asia-southeast1-hsr-statistics.cloudfunctions.net/app/api/search_v2/" +
      validUid,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  )
    .then((res) => res.json())
    .then(async (data) => {
      try {
        if (typeof data.detail !== "undefined") {
          if (
            data.detail === "User not found" ||
            data.detail === "Invalid uid"
          ) {
            alert("Invalid : User not found");
            return data.detail;
          } else if (data.detail === "Queue timeout") {
            if (
              window.location.href.includes(
                "/" + language + "/profile/" + validUid
              ) === false &&
              language !== "undefined"
            )
              window.location.href = "/" + language + "/profile/" + validUid;

            return data.detail;
          }

          if (alertNotification === true) {
            alert(
              "Honkai : Star Rail API might be updating.\n\nWe encountered some errors.\nPlease try again later."
            );
          }
        } else {
          world_level = data.player.world_level;
          character_list = data.characters;
          var uid = data.player.uid;
          var playerName = data.player.nickname;

          //const v2Doc = doc(db, "user_raw_v2", uid);
          //await setDoc(v2Doc, data, { merge: true });

          var MazeGroupID = 0;
          if (
            typeof data.player.space_info.challenge_data !== "undefined" &&
            data.player.space_info.challenge_data !== null &&
            typeof data.player.space_info.challenge_data.maze_group_id !==
              "undefined" &&
            typeof data.player.space_info.challenge_data.maze_group_id ===
              "number"
          ) {
            MazeGroupID = data.player.space_info.challenge_data.maze_group_id;
          }

          var MazeGroupIndex = 0;
          if (
            typeof data.player.space_info.challenge_data !== "undefined" &&
            data.player.space_info.challenge_data !== null &&
            typeof data.player.space_info.challenge_data.maze_group_index !==
              "undefined" &&
            typeof data.player.space_info.challenge_data.maze_group_index ===
              "number"
          ) {
            MazeGroupIndex =
              data.player.space_info.challenge_data.maze_group_index;
          }

          var characterList = [];
          var characterIdList = [];

          // Character Version 1
          for (let i = 0; i < data.characters.length; i++) {

            var characterData = data.characters[i];
            if(debugMode === true) console.log("START " + characterData.id);
            const characterDoc = doc(
              db,
              "character/id/" + characterData.id,
              uid
            );

            var property = [];
            // n -> Code for Property - HP
            // a -> Addition - 1466
            // b -> Base - 1883

            for (let j = 0; j < characterData.attributes.length; j++) {
              if(debugMode === true) console.log(characterData.attributes[j].name);
              property.push({
                n: convertProperty(
                  characterData.attributes[j].name,
                  characterData.attributes[j].display
                ),
                b: characterData.attributes[j].value,
                a: null,
              });
            }

            for (let j = 0; j < characterData.additions.length; j++) {
              var found = false;
              if(debugMode === true) console.log(characterData.additions[j].name);
              var currentAdditionPropertyCode = convertProperty(
                characterData.additions[j].name,
                characterData.additions[j].display
              );
              for (let k = 0; k < property.length; k++) {
                if (property[k].n === currentAdditionPropertyCode) {
                  found = true;
                  property[k].a = characterData.additions[j].value;
                }
              }

              if (found === false) {
              if(debugMode === true) console.log(characterData.additions[j].name + " NOT FOUND");
                property.push({
                  n: convertProperty(
                    characterData.additions[j].name,
                    characterData.additions[j].display
                  ),
                  b: null,
                  a: characterData.additions[j].value,
                });
              }
            }

            var relics = [];
            if(debugMode === true) console.log(characterData.relics.length);
            for (let j = 0; j < characterData.relics.length; j++) {

              if(debugMode === true) console.log(characterData.relics[j]);

              var relicCode = String(characterData.relics[j].icon)
                .split("/")
                [
                  String(characterData.relics[j].icon).split("/").length - 1
                ].split(".")[0];

              if (relicCode === "") {
                switch (characterData.relics[j].name) {
                  case "Taikiyan Laser Stadium":
                    relicCode = "309_0";
                    break;
                  case "Taikiyan's Arclight Race Track":
                    relicCode = "309_1";
                    break;
                  case "Insumousu's Whalefall Ship":
                    relicCode = "310_0";
                    break;
                  case "Insumousu's Frayed Hawser":
                    relicCode = "310_1";
                    break;
                  default:
                    break;
                }
              }
              

              var mainProperty = convertProperty(
                characterData.relics[j].main_affix.name,
                characterData.relics[j].main_affix.display
              );

              var subProperties = [];
              for (
                let k = 0;
                k < characterData.relics[j].sub_affix.length;
                k++
              ) {
                var currentProperty = convertProperty(
                  characterData.relics[j].sub_affix[k].name,
                  characterData.relics[j].sub_affix[k].display
                );
                subProperties.push({
                  n: currentProperty,
                  v: characterData.relics[j].sub_affix[k].value,
                  e: characterData.relics[j].sub_affix[k].count,
                });
              }

              relics.push({
                i: relicCode,
                l: characterData.relics[j].level,
                r: characterData.relics[j].rarity,
                m: {
                  n: mainProperty,
                  v: characterData.relics[j].main_affix.value,
                },
                s: subProperties,
              });
            }

            var relic_set = [];
            if(debugMode === true) console.log(characterData.relic_sets.length);
            for (let j = 0; j < characterData.relic_sets.length; j++) {
              var relicName = convertArtifact(characterData.relic_sets[j].name);

              var relicFound = false;
              for (let k = 0; k < relic_set.length; k++) {
                if (relic_set[k].n === relicName) {
                  relicFound = true;
                  if (relic_set[k].d < characterData.relic_sets[j].num) {
                    relic_set[k].d = characterData.relic_sets[j].num;
                  }
                }
              }
              if (relicFound === false) {
                relic_set.push({
                  d: characterData.relic_sets[j].num,
                  n: relicName,
                });
              }
            }

            var skills = [];
            var promotion = 0;
            // v2 API for skill tree
            for (let j = 0; j < character_list.length; j++) {
              // If same ID
              if (character_list[j].id === characterData.id) {
                promotion = character_list[j].promotion;

                for (let k = 0; k < character_list[j].skill_trees.length; k++) {
                  if(debugMode === true) console.log(k);
                  if(debugMode === true) console.log("START " + character_list[j].skill_trees[k].icon);
                  if (
                    character_list[j].skill_trees[k].icon.includes(
                      "basic_atk.png"
                    )
                  ) {
                    skills.push({
                      i: "b",
                      l: character_list[j].skill_trees[k].level,
                    });
                  } else if (
                    character_list[j].skill_trees[k].icon.includes("skill.png")
                  ) {
                    skills.push({
                      i: "s",
                      l: character_list[j].skill_trees[k].level,
                    });
                  } else if (
                    character_list[j].skill_trees[k].icon.includes(
                      "ultimate.png"
                    )
                  ) {
                    skills.push({
                      i: "u",
                      l: character_list[j].skill_trees[k].level,
                    });
                  } else if (
                    character_list[j].skill_trees[k].icon.includes("talent.png")
                  ) {
                    skills.push({
                      i: "t",
                      l: character_list[j].skill_trees[k].level,
                    });
                  } else if (
                    character_list[j].skill_trees[k].icon.includes(
                      "technique.png"
                    )
                  ) {
                    skills.push({
                      i: "q",
                      l: character_list[j].skill_trees[k].level,
                    });
                  } else {
                    // Skill Tree part
                    // bsutq
                    if (
                      character_list[j].skill_trees[k].icon.includes(
                        "skilltree"
                      ) === false &&
                      character_list[j].skill_trees[k].level !== 0
                    ) {
                      var skillFound = false;
                      var skillName = convertProperty(
                        character_list[j].skill_trees[k].icon.split("/")[
                          character_list[j].skill_trees[k].icon.split("/")
                            .length - 1
                        ],
                        "%"
                      );
                      for (
                        let innerIndex = 0;
                        innerIndex < skills.length;
                        innerIndex++
                      ) {
                        if (skillName === skills[innerIndex].i) {
                          skills[innerIndex].l += 1;
                          skillFound = true;
                          break;
                        }
                      }

                      if (skillFound === false) {
                        skills.push({
                          i: skillName,
                          l: 1,
                        });
                      }
                    }
                  }
                  if(debugMode === true) console.log("END " + character_list[j].skill_trees[k].icon);
                }
                break;
              }
            }

            var lightCone = {
              i: "",
            };

            if(debugMode === true) console.log(characterData.light_cone);
            if (
              typeof characterData.light_cone !== "undefined" &&
              characterData.light_cone !== null &&
              typeof characterData.light_cone.icon !== "undefined" &&
              characterData.light_cone.icon !== null
            ) {
              var lightconeId = String(characterData.light_cone.icon)
                .split("/")
                [
                  String(characterData.light_cone.icon).split("/").length - 1
                ].split(".")[0];

              var lightConeProperties = [];
              for (
                let j = 0;
                j < characterData.light_cone.attributes.length;
                j++
              ) {
                lightConeProperties.push({
                  n: convertProperty(
                    characterData.light_cone.attributes[j].name,
                    characterData.light_cone.attributes[j].display
                  ),
                  b: characterData.light_cone.attributes[j].value,
                });
              }

              for (
                let j = 0;
                j < characterData.light_cone.properties.length;
                j++
              ) {
              if(debugMode === true) console.log("ABCdef")
                var lcFound = false;
                var currentPropertyCode = convertProperty(
                  characterData.light_cone.properties[j].name,
                  characterData.light_cone.properties[j].display
                );
                if(debugMode === true) console.log(lightConeProperties.length)
                for (let k = 0; k < lightConeProperties.length; k++) {
                  if (lightConeProperties[k].n === currentPropertyCode) {
                    lcFound = true;
                    lightConeProperties[k].a =
                      characterData.light_cone.properties[j].value;
                  }
                }

                if (lcFound === false) {
                  lightConeProperties.push({
                    n: convertProperty(
                      characterData.light_cone.properties[j].name,
                      characterData.light_cone.properties[j].display
                    ),
                    a: characterData.light_cone.properties[j].value,
                  });
                }
              }

              lightCone = {
                i: lightconeId,
                l: characterData.light_cone.level,
                r: characterData.light_cone.rank,
                p: lightConeProperties,
              };
            }

            characterIdList.push(characterData.id);
            characterList.push({
              id: characterData.id,
              l: characterData.level,
              lc: lightCone,
              p: property,
              r: characterData.rank,
              rl: relics,
              rs: relic_set,
              s: skills,
              a: promotion,
              d: new Date(),
            });

            var finalCharacterData = JSON.parse(JSON.stringify({
                u: uid,
                n: playerName,

                l: characterData.level,
                lc: lightCone,
                p: property,
                r: characterData.rank,
                rl: relics,
                rs: relic_set,
                s: skills,
                a: promotion,
                d: new Date(),
              }));
            if(debugMode === true) console.log(characterData.id)
              
              var calculateCharacterData = await calculateRelic(
                          {
                            u: uid,
                            n: playerName,
                            l: characterData.level,
                            lc: lightCone,
                            p: property,
                            r: characterData.rank,
                            rl: relics,
                            rs: relic_set,
                            s: skills,
                            a: promotion,
                            d: new Date(),
                          },
                          "en-us",
                          characterRows.filter(id => id.id === characterData.id)[0]
                        );

              finalCharacterData.total_score = calculateCharacterData.total_score;

            if(debugMode === true) console.log("FINISH " + characterData.id);
            await setDoc(
              characterDoc,
              finalCharacterData,
              { merge: true }
            );

          }

          const profileDoc = doc(db, "user", data.player.uid);
          await setDoc(
            profileDoc,
            {
              i: String(data.player.avatar.icon)
                .split("/")
                [String(data.player.avatar.icon).split("/").length - 1].split(
                  "."
                )[0],
              w: world_level,
              u: uid,
              l: data.player.level,
              n: playerName,
              s: data.player.signature,
              ac: data.player.space_info.achievement_count,
              cc: data.player.space_info.avatar_count,
              m: MazeGroupID,
              c: MazeGroupIndex,
              cl: [],
              ci: arrayUnion(...characterIdList),
              d: new Date(),
            },
            { merge: true }
          );

          var storedProfiles = [];
          if (localStorage.getItem("profiles") !== "undefined")
            storedProfiles = JSON.parse(localStorage.getItem("profiles"));

          var inserted = false;
          if (storedProfiles === null) {
            storedProfiles = [];
          } else {
            for (let i = 0; i < storedProfiles.length; i++) {
              if (String(storedProfiles[i]).split(" ")[0].includes(uid)) {
                storedProfiles[i] = uid + " " + playerName;
                inserted = true;
              }
            }
          }

          if (inserted === false) storedProfiles.push(uid + " " + playerName);

          localStorage.setItem("profiles", JSON.stringify(storedProfiles));

          if (alertNotification === true) {
            if (
              window.confirm(
                translation.check_profile_1[language] +
                  uid +
                  translation.check_profile_2[language]
              )
            ) {
              window.location.href = "/" + language + "/profile/" + uid;
            }
          } else {
            window.location.reload();
          }
        }

        //window.location.reload();

        return data;
      } catch (e) {
        //if(debugMode === true) console.log(e.message);
        //if(debugMode === true) console.log(data);

        if (data.detail === "User not found" || data.detail === "Invalid uid") {
          alert("Invalid : User not found");
          return data.detail;
        } else if (data.detail.includes("Queue timeout")) {
          if (
            window.location.href.includes(
              "/" + language + "/profile/" + uid
            ) === false &&
            language !== "undefined"
          )
            window.location.href = "/" + language + "/profile/" + uid;
          return data.detail;
        }

        alert("We've encountered some errors.\nPlease try again later.");
        const ref = collection(db, "error");
        addDoc(ref, {
          code: "Insert Profile",
          data: data,
          error: e.message,
          created_at: new Date(),
        });
        return data;
      }
    });
}

export function revertProperty(target, language) {
  var name = "";
  switch (target) {
    case "A":
    case "AR":
      if (language === "zh-cn") {
        name = "攻击力";
      } else if (language === "zh-tw") {
        name = "攻擊力";
      } else {
        name = "ATK";
      }
      break;
    case "BE":
      if (language === "zh-cn") {
        name = "击破特攻";
      } else if (language === "zh-tw") {
        name = "擊破特攻";
      } else {
        name = "Break EFF";
      }
      break;
    case "CR":
      if (language === "zh-cn") {
        name = "暴击率";
      } else if (language === "zh-tw") {
        name = "暴擊率";
      } else {
        name = "CRIT Rate";
      }
      break;
    case "CD":
      if (language === "zh-cn") {
        name = "暴击伤害";
      } else if (language === "zh-tw") {
        name = "暴擊傷害";
      } else {
        name = "CRIT DMG";
      }
      break;
    case "D":
    case "DR":
      if (language === "zh-cn") {
        name = "防御力";
      } else if (language === "zh-tw") {
        name = "防禦力";
      } else {
        name = "DEF";
      }
      break;
    case "DB":
      name = "DMG Boost";
      break;
    case "DBF":
      if (language === "zh-cn") {
        name = "火属性";
      } else if (language === "zh-tw") {
        name = "火屬性";
      } else {
        name = "Fire";
      }
      break;
    case "DBI":
      if (language === "zh-cn") {
        name = "冰属性";
      } else if (language === "zh-tw") {
        name = "冰屬性";
      } else {
        name = "Ice";
      }
      break;
    case "DBM":
      if (language === "zh-cn") {
        name = "虚数属性";
      } else if (language === "zh-tw") {
        name = "虛數屬性";
      } else {
        name = "Imaginary";
      }
      break;
    case "DBP":
      if (language === "zh-cn") {
        name = "物理属性";
      } else if (language === "zh-tw") {
        name = "物理屬性";
      } else {
        name = "Physical";
      }
      break;
    case "DBL":
      if (language === "zh-cn") {
        name = "雷属性";
      } else if (language === "zh-tw") {
        name = "雷屬性";
      } else {
        name = "Lightning";
      }
      break;
    case "DBQ":
      if (language === "zh-cn") {
        name = "量子属性";
      } else if (language === "zh-tw") {
        name = "量子屬性";
      } else {
        name = "Quantum";
      }
      break;
    case "DBW":
      if (language === "zh-cn") {
        name = "风属性";
      } else if (language === "zh-tw") {
        name = "風屬性";
      } else {
        name = "Wind";
      }
      break;
    case "E":
      if (language === "zh-cn") {
        name = "能量上限";
      } else if (language === "zh-tw") {
        name = "能量上限";
      } else {
        name = "Energy";
      }
      break;
    case "EG":
      if (language === "zh-cn") {
        name = "能量恢复";
      } else if (language === "zh-tw") {
        name = "能量恢復";
      } else {
        name = "Energy REG";
      }
      break;
    case "EH":
      if (language === "zh-cn") {
        name = "效果命中";
      } else if (language === "zh-tw") {
        name = "效果命中";
      } else {
        name = "Effect Hit";
      }
      break;
    case "EL":
      if (language === "zh-cn") {
        name = "欢愉";
      } else if (language === "zh-tw") {
        name = "歡愉";
      } else {
        name = "Elation";
      }
      break;
    case "ER":
      if (language === "zh-cn") {
        name = "效果抵抗";
      } else if (language === "zh-tw") {
        name = "效果抵抗";
      } else {
        name = "Effect RES";
      }
      break;
    case "H":
    case "HR":
    case "HP":
      if (language === "zh-cn") {
        name = "生命值";
      } else if (language === "zh-tw") {
        name = "生命值";
      } else {
        name = "HP";
      }
      break;
    case "O":
      if (language === "zh-cn") {
        name = "治疗量";
      } else if (language === "zh-tw") {
        name = "治療量";
      } else {
        name = "Healing";
      }
      break;
    case "S":
      if (language === "zh-cn") {
        name = "速度";
      } else if (language === "zh-tw") {
        name = "速度";
      } else {
        name = "SPD";
      }
      break;
    default:
      break;
  }

  return name;
}

export function convertProperty(target, value) {
  var property = "";
  switch (target) {
    case "IconAttack.png":
    case "ATK":
      if (value.includes("%")) {
        property = "AR";
      } else {
        property = "A";
      }
      break;
    case "IconBreakUp.png":
    case "Break Effect":
      property = "BE";
      break;
    case "IconCriticalChance.png":
    case "CRIT Rate":
      property = "CR";
      break;
    case "IconCriticalDamage.png":
    case "CRIT DMG":
      property = "CD";
      break;
    case "IconDefence.png":
    case "DEF":
      if (value.includes("%")) {
        property = "DR";
      } else {
        property = "D";
      }
      break;
    case "DMG Boost":
      property = "DB";
      break;
    case "IconFireAddedRatio.png":
    case "Fire DMG Boost":
      property = "DBF";
      break;
    case "IconIceAddedRatio.png":
    case "Ice DMG Boost":
      property = "DBI";
      break;
    case "IconImaginaryAddedRatio.png":
    case "Imaginary DMG Boost":
      property = "DBM";
      break;
    case "IconPhysicalAddedRatio.png":
    case "Physical DMG Boost":
      property = "DBP";
      break;
    case "IconThunderAddedRatio.png":
    case "Lightning DMG Boost":
      property = "DBL";
      break;
    case "IconQuantumAddedRatio.png":
    case "Quantum DMG Boost":
      property = "DBQ";
      break;
    case "IconWindAddedRatio.png":
    case "Wind DMG Boost":
      property = "DBW";
      break;
    case "Energy":
      property = "E";
      break;
    case "Elation":
      property = "EL";
      break;
    case "IconEnergyRecovery.png":
    case "Energy Regeneration Rate":
      property = "EG";
      break;
    case "IconStatusProbability.png":
    case "Effect Hit Rate":
      property = "EH";
      break;
    case "Elation":
      property = "EL";
      break;
    case "IconStatusResistance.png":
    case "Effect RES":
      property = "ER";
      break;
    case "IconMaxHP.png":
    case "HP":
      if (value.includes("%")) {
        property = "HR";
      } else {
        property = "H";
      }
      break;
    case "Outgoing Healing Boost":
      property = "O";
      break;
    case "IconSpeed.png":
    case "SPD":
      property = "S";
      break;
    case "1402_servant.png":
    case "1402_servant1.png":
    case "8007_servant.png":
    case "8007_servant1.png":
    case "8008_servant.png":
    case "8008_servant1.png":
    case "":
      break;
    default:
      property = target;
      /*
      const ref = collection(db, "urgent");
      addDoc(ref, {
        error: target,
        code: "Unknown Property",
        created_at: new Date(),
      });
      */
      break;
  }

  return property;
}

export function revertArtifact(target) {
  var relicName = "";
  switch (target) {
    case "AGD":
      relicName = "The Ashblazing Grand Duke";
      break;
    case "ATEL":
      relicName = "Amphoreus, The Eternal Land";
      break;
    case "AWD":
      relicName = "Arcadia of Woven Dreams";
      break;
    case "BA":
      relicName = "Belobog of the Architects";
      break;
    case "BCS":
      relicName = "Bone Collection's Serene Demesne";
      break;
    case "BST":
      relicName = "Band of Sizzling Thunder";
      break;
    case "CD":
      relicName = "Celestial Differentiator";
      break;
    case "CSB":
      relicName = "Champion of Streetwise Boxing";
      break;
    case "DDR":
      relicName = "Diviner of Distant Reach";
      break;
    case "DDRW":
      relicName = "Duran, Dynasty of Running Wolves";
      break;
    case "DQMS":
      relicName = "Divine-Querying Master Smith";
      break;
    case "EGMG":
      relicName = "Ever-Glorious Magical Girl";
      break;
    case "ETL":
      relicName = "Eagle of Twilight Line";
      break;
    case "FA":
      relicName = "Fleet of the Ageless";
      break;
    case "FF":
      relicName = "Firmament Frontline: Glamoth";
      break;
    case "FKL":
      relicName = "Forge of the Kalpagni Lantern";
      break;
    case "FLF":
      relicName = "Firesmith of Lava-Forging";
      break;
    case "GBS":
      relicName = "Genius of Brilliant Stars";
      break;
    case "GTRB":
      relicName = "Giant Tree of Rapt Brooding";
      break;
    case "GWS":
      relicName = "Guard of Wuthering Snow";
      break;
    case "HGF":
      relicName = "Hunter of Glacial Forest";
      break;
    case "HTS":
      relicName = "Hero of Triumphant Song";
      break;
    case "IS":
      relicName = "Inert Salsotto";
      break;
    case "IGT":
      relicName = "Izumo Gensei and Takama Divine Realm";
      break;
    case "KPP":
      relicName = "Knight of Purity Palace";
      break;
    case "LD":
      relicName = "Longevous Disciple";
      break;
    case "LSS":
      relicName = "Lushaka, the Sunken Seas";
      break;
    case "MWW":
      relicName = "Musketeer of Wild Wheat";
      break;
    case "MTH":
      relicName = "Messenger Traversing Hackerspace";
      break;
    case "PDC":
      relicName = "Prisoner in Deep Confinement";
      break;
    case "PDDW":
      relicName = "Pioneer Diver of Dead Waters";
      break;
    case "PGCE":
      relicName = "Pan-Galactic Commercial Enterprise";
      break;
    case "PL":
      relicName = "Penacony, Land of the Dreams";
      break;
    case "PMC":
      relicName = "Poet of Mourning Collapse";
      break;
    case "PSZ":
      relicName = "Punklorde Stage Zero";
      break;
    case "PWC":
      relicName = "Passerby of Wandering Cloud";
      break;
    case "RTS":
      relicName = "Revelry by the Sea";
      break;
    case "SER":
      relicName = "Self-Enshrouded Recluse";
      break;
    case "SUD":
      relicName = "Sigonia, the Unclaimed Desolation";
      break;
    case "SSS":
      relicName = "Space Sealing Station";
      break;
    case "SV":
      relicName = "Sprightly Vonwacq";
      break;
    case "TKB":
      relicName = "Talia: Kingdom of Banditry";
      break;
    case "TL":
      relicName = "Tengoku@Livestream";
      break;
    case "TSM":
      relicName = "Thief of Shooting Meteor";
      break;
    case "TWBP":
      relicName = "The Wondrous BananAmusement Park";
      break;
    case "WBD":
      relicName = "Wastelander of Banditry Desert";
      break;
    case "WC":
      relicName = "Wavestrider Captain";
      break;
    case "WGST":
      relicName = "Warrior Goddess of Sun and Thunder";
      break;
    case "WMDM":
      relicName = "Watchmaker, Master of Dream Machinations";
      break;
    case "WRD":
      relicName = "World-Remaking Deliverer";
      break;
    default:
      relicName = target;
      break;
  }

  return relicName;
}

export function convertArtifact(target) {
  var relicName = "";
  switch (target) {
    case "The Ashblazing Grand Duke":
      relicName = "AGD";
      break;
    case "Amphoreus, The Eternal Land":
      relicName = "ATEL";
      break;
    case "Arcadia of Woven Dreams":
      relicName = "AWD";
      break;
    case "Belobog of the Architects":
      relicName = "BA";
      break;
    case "Bone Collection's Serene Demesne":
      relicName = "BCS";
      break;
    case "Broken Keel":
      relicName = "BK";
      break;
    case "Band of Sizzling Thunder":
      relicName = "BST";
      break;
    case "Celestial Differentiator":
      relicName = "CD";
      break;
    case "Champion of Streetwise Boxing":
      relicName = "CSB";
      break;
    case "Diviner of Distant Reach":
      relicName = "DDR";
      break;
    case "Duran, Dynasty of Running Wolves":
      relicName = "DDRW";
      break;
    case "Divine-Querying Master Smith":
      relicName = "DQMS";
      break;
    case "Ever-Glorious Magical Girl":
      relicName = "EGMG";
      break;
    case "Eagle of Twilight Line":
      relicName = "ETL";
      break;
    case "Fleet of the Ageless":
      relicName = "FA";
      break;
    case "Firmament Frontline: Glamoth":
      relicName = "FF";
      break;
    case "Forge of the Kalpagni Lantern":
      relicName = "FKL";
      break;
    case "Firesmith of Lava-Forging":
      relicName = "FLF";
      break;
    case "Genius of Brilliant Stars":
      relicName = "GBS";
      break;
    case "Giant Tree of Rapt Brooding":
      relicName = "GTRB";
      break;
    case "Guard of Wuthering Snow":
      relicName = "GWS";
      break;
    case "Hunter of Glacial Forest":
      relicName = "HGF";
      break;
    case "Hero of Triumphant Song":
      relicName = "HTS";
      break;
    case "Inert Salsotto":
      relicName = "IS";
      break;
    case "Izumo Gensei and Takama Divine Realm":
      relicName = "IGT";
      break;
    case "Knight of Purity Palace":
      relicName = "KPP";
      break;
    case "Longevous Disciple":
      relicName = "LD";
      break;
    case "Lushaka, the Sunken Seas":
      relicName = "LSS";
      break;
    case "Messenger Traversing Hackerspace":
      relicName = "MTH";
      break;
    case "Musketeer of Wild Wheat":
      relicName = "MWW";
      break;
    case "Prisoner in Deep Confinement":
      relicName = "PDC";
      break;
    case "Pioneer Diver of Dead Waters":
      relicName = "PDDW";
      break;
    case "Pan-Cosmic Commercial Enterprise":
    case "Pan-Galactic Commercial Enterprise":
      relicName = "PGCE";
      break;
    case "Penacony, Land of the Dreams":
      relicName = "PL";
      break;
    case "Poet of Mourning Collapse":
      relicName = "PMC";
      break;
    case "Punklorde Stage Zero":
      relicName = "PSZ";
      break;
    case "Passerby of Wandering Cloud":
      relicName = "PWC";
      break;
    case "Revelry by the Sea":
      relicName = "RTS";
      break;
    case "Self-Enshrouded Recluse":
      relicName = "SER";
      break;
    case "Sigonia, the Unclaimed Desolation":
      relicName = "SUD";
      break;
    case "Rutilant Arena":
      relicName = "RA";
      break;
    case "Sprightly Vonwacq":
      relicName = "SV";
      break;
    case "Space Sealing Station":
      relicName = "SSS";
      break;
    case "Tengoku@Livestream":
      relicName = "TL";
      break;
    case "Talia: Kingdom of Banditry":
      relicName = "TKB";
      break;
    case "Thief of Shooting Meteor":
      relicName = "TSM";
      break;
    case "The Wondrous BananAmusement Park":
      relicName = "TWBP";
      break;
    case "Wastelander of Banditry Desert":
      relicName = "WBD";
      break;
    case "Wavestrider Captain":
      relicName = "WC";
      break;
    case "Warrior Goddess of Sun and Thunder":
      relicName = "WGST";
      break;
    case "Watchmaker, Master of Dream Machinations":
      relicName = "WMDM";
      break;
    case "World-Remaking Deliverer":
      relicName = "WRD";
      break;
    default:
      relicName = target;
      /*
      const ref = collection(db, "urgent");
      addDoc(ref, {
        error: target,
        code: "Utils / Unknown Relic",
        created_at: new Date(),
      });
      */
      break;
  }

  return relicName;
}

export const relic = [
  {
    id: "101_0",
    name: "Passerby's Rejuvenated Wooden Hairstick",
    set: "Passerby of Wandering Cloud",
    type: "Cavern Relics",
    translation: {
      "en-us": "Passerby's Rejuvenated Wooden Hairstick",
      "zh-cn": "过客的逢春木簪",
      "zh-tw": "過客的逢春木簪",
    },
    translation_set: {
      "en-us": "Passerby of Wandering Cloud",
      "zh-cn": "云无留迹的过客",
      "zh-tw": "云無留蹟的過客",
    },
    code: "PWC",
    colour: "#484f5a",
  },
  {
    id: "101_1",
    name: "Passerby's Roaming Dragon Bracer",
    set: "Passerby of Wandering Cloud",
    type: "Cavern Relics",
    translation: {
      "en-us": "Passerby's Roaming Dragon Bracer",
      "zh-cn": "过客的游龙臂鞲",
      "zh-tw": "過客的遊龍臂鞲",
    },
    translation_set: {
      "en-us": "Passerby of Wandering Cloud",
      "zh-cn": "云无留迹的过客",
      "zh-tw": "云無留蹟的過客",
    },
    code: "PWC",
    colour: "#484f5a",
  },
  {
    id: "101_2",
    name: "Passerby's Ragged Embroided Coat",
    set: "Passerby of Wandering Cloud",
    type: "Cavern Relics",
    translation: {
      "en-us": "Passerby's Ragged Embroided Coat",
      "zh-cn": "过客的残绣风衣",
      "zh-tw": "過客的殘繡風衣",
    },
    translation_set: {
      "en-us": "Passerby of Wandering Cloud",
      "zh-cn": "云无留迹的过客",
      "zh-tw": "云無留蹟的過客",
    },
    code: "PWC",
    colour: "#484f5a",
  },
  {
    id: "101_3",
    name: "Passerby's Stygian Hiking Boots",
    set: "Passerby of Wandering Cloud",
    type: "Cavern Relics",
    translation: {
      "en-us": "Passerby's Stygian Hiking Boots",
      "zh-cn": "过客的冥途游履",
      "zh-tw": "過客的冥途遊履",
    },
    translation_set: {
      "en-us": "Passerby of Wandering Cloud",
      "zh-cn": "云无留迹的过客",
      "zh-tw": "云無留蹟的過客",
    },
    code: "PWC",
    colour: "#484f5a",
  },
  {
    id: "102_0",
    name: "Musketeer's Wild Wheat Felt Hat",
    set: "Musketeer of Wild Wheat",
    type: "Cavern Relics",
    translation: {
      "en-us": "Musketeer's Wild Wheat Felt Hat",
      "zh-cn": "快枪手的野穗毡帽",
      "zh-tw": "快槍手的野穗氈帽",
    },
    translation_set: {
      "en-us": "Musketeer of Wild Wheat",
      "zh-cn": "野穗伴行的快枪手",
      "zh-tw": "野穗伴行的快槍手",
    },
    code: "MWW",
    colour: "#a37370",
  },
  {
    id: "102_1",
    name: "Musketeer's Coarse Leather Gloves",
    set: "Musketeer of Wild Wheat",
    type: "Cavern Relics",
    translation: {
      "en-us": "Musketeer's Coarse Leather Gloves",
      "zh-cn": "快枪手的粗革手套",
      "zh-tw": "快槍手的粗革手套",
    },
    translation_set: {
      "en-us": "Musketeer of Wild Wheat",
      "zh-cn": "野穗伴行的快枪手",
      "zh-tw": "野穗伴行的快槍手",
    },
    code: "MWW",
    colour: "#a37370",
  },
  {
    id: "102_2",
    name: "Musketeer's Wind-Hunting Shawl",
    set: "Musketeer of Wild Wheat",
    type: "Cavern Relics",
    translation: {
      "en-us": "Musketeer's Wind-Hunting Shawl",
      "zh-cn": "快枪手的猎风披肩",
      "zh-tw": "快槍手的獵風披肩",
    },
    translation_set: {
      "en-us": "Musketeer of Wild Wheat",
      "zh-cn": "野穗伴行的快枪手",
      "zh-tw": "野穗伴行的快槍手",
    },
    code: "MWW",
    colour: "#a37370",
  },
  {
    id: "102_3",
    name: "Musketeer's Rivets Riding Boots",
    set: "Musketeer of Wild Wheat",
    type: "Cavern Relics",
    translation: {
      "en-us": "Musketeer's Rivets Riding Boots",
      "zh-cn": "快枪手的铆钉马靴",
      "zh-tw": "快槍手的鉚釘馬靴",
    },
    translation_set: {
      "en-us": "Musketeer of Wild Wheat",
      "zh-cn": "野穗伴行的快枪手",
      "zh-tw": "野穗伴行的快槍手",
    },
    code: "MWW",
    colour: "#a37370",
  },
  {
    id: "103_0",
    name: "Knight's Forgiving Casque",
    set: "Knight of Purity Palace",
    type: "Cavern Relics",
    translation: {
      "en-us": "Knight's Forgiving Casque",
      "zh-cn": "圣骑的宽恕盔面",
      "zh-tw": "聖騎的寬恕盔面",
    },
    translation_set: {
      "en-us": "Knight of Purity Palace",
      "zh-cn": "净庭教宗的圣骑士",
      "zh-tw": "淨庭教宗的聖騎士",
    },
    code: "KPP",
    colour: "#e7e6e9",
  },
  {
    id: "103_1",
    name: "Knight's Silent Oath Ring",
    set: "Knight of Purity Palace",
    type: "Cavern Relics",
    translation: {
      "en-us": "Knight's Silent Oath Ring",
      "zh-cn": "圣骑的沉默誓环",
      "zh-tw": "聖騎的沉默誓環",
    },
    translation_set: {
      "en-us": "Knight of Purity Palace",
      "zh-cn": "净庭教宗的圣骑士",
      "zh-tw": "淨庭教宗的聖騎士",
    },
    code: "KPP",
    colour: "#e7e6e9",
  },
  {
    id: "103_2",
    name: "Knight's Solemn Breastplate",
    set: "Knight of Purity Palace",
    type: "Cavern Relics",
    translation: {
      "en-us": "Knight's Solemn Breastplate",
      "zh-cn": "圣骑的肃穆胸甲",
      "zh-tw": "聖騎的肅穆胸甲",
    },
    translation_set: {
      "en-us": "Knight of Purity Palace",
      "zh-cn": "净庭教宗的圣骑士",
      "zh-tw": "淨庭教宗的聖騎士",
    },
    code: "KPP",
    colour: "#e7e6e9",
  },
  {
    id: "103_3",
    name: "Knight's Iron Boots of Order",
    set: "Knight of Purity Palace",
    type: "Cavern Relics",
    translation: {
      "en-us": "Knight's Iron Boots of Order",
      "zh-cn": "圣骑的秩序铁靴",
      "zh-tw": "聖騎的秩序鐵靴",
    },
    translation_set: {
      "en-us": "Knight of Purity Palace",
      "zh-cn": "净庭教宗的圣骑士",
      "zh-tw": "淨庭教宗的聖騎士",
    },
    code: "KPP",
    colour: "#e7e6e9",
  },
  {
    id: "104_0",
    name: "Hunter's Artaius Hood",
    set: "Hunter of Glacial Forest",
    type: "Cavern Relics",
    translation: {
      "en-us": "Hunter's Artaius Hood",
      "zh-cn": "雪猎的荒神兜帽",
      "zh-tw": "雪獵的荒神兜帽",
    },
    translation_set: {
      "en-us": "Hunter of Glacial Forest",
      "zh-cn": "密林卧雪的猎人",
      "zh-tw": "密林臥雪的獵人",
    },
    code: "HGF",
    colour: "#f3ebec",
  },
  {
    id: "104_1",
    name: "Hunter's Lizard Gloves",
    set: "Hunter of Glacial Forest",
    type: "Cavern Relics",
    translation: {
      "en-us": "Hunter's Lizard Gloves",
      "zh-cn": "雪猎的巨蜥手套",
      "zh-tw": "雪獵的巨蜥手套",
    },
    translation_set: {
      "en-us": "Hunter of Glacial Forest",
      "zh-cn": "密林卧雪的猎人",
      "zh-tw": "密林臥雪的獵人",
    },
    code: "HGF",
    colour: "#f3ebec",
  },
  {
    id: "104_2",
    name: "Hunter's Ice Dragon Cloak",
    set: "Hunter of Glacial Forest",
    type: "Cavern Relics",
    translation: {
      "en-us": "Hunter's Ice Dragon Cloak",
      "zh-cn": "雪猎的冰龙披风",
      "zh-tw": "雪獵的冰龍披風",
    },
    translation_set: {
      "en-us": "Hunter of Glacial Forest",
      "zh-cn": "密林卧雪的猎人",
      "zh-tw": "密林臥雪的獵人",
    },
    code: "HGF",
    colour: "#f3ebec",
  },
  {
    id: "104_3",
    name: "Hunter's Soft Elkskin Boots",
    set: "Hunter of Glacial Forest",
    type: "Cavern Relics",
    translation: {
      "en-us": "Hunter's Soft Elkskin Boots",
      "zh-cn": "雪猎的鹿皮软靴",
      "zh-tw": "雪獵的鹿皮軟靴",
    },
    translation_set: {
      "en-us": "Hunter of Glacial Forest",
      "zh-cn": "密林卧雪的猎人",
      "zh-tw": "密林臥雪的獵人",
    },
    code: "HGF",
    colour: "#f3ebec",
  },
  {
    id: "105_0",
    name: "Champion's Headgear",
    set: "Champion of Streetwise Boxing",
    type: "Cavern Relics",
    translation: {
      "en-us": "Champion's Headgear",
      "zh-cn": "拳王的冠军护头",
      "zh-tw": "拳王的冠軍護頭",
    },
    translation_set: {
      "en-us": "Champion of Streetwise Boxing",
      "zh-cn": "街头出身的拳王",
      "zh-tw": "街頭出身的拳王",
    },
    code: "CSB",
    colour: "#3c2f2f",
  },
  {
    id: "105_1",
    name: "Champion's Heavy Gloves",
    set: "Champion of Streetwise Boxing",
    type: "Cavern Relics",
    translation: {
      "en-us": "Champion's Heavy Gloves",
      "zh-cn": "拳王的重炮拳套",
      "zh-tw": "拳王的重砲拳套",
    },
    translation_set: {
      "en-us": "Champion of Streetwise Boxing",
      "zh-cn": "街头出身的拳王",
      "zh-tw": "街頭出身的拳王",
    },
    code: "CSB",
    colour: "#3c2f2f",
  },
  {
    id: "105_2",
    name: "Champion's Chest Guard",
    set: "Champion of Streetwise Boxing",
    type: "Cavern Relics",
    translation: {
      "en-us": "Champion's Chest Guard",
      "zh-cn": "拳王的贴身护胸",
      "zh-tw": "拳王的貼身護胸",
    },
    translation_set: {
      "en-us": "Champion of Streetwise Boxing",
      "zh-cn": "街头出身的拳王",
      "zh-tw": "街頭出身的拳王",
    },
    code: "CSB",
    colour: "#3c2f2f",
  },
  {
    id: "105_3",
    name: "Champion's Fleetfoot Boots",
    set: "Champion of Streetwise Boxing",
    type: "Cavern Relics",
    translation: {
      "en-us": "Champion's Fleetfoot Boots",
      "zh-cn": "拳王的弧步战靴",
      "zh-tw": "拳王的弧步戰靴",
    },
    translation_set: {
      "en-us": "Champion of Streetwise Boxing",
      "zh-cn": "街头出身的拳王",
      "zh-tw": "街頭出身的拳王",
    },
    code: "CSB",
    colour: "#3c2f2f",
  },
  {
    id: "106_0",
    name: "Guard's Cast Iron Helmet",
    set: "Guard of Wuthering Snow",
    type: "Cavern Relics",
    translation: {
      "en-us": "Guard's Cast Iron Helmet",
      "zh-cn": "铁卫的铸铁面盔",
      "zh-tw": "鐵衛的鑄鐵面盔",
    },
    translation_set: {
      "en-us": "Guard of Wuthering Snow",
      "zh-cn": "戍卫风雪的铁卫",
      "zh-tw": "戍衛風雪的鐵衛",
    },
    code: "GWS",
    colour: "#23369d",
  },
  {
    id: "106_1",
    name: "Guard's Shining Gauntlets",
    set: "Guard of Wuthering Snow",
    type: "Cavern Relics",
    translation: {
      "en-us": "Guard's Shining Gauntlets",
      "zh-cn": "铁卫的银鳞手甲",
      "zh-tw": "鐵衛的銀鱗手甲",
    },
    translation_set: {
      "en-us": "Guard of Wuthering Snow",
      "zh-cn": "戍卫风雪的铁卫",
      "zh-tw": "戍衛風雪的鐵衛",
    },
    code: "GWS",
    colour: "#23369d",
  },
  {
    id: "106_2",
    name: "Guard's Uniform of Old",
    set: "Guard of Wuthering Snow",
    type: "Cavern Relics",
    translation: {
      "en-us": "Guard's Uniform of Old",
      "zh-cn": "铁卫的旧制军服",
      "zh-tw": "鐵衛的舊制軍服",
    },
    translation_set: {
      "en-us": "Guard of Wuthering Snow",
      "zh-cn": "戍卫风雪的铁卫",
      "zh-tw": "戍衛風雪的鐵衛",
    },
    code: "GWS",
    colour: "#23369d",
  },
  {
    id: "106_3",
    name: "Guard's Silver Greaves",
    set: "Guard of Wuthering Snow",
    type: "Cavern Relics",
    translation: {
      "en-us": "Guard's Silver Greaves",
      "zh-cn": "铁卫的白银护胫",
      "zh-tw": "鐵衛的白銀護脛",
    },
    translation_set: {
      "en-us": "Guard of Wuthering Snow",
      "zh-cn": "戍卫风雪的铁卫",
      "zh-tw": "戍衛風雪的鐵衛",
    },
    code: "GWS",
    colour: "#23369d",
  },
  {
    id: "107_0",
    name: "Firesmith's Obsidian Goggles",
    set: "Firesmith of Lava-Forging",
    type: "Cavern Relics",
    translation: {
      "en-us": "Firesmith's Obsidian Goggles",
      "zh-cn": "火匠的黑曜目镜",
      "zh-tw": "火匠的黑曜目鏡",
    },
    translation_set: {
      "en-us": "Firesmith of Lava-Forging",
      "zh-cn": "熔岩锻铸的火匠",
      "zh-tw": "熔岩鍛鑄的火匠",
    },
    code: "FLF",
    colour: "#ae2328",
  },
  {
    id: "107_1",
    name: "Firesmith's Ring of Flame-Mastery",
    set: "Firesmith of Lava-Forging",
    type: "Cavern Relics",
    translation: {
      "en-us": "Firesmith's Ring of Flame-Mastery",
      "zh-cn": "火匠的御火戒指",
      "zh-tw": "火匠的御火戒指",
    },
    translation_set: {
      "en-us": "Firesmith of Lava-Forging",
      "zh-cn": "熔岩锻铸的火匠",
      "zh-tw": "熔岩鍛鑄的火匠",
    },
    code: "FLF",
    colour: "#ae2328",
  },
  {
    id: "107_2",
    name: "Firesmith's Fireproof Apron",
    set: "Firesmith of Lava-Forging",
    type: "Cavern Relics",
    translation: {
      "en-us": "Firesmith's Fireproof Apron",
      "zh-cn": "火匠的阻燃围裙",
      "zh-tw": "火匠的阻燃圍裙",
    },
    translation_set: {
      "en-us": "Firesmith of Lava-Forging",
      "zh-cn": "熔岩锻铸的火匠",
      "zh-tw": "熔岩鍛鑄的火匠",
    },
    code: "FLF",
    colour: "#ae2328",
  },
  {
    id: "107_3",
    name: "Firesmith's Alloy Leg",
    set: "Firesmith of Lava-Forging",
    type: "Cavern Relics",
    translation: {
      "en-us": "Firesmith's Alloy Leg",
      "zh-cn": "火匠的合金义肢",
      "zh-tw": "火匠的合金義肢",
    },
    translation_set: {
      "en-us": "Firesmith of Lava-Forging",
      "zh-cn": "熔岩锻铸的火匠",
      "zh-tw": "熔岩鍛鑄的火匠",
    },
    code: "FLF",
    colour: "#ae2328",
  },
  {
    id: "108_0",
    name: "Genius's Ultraremote Sensing Visor",
    set: "Genius of Brilliant Stars",
    type: "Cavern Relics",
    translation: {
      "en-us": "Genius's Ultraremote Sensing Visor",
      "zh-cn": "天才的超距遥感",
      "zh-tw": "天才的超距遙感",
    },
    translation_set: {
      "en-us": "Genius of Brilliant Stars",
      "zh-cn": "繁星璀璨的天才",
      "zh-tw": "繁星璀璨的天才",
    },
    code: "GBS",
    colour: "#03e5fa",
  },
  {
    id: "108_1",
    name: "Genius's Frequency Catcher",
    set: "Genius of Brilliant Stars",
    type: "Cavern Relics",
    translation: {
      "en-us": "Genius's Frequency Catcher",
      "zh-cn": "天才的频变捕手",
      "zh-tw": "天才的頻變捕手",
    },
    translation_set: {
      "en-us": "Genius of Brilliant Stars",
      "zh-cn": "繁星璀璨的天才",
      "zh-tw": "繁星璀璨的天才",
    },
    code: "GBS",
    colour: "#03e5fa",
  },
  {
    id: "108_2",
    name: "Genius's Metafield Suit",
    set: "Genius of Brilliant Stars",
    type: "Cavern Relics",
    translation: {
      "en-us": "Genius's Metafield Suit",
      "zh-cn": "天才的元域深潜",
      "zh-tw": "天才的元域深潛",
    },
    translation_set: {
      "en-us": "Genius of Brilliant Stars",
      "zh-cn": "繁星璀璨的天才",
      "zh-tw": "繁星璀璨的天才",
    },
    code: "GBS",
    colour: "#03e5fa",
  },
  {
    id: "108_3",
    name: "Genius's Gravity Walker",
    set: "Genius of Brilliant Stars",
    type: "Cavern Relics",
    translation: {
      "en-us": "Genius's Gravity Walker",
      "zh-cn": "天才的引力漫步",
      "zh-tw": "天才的引力漫步",
    },
    translation_set: {
      "en-us": "Genius of Brilliant Stars",
      "zh-cn": "繁星璀璨的天才",
      "zh-tw": "繁星璀璨的天才",
    },
    code: "GBS",
    colour: "#03e5fa",
  },
  {
    id: "109_0",
    name: "Band's Polarized Sunglasses",
    set: "Band of Sizzling Thunder",
    type: "Cavern Relics",
    translation: {
      "en-us": "Band's Polarized Sunglasses",
      "zh-cn": "乐队的偏光墨镜",
      "zh-tw": "樂隊的偏光墨鏡",
    },
    translation_set: {
      "en-us": "Band of Sizzling Thunder",
      "zh-cn": "激奏雷电的乐队",
      "zh-tw": "激奏雷電的樂隊",
    },
    code: "BST",
    colour: "#943ff0",
  },
  {
    id: "109_1",
    name: "Band's Touring Bracelet",
    set: "Band of Sizzling Thunder",
    type: "Cavern Relics",
    translation: {
      "en-us": "Band's Touring Bracelet",
      "zh-cn": "乐队的巡演手绳",
      "zh-tw": "樂隊的巡演手繩",
    },
    translation_set: {
      "en-us": "Band of Sizzling Thunder",
      "zh-cn": "激奏雷电的乐队",
      "zh-tw": "激奏雷電的樂隊",
    },
    code: "BST",
    colour: "#943ff0",
  },
  {
    id: "109_2",
    name: "Band's Leather Jacket With Studs",
    set: "Band of Sizzling Thunder",
    type: "Cavern Relics",
    translation: {
      "en-us": "Band's Leather Jacket With Studs",
      "zh-cn": "乐队的钉刺皮衣",
      "zh-tw": "樂隊的釘刺皮衣",
    },
    translation_set: {
      "en-us": "Band of Sizzling Thunder",
      "zh-cn": "激奏雷电的乐队",
      "zh-tw": "激奏雷電的樂隊",
    },
    code: "BST",
    colour: "#943ff0",
  },
  {
    id: "109_3",
    name: "Band's Ankle Boots With Rivets",
    set: "Band of Sizzling Thunder",
    type: "Cavern Relics",
    translation: {
      "en-us": "Band's Ankle Boots With Rivets",
      "zh-cn": "乐队的铆钉短靴",
      "zh-tw": "樂隊的鉚釘短靴",
    },
    translation_set: {
      "en-us": "Band of Sizzling Thunder",
      "zh-cn": "激奏雷电的乐队",
      "zh-tw": "激奏雷電的樂隊",
    },
    code: "BST",
    colour: "#943ff0",
  },
  {
    id: "110_0",
    name: "Eagle's Beaked Helmet",
    set: "Eagle of Twilight Line",
    type: "Cavern Relics",
    translation: {
      "en-us": "Eagle's Beaked Helmet",
      "zh-cn": "翔鹰的长喙头盔",
      "zh-tw": "翔鷹的長喙頭盔",
    },
    translation_set: {
      "en-us": "Eagle of Twilight Line",
      "zh-cn": "晨昏交界的翔鹰",
      "zh-tw": "晨昏交界的翔鷹",
    },
    code: "ETL",
    colour: "#535671",
  },
  {
    id: "110_1",
    name: "Eagle's Soaring Ring",
    set: "Eagle of Twilight Line",
    type: "Cavern Relics",
    translation: {
      "en-us": "Eagle's Soaring Ring",
      "zh-cn": "翔鹰的鹰击指环",
      "zh-tw": "翔鷹的鷹擊指環",
    },
    translation_set: {
      "en-us": "Eagle of Twilight Line",
      "zh-cn": "晨昏交界的翔鹰",
      "zh-tw": "晨昏交界的翔鷹",
    },
    code: "ETL",
    colour: "#535671",
  },
  {
    id: "110_2",
    name: "Eagle's Winged Suit Harness",
    set: "Eagle of Twilight Line",
    type: "Cavern Relics",
    translation: {
      "en-us": "Eagle's Winged Suit Harness",
      "zh-cn": "翔鹰的翼装束带",
      "zh-tw": "翔鷹的翼裝束帶",
    },
    translation_set: {
      "en-us": "Eagle of Twilight Line",
      "zh-cn": "晨昏交界的翔鹰",
      "zh-tw": "晨昏交界的翔鷹",
    },
    code: "ETL",
    colour: "#535671",
  },
  {
    id: "110_3",
    name: "Eagle's Quilted Puttees",
    set: "Eagle of Twilight Line",
    type: "Cavern Relics",
    translation: {
      "en-us": "Eagle's Quilted Puttees",
      "zh-cn": "翔鹰的绒羽绑带",
      "zh-tw": "翔鷹的絨羽綁帶",
    },
    translation_set: {
      "en-us": "Eagle of Twilight Line",
      "zh-cn": "晨昏交界的翔鹰",
      "zh-tw": "晨昏交界的翔鷹",
    },
    code: "ETL",
    colour: "#535671",
  },
  {
    id: "111_0",
    name: "Thief's Myriad-Faced Mask",
    set: "Thief of Shooting Meteor",
    type: "Cavern Relics",
    translation: {
      "en-us": "Thief's Myriad-Faced Mask",
      "zh-cn": "怪盗的千人假面",
      "zh-tw": "怪盜的千人假面",
    },
    translation_set: {
      "en-us": "Thief of Shooting Meteor",
      "zh-cn": "流星追迹的怪盗",
      "zh-tw": "流星追蹟的怪盜",
    },
    code: "TSM",
    colour: "#2a38ad",
  },
  {
    id: "111_1",
    name: "Thief's Gloves With Prints",
    set: "Thief of Shooting Meteor",
    type: "Cavern Relics",
    translation: {
      "en-us": "Thief's Gloves With Prints",
      "zh-cn": "怪盗的绘纹手套",
      "zh-tw": "怪盜的繪紋手套",
    },
    translation_set: {
      "en-us": "Thief of Shooting Meteor",
      "zh-cn": "流星追迹的怪盗",
      "zh-tw": "流星追蹟的怪盜",
    },
    code: "TSM",
    colour: "#2a38ad",
  },
  {
    id: "111_2",
    name: "Thief's Steel Grappling Hook",
    set: "Thief of Shooting Meteor",
    type: "Cavern Relics",
    translation: {
      "en-us": "Thief's Steel Grappling Hook",
      "zh-cn": "怪盗的纤钢爪钩",
      "zh-tw": "怪盜的纖鋼爪鉤",
    },
    translation_set: {
      "en-us": "Thief of Shooting Meteor",
      "zh-cn": "流星追迹的怪盗",
      "zh-tw": "流星追蹟的怪盜",
    },
    code: "TSM",
    colour: "#2a38ad",
  },
  {
    id: "111_3",
    name: "Thief's Meteor Boots",
    set: "Thief of Shooting Meteor",
    type: "Cavern Relics",
    translation: {
      "en-us": "Thief's Meteor Boots",
      "zh-cn": "怪盗的流星快靴",
      "zh-tw": "怪盜的流星快靴",
    },
    translation_set: {
      "en-us": "Thief of Shooting Meteor",
      "zh-cn": "流星追迹的怪盗",
      "zh-tw": "流星追蹟的怪盜",
    },
    code: "TSM",
    colour: "#2a38ad",
  },
  {
    id: "112_0",
    name: "Wastelander's Breathing Mask",
    set: "Wastelander of Banditry Desert",
    type: "Cavern Relics",
    translation: {
      "en-us": "Wastelander's Breathing Mask",
      "zh-cn": "废土客的呼吸面罩",
      "zh-tw": "廢土客的呼吸面罩",
    },
    translation_set: {
      "en-us": "Wastelander of Banditry Desert",
      "zh-cn": "盗匪荒漠的废土客",
      "zh-tw": "盜匪荒漠的廢土客",
    },
    code: "WBD",
    colour: "#977f71",
  },
  {
    id: "112_1",
    name: "Wastelander's Desert Terminal",
    set: "Wastelander of Banditry Desert",
    type: "Cavern Relics",
    translation: {
      "en-us": "Wastelander's Desert Terminal",
      "zh-cn": "废土客的荒漠终端",
      "zh-tw": "廢土客的荒漠終端",
    },
    translation_set: {
      "en-us": "Wastelander of Banditry Desert",
      "zh-cn": "盗匪荒漠的废土客",
      "zh-tw": "盜匪荒漠的廢土客",
    },
    code: "WBD",
    colour: "#977f71",
  },
  {
    id: "112_2",
    name: "Wastelander's Friar Robe",
    set: "Wastelander of Banditry Desert",
    type: "Cavern Relics",
    translation: {
      "en-us": "Wastelander's Friar Robe",
      "zh-cn": "废土客的修士长袍",
      "zh-tw": "廢土客的修士長袍",
    },
    translation_set: {
      "en-us": "Wastelander of Banditry Desert",
      "zh-cn": "盗匪荒漠的废土客",
      "zh-tw": "盜匪荒漠的廢土客",
    },
    code: "WBD",
    colour: "#977f71",
  },
  {
    id: "112_3",
    name: "Wastelander's Powered Greaves",
    set: "Wastelander of Banditry Desert",
    type: "Cavern Relics",
    translation: {
      "en-us": "Wastelander's Powered Greaves",
      "zh-cn": "废土客的动力腿甲",
      "zh-tw": "廢土客的動力腿甲",
    },
    translation_set: {
      "en-us": "Wastelander of Banditry Desert",
      "zh-cn": "盗匪荒漠的废土客",
      "zh-tw": "盜匪荒漠的廢土客",
    },
    code: "WBD",
    colour: "#977f71",
  },
  {
    id: "113_0",
    name: "Disciple's Prosthetic Eye",
    set: "Longevous Disciple",
    type: "Cavern Relics",
    translation: {
      "en-us": "Disciple's Prosthetic Eye",
      "zh-cn": "莳者的复明义眼",
      "zh-tw": "蒔者的複明義眼",
    },
    translation_set: {
      "en-us": "Longevous Disciple",
      "zh-cn": "宝命长存的莳者",
      "zh-tw": "寶命長存的蒔者",
    },
    code: "LD",
    colour: "#54848e",
  },
  {
    id: "113_1",
    name: "Disciple's Ingenium Hand",
    set: "Longevous Disciple",
    type: "Cavern Relics",
    translation: {
      "en-us": "Disciple's Ingenium Hand",
      "zh-cn": "莳者的机巧木手",
      "zh-tw": "蒔者的機巧木手",
    },
    translation_set: {
      "en-us": "Longevous Disciple",
      "zh-cn": "宝命长存的莳者",
      "zh-tw": "寶命長存的蒔者",
    },
    code: "LD",
    colour: "#54848e",
  },
  {
    id: "113_2",
    name: "Disciple's Dewy Feather Garb",
    set: "Longevous Disciple",
    type: "Cavern Relics",
    translation: {
      "en-us": "Disciple's Dewy Feather Garb",
      "zh-cn": "莳者的承露羽衣",
      "zh-tw": "蒔者的承露羽衣",
    },
    translation_set: {
      "en-us": "Longevous Disciple",
      "zh-cn": "宝命长存的莳者",
      "zh-tw": "寶命長存的蒔者",
    },
    code: "LD",
    colour: "#54848e",
  },
  {
    id: "113_3",
    name: "Disciple's Celestial Silk Sandals",
    set: "Longevous Disciple",
    type: "Cavern Relics",
    translation: {
      "en-us": "Disciple's Celestial Silk Sandals",
      "zh-cn": "莳者的天人丝履",
      "zh-tw": "蒔者的天人絲履",
    },
    translation_set: {
      "en-us": "Longevous Disciple",
      "zh-cn": "宝命长存的莳者",
      "zh-tw": "寶命長存的蒔者",
    },
    code: "LD",
    colour: "#54848e",
  },
  {
    id: "114_0",
    name: "Messenger's Holovisor",
    set: "Messenger Traversing Hackerspace",
    type: "Cavern Relics",
    translation: {
      "en-us": "Messenger's Holovisor",
      "zh-cn": "信使的全息目镜",
      "zh-tw": "信使的全息目鏡",
    },
    translation_set: {
      "en-us": "Messenger Traversing Hackerspace",
      "zh-cn": "骇域漫游的信使",
      "zh-tw": "駭域漫遊的信使",
    },
    code: "MTH",
    colour: "#54848e",
  },
  {
    id: "114_1",
    name: "Messenger's Transformative Arm",
    set: "Messenger Traversing Hackerspace",
    type: "Cavern Relics",
    translation: {
      "en-us": "Messenger's Transformative Arm",
      "zh-cn": "信使的百变义手",
      "zh-tw": "信使的百變義手",
    },
    translation_set: {
      "en-us": "Messenger Traversing Hackerspace",
      "zh-cn": "骇域漫游的信使",
      "zh-tw": "駭域漫遊的信使",
    },
    code: "MTH",
    colour: "#54848e",
  },
  {
    id: "114_2",
    name: "Messenger's Secret Satchel",
    set: "Messenger Traversing Hackerspace",
    type: "Cavern Relics",
    translation: {
      "en-us": "Messenger's Secret Satchel",
      "zh-cn": "信使的密信挎包",
      "zh-tw": "信使的密信挎包",
    },
    translation_set: {
      "en-us": "Messenger Traversing Hackerspace",
      "zh-cn": "骇域漫游的信使",
      "zh-tw": "駭域漫遊的信使",
    },
    code: "MTH",
    colour: "#54848e",
  },
  {
    id: "114_3",
    name: "Messenger's Par-kool Sneakers",
    set: "Messenger Traversing Hackerspace",
    type: "Cavern Relics",
    translation: {
      "en-us": "Messenger's Par-kool Sneakers",
      "zh-cn": "信使的酷跑板鞋",
      "zh-tw": "信使的酷跑板鞋",
    },
    translation_set: {
      "en-us": "Messenger Traversing Hackerspace",
      "zh-cn": "骇域漫游的信使",
      "zh-tw": "駭域漫遊的信使",
    },
    code: "MTH",
    colour: "#54848e",
  },

  {
    id: "115_0",
    name: "Grand Duke's Crown of Netherflame",
    set: "The Ashblazing Grand Duke",
    type: "Cavern Relics",
    translation: {
      "en-us": "Grand Duke's Crown of Netherflame",
      "zh-cn": "大公的冥焰冠冕",
      "zh-tw": "大公的冥焰冠冕",
    },
    translation_set: {
      "en-us": "The Ashblazing Grand Duke",
      "zh-cn": "毁烬焚骨的大公",
      "zh-tw": "毀燼焚骨的大公",
    },
    code: "AGD",
    colour: "#ECB811",
  },
  {
    id: "115_1",
    name: "Grand Duke's Gloves of Fieryfur",
    set: "The Ashblazing Grand Duke",
    type: "Cavern Relics",
    translation: {
      "en-us": "Grand Duke's Gloves of Fieryfur",
      "zh-cn": "大公的绒火指套",
      "zh-tw": "大公的絨火指套",
    },
    translation_set: {
      "en-us": "The Ashblazing Grand Duke",
      "zh-cn": "毁烬焚骨的大公",
      "zh-tw": "毀燼焚骨的大公",
    },
    code: "AGD",
    colour: "#ECB811",
  },
  {
    id: "115_2",
    name: "Grand Duke's Robe of Grace",
    set: "The Ashblazing Grand Duke",
    type: "Cavern Relics",
    translation: {
      "en-us": "Grand Duke's Robe of Grace",
      "zh-cn": "大公的蒙恩长袍",
      "zh-tw": "大公的蒙恩長袍",
    },
    translation_set: {
      "en-us": "The Ashblazing Grand Duke",
      "zh-cn": "毁烬焚骨的大公",
      "zh-tw": "毀燼焚骨的大公",
    },
    code: "AGD",
    colour: "#ECB811",
  },
  {
    id: "115_3",
    name: "Grand Duke's Ceremonial Boots",
    set: "The Ashblazing Grand Duke",
    type: "Cavern Relics",
    translation: {
      "en-us": "Grand Duke's Ceremonial Boots",
      "zh-cn": "大公的绅雅礼靴",
      "zh-tw": "大公的紳雅禮靴",
    },
    translation_set: {
      "en-us": "The Ashblazing Grand Duke",
      "zh-cn": "毁烬焚骨的大公",
      "zh-tw": "毀燼焚骨的大公",
    },
    code: "AGD",
    colour: "#ECB811",
  },

  {
    id: "116_0",
    name: "Prisoner's Sealed Muzzle",
    set: "Prisoner in Deep Confinement",
    type: "Cavern Relics",
    translation: {
      "en-us": "Prisoner's Sealed Muzzle",
      "zh-cn": "系囚的合啮拘笼",
      "zh-tw": "繫囚的合齧拘籠",
    },
    translation_set: {
      "en-us": "Prisoner in Deep Confinement",
      "zh-cn": "幽锁深牢的系囚",
      "zh-tw": "幽鎖深牢的繫囚",
    },
    code: "PDC",
    colour: "#7E9DA0",
  },

  {
    id: "116_1",
    name: "Prisoner's Leadstone Shackles",
    set: "Prisoner in Deep Confinement",
    type: "Cavern Relics",
    translation: {
      "en-us": "Prisoner's Leadstone Shackles",
      "zh-cn": "系囚的铅石梏铐",
      "zh-tw": "繫囚的鉛石梏銬",
    },
    translation_set: {
      "en-us": "Prisoner in Deep Confinement",
      "zh-cn": "幽锁深牢的系囚",
      "zh-tw": "幽鎖深牢的繫囚",
    },
    code: "PDC",
    colour: "#7E9DA0",
  },
  {
    id: "116_2",
    name: "Prisoner's Repressive Straitjacket",
    set: "Prisoner in Deep Confinement",
    type: "Cavern Relics",
    translation: {
      "en-us": "Prisoner's Repressive Straitjacket",
      "zh-cn": "系囚的幽闭缚束",
      "zh-tw": "繫囚的幽閉縛束",
    },
    translation_set: {
      "en-us": "Prisoner in Deep Confinement",
      "zh-cn": "幽锁深牢的系囚",
      "zh-tw": "幽鎖深牢的繫囚",
    },
    code: "PDC",
    colour: "#7E9DA0",
  },

  {
    id: "116_3",
    name: "Prisoner's Restrictive Fetters",
    set: "Prisoner in Deep Confinement",
    type: "Cavern Relics",
    translation: {
      "en-us": "Prisoner's Restrictive Fetters",
      "zh-cn": "系囚的绝足锁桎",
      "zh-tw": "繫囚的合齧拘籠",
    },
    translation_set: {
      "en-us": "Prisoner in Deep Confinement",
      "zh-cn": "幽锁深牢的系囚",
      "zh-tw": "繫囚的絕足鎖桎",
    },
    code: "PDC",
    colour: "#7E9DA0",
  },

  {
    id: "117_0",
    name: "Pioneer's Heatproof Shell",
    set: "Pioneer Diver of Dead Waters",
    type: "Cavern Relics",
    translation: {
      "en-us": "Pioneer's Heatproof Shell",
      "zh-cn": "先驱的绝热围壳",
      "zh-tw": "先驅的絕熱圍殼",
    },
    translation_set: {
      "en-us": "Pioneer Diver of Dead Waters",
      "zh-cn": "死水深潜的先驱",
      "zh-tw": "死水深潛的先驅",
    },
    code: "PDDW",
    colour: "#693c39",
  },

  {
    id: "117_1",
    name: "Pioneer's Lacuna Compass",
    set: "Pioneer Diver of Dead Waters",
    type: "Cavern Relics",
    translation: {
      "en-us": "Pioneer's Lacuna Compass",
      "zh-cn": "先驱的虚极罗盘",
      "zh-tw": "先驅的虛極羅盤",
    },
    translation_set: {
      "en-us": "Pioneer Diver of Dead Waters",
      "zh-cn": "死水深潜的先驱",
      "zh-tw": "死水深潛的先驅",
    },
    code: "PDDW",
    colour: "#693c39",
  },

  {
    id: "117_2",
    name: "Pioneer's Sealed Lead Apron",
    set: "Pioneer Diver of Dead Waters",
    type: "Cavern Relics",
    translation: {
      "en-us": "Pioneer's Sealed Lead Apron",
      "zh-cn": "先驱的密合铅衣",
      "zh-tw": "先驅的密合鉛衣",
    },
    translation_set: {
      "en-us": "Pioneer Diver of Dead Waters",
      "zh-cn": "死水深潜的先驱",
      "zh-tw": "死水深潛的先驅",
    },
    code: "PDDW",
    colour: "#693c39",
  },

  {
    id: "117_3",
    name: "Pioneer's Starfaring Anchor",
    set: "Pioneer Diver of Dead Waters",
    type: "Cavern Relics",
    translation: {
      "en-us": "Pioneer's Starfaring Anchor",
      "zh-cn": "先驱的泊星桩锚",
      "zh-tw": "先驅的泊星樁錨",
    },
    translation_set: {
      "en-us": "Pioneer Diver of Dead Waters",
      "zh-cn": "死水深潜的先驱",
      "zh-tw": "死水深潛的先驅",
    },
    code: "PDDW",
    colour: "#693c39",
  },

  {
    id: "118_0",
    name: "Watchmaker's Telescoping Lens",
    set: "Watchmaker, Master of Dream Machinations",
    type: "Cavern Relics",
    translation: {
      "en-us": "Watchmaker's Telescoping Lens",
      "zh-cn": "钟表匠的极目透镜",
      "zh-tw": "鐘錶匠的極目透鏡",
    },
    translation_set: {
      "en-us": "Watchmaker, Master of Dream Machinations",
      "zh-cn": "机心戏梦的钟表匠",
      "zh-tw": "機心戲夢的鐘錶匠",
    },
    code: "WMDM",
    colour: "#edd888",
  },

  {
    id: "118_1",
    name: "Watchmaker's Fortuitous Wristwatch",
    set: "Watchmaker, Master of Dream Machinations",
    type: "Cavern Relics",
    translation: {
      "en-us": "Watchmaker's Fortuitous Wristwatch",
      "zh-cn": "钟表匠的交运腕表",
      "zh-tw": "鐘錶匠的交運腕錶",
    },
    translation_set: {
      "en-us": "Watchmaker, Master of Dream Machinations",
      "zh-cn": "机心戏梦的钟表匠",
      "zh-tw": "機心戲夢的鐘錶匠",
    },
    code: "WMDM",
    colour: "#edd888",
  },

  {
    id: "118_2",
    name: "Watchmaker's Illusory Formal Suit",
    set: "Watchmaker, Master of Dream Machinations",
    type: "Cavern Relics",
    translation: {
      "en-us": "Watchmaker's Illusory Formal Suit",
      "zh-cn": "钟表匠的空幻礼服",
      "zh-tw": "鐘錶匠的空幻禮服",
    },
    translation_set: {
      "en-us": "Watchmaker, Master of Dream Machinations",
      "zh-cn": "机心戏梦的钟表匠",
      "zh-tw": "機心戲夢的鐘錶匠",
    },
    code: "WMDM",
    colour: "#edd888",
  },

  {
    id: "118_3",
    name: "Watchmaker's Dream-Concealing Dress Shoes",
    set: "Watchmaker, Master of Dream Machinations",
    type: "Cavern Relics",
    translation: {
      "en-us": "Watchmaker's Dream-Concealing Dress Shoes",
      "zh-cn": "钟表匠的隐梦革履",
      "zh-tw": "鐘錶匠的隱夢革履",
    },
    translation_set: {
      "en-us": "Watchmaker, Master of Dream Machinations",
      "zh-cn": "机心戏梦的钟表匠",
      "zh-tw": "機心戲夢的鐘錶匠",
    },
    code: "WMDM",
    colour: "#edd888",
  },
  {
    id: "119_0",
    name: "Iron Cavalry’s Homing Helm",
    set: "Iron Cavalry Against the Scourge",
    type: "Cavern Relics",
    translation: {
      "en-us": "Iron Cavalry’s Homing Helm",
      "zh-cn": "铁骑的索敌战盔",
      "zh-tw": "鐵騎的索敵戰盔",
    },
    translation_set: {
      "en-us": "Iron Cavalry Against the Scourge",
      "zh-cn": "荡除蠹灾的铁骑",
      "zh-tw": "蕩除蠹災的鐵騎",
    },
    code: "ICAS",
    colour: "#a9acb9",
  },
  {
    id: "119_1",
    name: "Iron Cavalry’s Crushing Wristguard",
    set: "Iron Cavalry Against the Scourge",
    type: "Cavern Relics",
    translation: {
      "en-us": "Iron Cavalry’s Crushing Wristguard",
      "zh-cn": "铁骑的摧坚铁腕",
      "zh-tw": "鐵騎的摧堅鐵腕",
    },
    translation_set: {
      "en-us": "Iron Cavalry Against the Scourge",
      "zh-cn": "荡除蠹灾的铁骑",
      "zh-tw": "蕩除蠹災的鐵騎",
    },
    code: "ICAS",
    colour: "#a9acb9",
  },

  {
    id: "119_2",
    name: "Iron Cavalry’s Silvery Armor",
    set: "Iron Cavalry Against the Scourge",
    type: "Cavern Relics",
    translation: {
      "en-us": "Iron Cavalry’s Silvery Armor",
      "zh-cn": "铁骑的银影装甲",
      "zh-tw": "鐵騎的銀影裝甲",
    },
    translation_set: {
      "en-us": "Iron Cavalry Against the Scourge",
      "zh-cn": "荡除蠹灾的铁骑",
      "zh-tw": "蕩除蠹災的鐵騎",
    },
    code: "ICAS",
    colour: "#a9acb9",
  },

  {
    id: "119_3",
    name: "Iron Cavalry’s Skywalk Greaves",
    set: "Iron Cavalry Against the Scourge",
    type: "Cavern Relics",
    translation: {
      "en-us": "Iron Cavalry’s Skywalk Greaves",
      "zh-cn": "铁骑的行空护胫",
      "zh-tw": "鐵騎的行空護脛",
    },
    translation_set: {
      "en-us": "Iron Cavalry Against the Scourge",
      "zh-cn": "荡除蠹灾的铁骑",
      "zh-tw": "蕩除蠹災的鐵騎",
    },
    code: "ICAS",
    colour: "#a9acb9",
  },

  {
    id: "120_0",
    name: "Valorous Mask of Northern Skies",
    set: "The Wind-Soaring Valorous",
    type: "Cavern Relics",
    translation: {
      "en-us": "Valorous Mask of Northern Skies",
      "zh-cn": "勇烈的玄枵面甲",
      "zh-tw": "勇烈的玄枵面甲",
    },
    translation_set: {
      "en-us": "The Wind-Soaring Valorous",
      "zh-cn": "风举云飞的勇烈",
      "zh-tw": "風舉雲飛的勇烈",
    },
    code: "TWSV",
    colour: "#50d6f0",
  },

  {
    id: "120_1",
    name: "Valorous Bracelet of Grappling Hooks",
    set: "The Wind-Soaring Valorous",
    type: "Cavern Relics",
    translation: {
      "en-us": "Valorous Bracelet of Grappling Hooks",
      "zh-cn": "勇烈的钩爪腕甲",
      "zh-tw": "勇烈的鉤爪腕甲",
    },
    translation_set: {
      "en-us": "The Wind-Soaring Valorous",
      "zh-cn": "风举云飞的勇烈",
      "zh-tw": "風舉雲飛的勇烈",
    },
    code: "TWSV",
    colour: "#50d6f0",
  },

  {
    id: "120_2",
    name: "Valorous Plate of Soaring Flight",
    set: "The Wind-Soaring Valorous",
    type: "Cavern Relics",
    translation: {
      "en-us": "Valorous Plate of Soaring Flight",
      "zh-cn": "勇烈的飞翎瓷甲",
      "zh-tw": "勇烈的鉤爪腕甲",
    },
    translation_set: {
      "en-us": "The Wind-Soaring Valorous",
      "zh-cn": "风举云飞的勇烈",
      "zh-tw": "勇烈的飛翎瓷甲",
    },
    code: "TWSV",
    colour: "#50d6f0",
  },

  {
    id: "120_3",
    name: "Valorous Greaves of Pursuing Hunt",
    set: "The Wind-Soaring Valorous",
    type: "Cavern Relics",
    translation: {
      "en-us": "Valorous Greaves of Pursuing Hunt",
      "zh-cn": "勇烈的逐猎腿甲",
      "zh-tw": "勇烈的逐獵腿甲",
    },
    translation_set: {
      "en-us": "The Wind-Soaring Valorous",
      "zh-cn": "风举云飞的勇烈",
      "zh-tw": "勇烈的飛翎瓷甲",
    },
    code: "TWSV",
    colour: "#50d6f0",
  },

  {
    id: "120_0",
    name: "Valorous Mask of Northern Skies",
    set: "The Wind-Soaring Valorous",
    type: "Cavern Relics",
    translation: {
      "en-us": "Valorous Mask of Northern Skies",
      "zh-cn": "勇烈的玄枵面甲",
      "zh-tw": "勇烈的玄枵面甲",
    },
    translation_set: {
      "en-us": "The Wind-Soaring Valorous",
      "zh-cn": "风举云飞的勇烈",
      "zh-tw": "風舉雲飛的勇烈",
    },
    code: "TWSV",
    colour: "#50d6f0",
  },

  {
    id: "120_1",
    name: "Valorous Bracelet of Grappling Hooks",
    set: "The Wind-Soaring Valorous",
    type: "Cavern Relics",
    translation: {
      "en-us": "Valorous Bracelet of Grappling Hooks",
      "zh-cn": "勇烈的钩爪腕甲",
      "zh-tw": "勇烈的鉤爪腕甲",
    },
    translation_set: {
      "en-us": "The Wind-Soaring Valorous",
      "zh-cn": "风举云飞的勇烈",
      "zh-tw": "風舉雲飛的勇烈",
    },
    code: "TWSV",
    colour: "#50d6f0",
  },

  {
    id: "120_2",
    name: "Valorous Plate of Soaring Flight",
    set: "The Wind-Soaring Valorous",
    type: "Cavern Relics",
    translation: {
      "en-us": "Valorous Plate of Soaring Flight",
      "zh-cn": "勇烈的飞翎瓷甲",
      "zh-tw": "勇烈的鉤爪腕甲",
    },
    translation_set: {
      "en-us": "The Wind-Soaring Valorous",
      "zh-cn": "风举云飞的勇烈",
      "zh-tw": "勇烈的飛翎瓷甲",
    },
    code: "TWSV",
    colour: "#50d6f0",
  },

  {
    id: "120_3",
    name: "Valorous Greaves of Pursuing Hunt",
    set: "The Wind-Soaring Valorous",
    type: "Cavern Relics",
    translation: {
      "en-us": "Valorous Greaves of Pursuing Hunt",
      "zh-cn": "勇烈的逐猎腿甲",
      "zh-tw": "勇烈的逐獵腿甲",
    },
    translation_set: {
      "en-us": "The Wind-Soaring Valorous",
      "zh-cn": "风举云飞的勇烈",
      "zh-tw": "勇烈的飛翎瓷甲",
    },
    code: "TWSV",
    colour: "#50d6f0",
  },

  {
    id: "121_0",
    name: "Sacerdos' Melodic Earrings",
    set: "Sacerdos' Relived Ordeal",
    type: "Cavern Relics",
    translation: {
      "en-us": "Sacerdos' Melodic Earrings",
      "zh-cn": "司铎的律音耳坠",
      "zh-tw": "司鐸的律音耳墜",
    },
    translation_set: {
      "en-us": "Sacerdos' Relived Ordeal",
      "zh-cn": "重循苦旅的司铎",
      "zh-tw": "重循苦旅的司鐸",
    },
    code: "SRO",
    colour: "#6685d1",
  },
  {
    id: "121_1",
    name: "Sacerdos' Welcoming Gloves",
    set: "Sacerdos' Relived Ordeal",
    type: "Cavern Relics",
    translation: {
      "en-us": "Sacerdos' Welcoming Gloves",
      "zh-cn": "司铎的授邀手套",
      "zh-tw": "司鐸的授邀手套",
    },
    translation_set: {
      "en-us": "Sacerdos' Relived Ordeal",
      "zh-cn": "重循苦旅的司铎",
      "zh-tw": "重循苦旅的司鐸",
    },
    code: "SRO",
    colour: "#6685d1",
  },
  {
    id: "121_2",
    name: "Sacerdos' Ceremonial Garb",
    set: "Sacerdos' Relived Ordeal",
    type: "Cavern Relics",
    translation: {
      "en-us": "Sacerdos' Ceremonial Garb",
      "zh-cn": "司铎的圣职礼服",
      "zh-tw": "司鐸的聖職禮服",
    },
    translation_set: {
      "en-us": "Sacerdos' Relived Ordeal",
      "zh-cn": "重循苦旅的司铎",
      "zh-tw": "重循苦旅的司鐸",
    },
    code: "SRO",
    colour: "#6685d1",
  },
  {
    id: "121_3",
    name: "Sacerdos' Arduous Boots",
    set: "Sacerdos' Relived Ordeal",
    type: "Cavern Relics",
    translation: {
      "en-us": "Sacerdos' Arduous Boots",
      "zh-cn": "司铎的苦旅短靴",
      "zh-tw": "司鐸的苦旅短靴",
    },
    translation_set: {
      "en-us": "Sacerdos' Relived Ordeal",
      "zh-cn": "重循苦旅的司铎",
      "zh-tw": "重循苦旅的司鐸",
    },
    code: "SRO",
    colour: "#6685d1",
  },

  {
    id: "122_0",
    name: "Scholar's Silver-Rimmed Monocle",
    set: "Scholar Lost in Erudition",
    type: "Cavern Relics",
    translation: {
      "en-us": "Scholar's Silver-Rimmed Monocle",
      "zh-cn": "学者的银边视镜",
      "zh-tw": "學者的銀邊視鏡",
    },
    translation_set: {
      "en-us": "Scholar Lost in Erudition",
      "zh-cn": "识海迷坠的学者",
      "zh-tw": "識海迷墜的學者",
    },
    code: "SLE",
    colour: "#5e46c0",
  },
  {
    id: "122_1",
    name: "Scholar's Auxiliary Knuckle",
    set: "Scholar Lost in Erudition",
    type: "Cavern Relics",
    translation: {
      "en-us": "Scholar's Auxiliary Knuckle",
      "zh-cn": "学者的辅助指节",
      "zh-tw": "學者的輔助指節",
    },
    translation_set: {
      "en-us": "Scholar Lost in Erudition",
      "zh-cn": "识海迷坠的学者",
      "zh-tw": "識海迷墜的學者",
    },
    code: "SLE",
    colour: "#5e46c0",
  },
  {
    id: "122_2",
    name: "Scholar's Tweed Jacket",
    set: "Scholar Lost in Erudition",
    type: "Cavern Relics",
    translation: {
      "en-us": "Scholar's Tweed Jacket",
      "zh-cn": "学者的粗纺外套",
      "zh-tw": "學者的粗紡外套",
    },
    translation_set: {
      "en-us": "Scholar Lost in Erudition",
      "zh-cn": "识海迷坠的学者",
      "zh-tw": "識海迷墜的學者",
    },
    code: "SLE",
    colour: "#5e46c0",
  },

  {
    id: "122_3",
    name: "Scholar's Felt Snowboots",
    set: "Scholar Lost in Erudition",
    type: "Cavern Relics",
    translation: {
      "en-us": "Scholar's Felt Snowboots",
      "zh-cn": "学者的绒皮雪靴",
      "zh-tw": "學者的絨皮雪靴",
    },
    translation_set: {
      "en-us": "Scholar Lost in Erudition",
      "zh-cn": "识海迷坠的学者",
      "zh-tw": "識海迷墜的學者",
    },
    code: "SLE",
    colour: "#5e46c0",
  },
  {
    id: "123_0",
    name: "Hero's Wreath of Championship",
    set: "Hero of Triumphant Song",
    type: "Cavern Relics",
    translation: {
      "en-us": "Hero's Wreath of Championship",
      "zh-cn": "英豪的冠军桂冠",
      "zh-tw": "英豪的冠軍桂冠",
    },
    translation_set: {
      "en-us": "Hero of Triumphant Song",
      "zh-cn": "凯歌祝捷的英豪",
      "zh-tw": "凱歌祝捷的英豪",
    },
    code: "HTS",
    colour: "#d6ba6d",
  },
  {
    id: "123_1",
    name: "Hero's Gilded Bracers",
    set: "Hero of Triumphant Song",
    type: "Cavern Relics",
    translation: {
      "en-us": "Hero's Gilded Bracers",
      "zh-cn": "英豪的鉴金腕铠",
      "zh-tw": "英豪的鉴金腕铠",
    },
    translation_set: {
      "en-us": "Hero of Triumphant Song",
      "zh-cn": "凯歌祝捷的英豪",
      "zh-tw": "凱歌祝捷的英豪",
    },
    code: "HTS",
    colour: "#d6ba6d",
  },
  {
    id: "123_2",
    name: "Hero's Gallant Golden Armor",
    set: "Hero of Triumphant Song",
    type: "Cavern Relics",
    translation: {
      "en-us": "Hero's Gallant Golden Armor",
      "zh-cn": "英豪的骁战金甲",
      "zh-tw": "英豪的骁战金甲",
    },
    translation_set: {
      "en-us": "Hero of Triumphant Song",
      "zh-cn": "凯歌祝捷的英豪",
      "zh-tw": "凱歌祝捷的英豪",
    },
    code: "HTS",
    colour: "#d6ba6d",
  },

  {
    id: "123_3",
    name: "Hero's Firechasing Shinguard",
    set: "Hero of Triumphant Song",
    type: "Cavern Relics",
    translation: {
      "en-us": "Hero's Firechasing Shinguard",
      "zh-cn": "英豪的赴火护胫",
      "zh-tw": "	英豪的赴火护胫",
    },
    translation_set: {
      "en-us": "Hero of Triumphant Song",
      "zh-cn": "凯歌祝捷的英豪",
      "zh-tw": "凱歌祝捷的英豪",
    },
    code: "HTS",
    colour: "#d6ba6d",
  },
  {
    id: "124_0",
    name: "Poet’s Dill Wreath",
    set: "Poet of Mourning Collapse",
    type: "Cavern Relics",
    translation: {
      "en-us": "Poet’s Dill Wreath",
      "zh-cn": "诗人的莳萝花冠",
      "zh-tw": "詩人的蒔蘿花冠",
    },
    translation_set: {
      "en-us": "Poet of Mourning Collapse",
      "zh-cn": "哀歌覆国的诗人",
      "zh-tw": "哀歌覆國的詩人",
    },
    code: "PMC",
    colour: "#e4c969",
  },
  {
    id: "124_1",
    name: "Poet’s Gilded Bracelet",
    set: "Poet of Mourning Collapse",
    type: "Cavern Relics",
    translation: {
      "en-us": "Poet’s Gilded Bracelet",
      "zh-cn": "诗人的贵金手镯",
      "zh-tw": "詩人的貴金手鐲",
    },
    translation_set: {
      "en-us": "Poet of Mourning Collapse",
      "zh-cn": "哀歌覆国的诗人",
      "zh-tw": "哀歌覆國的詩人",
    },
    code: "PMC",
    colour: "#e4c969",
  },
  {
    id: "124_2",
    name: "Poet’s Star-Studded Skirt",
    set: "Poet of Mourning Collapse",
    type: "Cavern Relics",
    translation: {
      "en-us": "Poet’s Star-Studded Skirt",
      "zh-cn": "诗人的缀星裙摆",
      "zh-tw": "詩人的綴星裙襬",
    },
    translation_set: {
      "en-us": "Poet of Mourning Collapse",
      "zh-cn": "哀歌覆国的诗人",
      "zh-tw": "哀歌覆國的詩人",
    },
    code: "PMC",
    colour: "#e4c969",
  },
  {
    id: "124_3",
    name: "Poet’s Silver-Studded Shoes",
    set: "Poet of Mourning Collapse",
    type: "Cavern Relics",
    translation: {
      "en-us": "Poet’s Silver-Studded Shoes",
      "zh-cn": "诗人的钉银之履",
      "zh-tw": "詩人的釘銀之履",
    },
    translation_set: {
      "en-us": "Poet of Mourning Collapse",
      "zh-cn": "哀歌覆国的诗人",
      "zh-tw": "哀歌覆國的詩人",
    },
    code: "PMC",
    colour: "#e4c969",
  },
  {
    id: "125_0",
    name: "Warrior Goddess's Winged Helm",
    set: "Warrior Goddess of Sun and Thunder",
    type: "Cavern Relics",
    translation: {
      "en-us": "Warrior Goddess's Winged Helm",
      "zh-cn": "女武神的翱翔翼盔",
      "zh-tw": "女武神的翱翔翼盔",
    },
    translation_set: {
      "en-us": "Warrior Goddess of Sun and Thunder",
      "zh-cn": "烈阳惊雷的女武神",
      "zh-tw": "烈陽驚雷的女武神",
    },
    code: "WGST",
    colour: "#b4b5b0",
  },
  {
    id: "125_1",
    name: "Warrior Goddess's Cavalry Gauntlets",
    set: "Warrior Goddess of Sun and Thunder",
    type: "Cavern Relics",
    translation: {
      "en-us": "Warrior Goddess's Cavalry Gauntlets",
      "zh-cn": "女武神的骑枪手铠",
      "zh-tw": "女武神的騎槍手鎧",
    },
    translation_set: {
      "en-us": "Warrior Goddess of Sun and Thunder",
      "zh-cn": "烈阳惊雷的女武神",
      "zh-tw": "烈陽驚雷的女武神",
    },
    code: "WGST",
    colour: "#b4b5b0",
  },
  {
    id: "125_2",
    name: "Warrior Goddess's Dawn Cape",
    set: "Warrior Goddess of Sun and Thunder",
    type: "Cavern Relics",
    translation: {
      "en-us": "Warrior Goddess's Dawn Cape",
      "zh-cn": "女武神的启程披风",
      "zh-tw": "女武神的啟程披風",
    },
    translation_set: {
      "en-us": "Warrior Goddess of Sun and Thunder",
      "zh-cn": "烈阳惊雷的女武神",
      "zh-tw": "烈陽驚雷的女武神",
    },
    code: "WGST",
    colour: "#b4b5b0",
  },
  {
    id: "125_3",
    name: "Warrior Goddess's Honor Spurs",
    set: "Warrior Goddess of Sun and Thunder",
    type: "Cavern Relics",
    translation: {
      "en-us": "Warrior Goddess's Honor Spurs",
      "zh-cn": "女武神的勋礼马刺",
      "zh-tw": "女武神的勳禮馬刺",
    },
    translation_set: {
      "en-us": "Warrior Goddess of Sun and Thunder",
      "zh-cn": "烈阳惊雷的女武神",
      "zh-tw": "烈陽驚雷的女武神",
    },
    code: "WGST",
    colour: "#b4b5b0",
  },
  {
    id: "126_0",
    name: "Captain's Navigator Hat",
    set: "Wavestrider Captain",
    type: "Cavern Relics",
    translation: {
      "en-us": "Captain's Navigator Hat",
      "zh-cn": "船长的领航笠帽",
      "zh-tw": "船長的領航笠帽",
    },
    translation_set: {
      "en-us": "Wavestrider Captain",
      "zh-cn": "恶海逐波的船长",
      "zh-tw": "惡海逐波的船長",
    },
    code: "WC",
    colour: "#fff842",
  },
  {
    id: "126_1",
    name: "Captain's Lightcatcher Astrolabe",
    set: "Wavestrider Captain",
    type: "Cavern Relics",
    translation: {
      "en-us": "Captain's Lightcatcher Astrolabe",
      "zh-cn": "船长的捕光星盘",
      "zh-tw": "船長的捕光星盤",
    },
    translation_set: {
      "en-us": "Wavestrider Captain",
      "zh-cn": "恶海逐波的船长",
      "zh-tw": "惡海逐波的船長",
    },
    code: "WC",
    colour: "#fff842",
  },
  {
    id: "126_2",
    name: "Captain's Wind Mantle",
    set: "Wavestrider Captain",
    type: "Cavern Relics",
    translation: {
      "en-us": "Captain's Wind Mantle",
      "zh-cn": "船长的驭风斗篷",
      "zh-tw": "船長的馭風斗篷",
    },
    translation_set: {
      "en-us": "Wavestrider Captain",
      "zh-cn": "恶海逐波的船长",
      "zh-tw": "惡海逐波的船長",
    },
    code: "WC",
    colour: "#fff842",
  },
  {
    id: "126_3",
    name: "Captain's Tidal Boots",
    set: "Wavestrider Captain",
    type: "Cavern Relics",
    translation: {
      "en-us": "Captain's Wind Mantle",
      "zh-cn": "船长的踏浪游靴",
      "zh-tw": "船長的踏浪遊靴",
    },
    translation_set: {
      "en-us": "Wavestrider Captain",
      "zh-cn": "恶海逐波的船长",
      "zh-tw": "惡海逐波的船長",
    },
    code: "WC",
    colour: "#fff842",
  },
  {
    id: "127_0",
    name: "Deliverer's Hood",
    set: "World-Remaking Deliverer",
    type: "Cavern Relics",
    translation: {
      "en-us": "Deliverer's Hood",
      "zh-cn": "救世主的登程风帽",
      "zh-tw": "救世主的登程風帽",
    },
    translation_set: {
      "en-us": "World-Remaking Deliverer",
      "zh-cn": "再创天地的救世主",
      "zh-tw": "再創天地的救世主",
    },
    code: "WRD",
    colour: "#d49202ff",
  },
  {
    id: "127_1",
    name: "Deliverer's Sword Gauntlet",
    set: "World-Remaking Deliverer",
    type: "Cavern Relics",
    translation: {
      "en-us": "Deliverer's Sword Gauntlet",
      "zh-cn": "救世主的执剑护手",
      "zh-tw": "救世主的執劍護手",
    },
    translation_set: {
      "en-us": "World-Remaking Deliverer",
      "zh-cn": "再创天地的救世主",
      "zh-tw": "再創天地的救世主",
    },
    code: "WRD",
    colour: "#d49202ff",
  },
  {
    id: "127_2",
    name: "Deliverer's Robe of Legacy",
    set: "World-Remaking Deliverer",
    type: "Cavern Relics",
    translation: {
      "en-us": "Deliverer's Robe of Legacy",
      "zh-cn": "救世主的传承战袍",
      "zh-tw": "救世主的傳承戰袍",
    },
    translation_set: {
      "en-us": "World-Remaking Deliverer",
      "zh-cn": "再创天地的救世主",
      "zh-tw": "再創天地的救世主",
    },
    code: "WRD",
    colour: "#d49202ff",
  },
  {
    id: "127_3",
    name: "Deliverer's Boots of Pioneering",
    set: "World-Remaking Deliverer",
    type: "Cavern Relics",
    translation: {
      "en-us": "Deliverer's Boots of Pioneering",
      "zh-cn": "救世主的拓荒长靴",
      "zh-tw": "救世主的拓荒長靴",
    },
    translation_set: {
      "en-us": "World-Remaking Deliverer",
      "zh-cn": "再创天地的救世主",
      "zh-tw": "再創天地的救世主",
    },
    code: "WRD",
    colour: "#d49202ff",
  },
  {
    id: "128_0",
    name: "Recluse's Wide-Brimmed Fedora",
    set: "Self-Enshrouded Recluse",
    type: "Cavern Relics",
    translation: {
      "en-us": "Recluse's Wide-Brimmed Fedora",
      "zh-cn": "隐士的宽檐呢帽",
      "zh-tw": "隱士的寬簷呢帽",
    },
    translation_set: {
      "en-us": "Self-Enshrouded Recluse",
      "zh-cn": "自匿星芒的隐士",
      "zh-tw": "自匿星芒的隱士",
    },
    code: "SER",
    colour: "#6e4b00ff",
  },
  {
    id: "128_1",
    name: "Recluse's Refined Timepiece",
    set: "Self-Enshrouded Recluse",
    type: "Cavern Relics",
    translation: {
      "en-us": "Recluse's Refined Timepiece",
      "zh-cn": "隐士的简雅腕表",
      "zh-tw": "隱士的簡雅腕錶",
    },
    translation_set: {
      "en-us": "Self-Enshrouded Recluse",
      "zh-cn": "自匿星芒的隐士",
      "zh-tw": "自匿星芒的隱士",
    },
    code: "SER",
    colour: "#6e4b00ff",
  },
  {
    id: "128_2",
    name: "Recluse's Camel-Colored Coat",
    set: "Self-Enshrouded Recluse",
    type: "Cavern Relics",
    translation: {
      "en-us": "Recluse's Camel-Colored Coat",
      "zh-cn": "隐士的驼色夹克",
      "zh-tw": "隱士的駝色夾克",
    },
    translation_set: {
      "en-us": "Self-Enshrouded Recluse",
      "zh-cn": "自匿星芒的隐士",
      "zh-tw": "自匿星芒的隱士",
    },
    code: "SER",
    colour: "#6e4b00ff",
  },
  {
    id: "128_3",
    name: "Recluse's Soft Suede Boots",
    set: "Self-Enshrouded Recluse",
    type: "Cavern Relics",
    translation: {
      "en-us": "Recluse's Soft Suede Boots",
      "zh-cn": "隐士的麂皮软鞋",
      "zh-tw": "隱士的麂皮軟鞋",
    },
    translation_set: {
      "en-us": "Self-Enshrouded Recluse",
      "zh-cn": "自匿星芒的隐士",
      "zh-tw": "自匿星芒的隱士",
    },
    code: "SER",
    colour: "#6e4b00ff",
  },
  {
    id: "129_0",
    name: "Magical Girl's Shining Medal",
    set: "Ever-Glorious Magical Girl",
    type: "Cavern Relics",
    translation: {
      "en-us": "Magical Girl's Shining Medal",
      "zh-cn": "魔法少女的闪耀勋章",
      "zh-tw": "魔法少女的閃耀勳章",
    },
    translation_set: {
      "en-us": "Ever-Glorious Magical Girl",
      "zh-cn": "闪耀功勋的魔法少女",
      "zh-tw": "功勳閃耀的魔法少女",
    },
    code: "EGMG",
    colour: "rgb(255, 0, 21)",
  },
  {
    id: "129_1",
    name: "Magical Girl's Protective Gloves",
    set: "Ever-Glorious Magical Girl",
    type: "Cavern Relics",
    translation: {
      "en-us": "Magical Girl's Protective Gloves",
      "zh-cn": "魔法少女的守护手套",
      "zh-tw": "魔法少女的守護手套",
    },
    translation_set: {
      "en-us": "Ever-Glorious Magical Girl",
      "zh-cn": "闪耀功勋的魔法少女",
      "zh-tw": "功勳閃耀的魔法少女",
    },
    code: "EGMG",
    colour: "rgb(255, 0, 21)",
  },
  {
    id: "129_2",
    name: "Magical Girl's Everdance Battle Skirt",
    set: "Ever-Glorious Magical Girl",
    type: "Cavern Relics",
    translation: {
      "en-us": "Magical Girl's Everdance Battle Skirt",
      "zh-cn": "魔法少女的永舞战裙",
      "zh-tw": "魔法少女的永舞戰裙",
    },
    translation_set: {
      "en-us": "Ever-Glorious Magical Girl",
      "zh-cn": "闪耀功勋的魔法少女",
      "zh-tw": "功勳閃耀的魔法少女",
    },
    code: "EGMG",
    colour: "rgb(255, 0, 21)",
  },
  {
    id: "129_3",
    name: "Magical Girl's Contract Boots",
    set: "Ever-Glorious Magical Girl",
    type: "Cavern Relics",
    translation: {
      "en-us": "Magical Girl's Contract Boots",
      "zh-cn": "魔法少女的缔约长靴",
      "zh-tw": "魔法少女的締約長靴",
    },
    translation_set: {
      "en-us": "Ever-Glorious Magical Girl",
      "zh-cn": "闪耀功勋的魔法少女",
      "zh-tw": "功勳閃耀的魔法少女",
    },
    code: "EGMG",
    colour: "rgb(255, 0, 21)",
  },
  {
    id: "130_0",
    name: "Diviner's Extrapolation Jade Abacus",
    set: "Diviner of Distant Reach",
    type: "Cavern Relics",
    translation: {
      "en-us": "Diviner's Extrapolation Jade Abacus",
      "zh-cn": "卜者的演算玉兆",
      "zh-tw": "卜者的演算玉兆",
    },
    translation_set: {
      "en-us": "Diviner of Distant Reach",
      "zh-cn": "应天涉远的卜者",
      "zh-tw": "應天涉遠的卜者",
    },
    code: "DDR",
    colour: "rgb(0, 77, 90)",
  },
  {
    id: "130_1",
    name: "Diviner's Ingenium Prosthetic Hand",
    set: "Diviner of Distant Reach",
    type: "Cavern Relics",
    translation: {
      "en-us": "Diviner's Ingenium Prosthetic Hand",
      "zh-cn": "卜者的机巧义手",
      "zh-tw": "卜者的機巧義手",
    },
    translation_set: {
      "en-us": "Diviner of Distant Reach",
      "zh-cn": "应天涉远的卜者",
      "zh-tw": "應天涉遠的卜者",
    },
    code: "DDR",
    colour: "rgb(0, 77, 90)",
  },
  {
    id: "130_2",
    name: "Diviner's Astral Robe",
    set: "Diviner of Distant Reach",
    type: "Cavern Relics",
    translation: {
      "en-us": "Diviner's Astral Robe",
      "zh-cn": "卜者的观天星袍",
      "zh-tw": "卜者的觀天星袍",
    },
    translation_set: {
      "en-us": "Diviner of Distant Reach",
      "zh-cn": "应天涉远的卜者",
      "zh-tw": "應天涉遠的卜者",
    },
    code: "DDR",
    colour: "rgb(0, 77, 90)",
  },
  {
    id: "130_3",
    name: "Diviner's Cloud-Soaring Boots",
    set: "Diviner of Distant Reach",
    type: "Cavern Relics",
    translation: {
      "en-us": "Diviner's Astral Robe",
      "zh-cn": "卜者的飞腾云履",
      "zh-tw": "卜者的飛騰雲履",
    },
    translation_set: {
      "en-us": "Diviner of Distant Reach",
      "zh-cn": "应天涉远的卜者",
      "zh-tw": "應天涉遠的卜者",
    },
    code: "DDR",
    colour: "rgb(0, 77, 90)",
  },
  {
    id: "132_0",
    name: "Smith's Fire Beast Mask",
    set: "Divine-Querying Master Smith",
    type: "Cavern Relics",
    translation: {
      "en-us": "Smith's Fire Beast Mask",
      "zh-cn": "名冶的火兽面罩",
      "zh-tw": "名冶的火獸面罩",
    },
    translation_set: {
      "en-us": "Divine-Querying Master Smith",
      "zh-cn": "叩问天工的名冶",
      "zh-tw": "叩問天工的名冶",
    },
    code: "DQMS",
    colour: "rgb(255, 0, 0)",
  },
  {
    id: "132_1",
    name: "Smith's Damascus Steel Gauntlets",
    set: "Divine-Querying Master Smith",
    type: "Cavern Relics",
    translation: {
      "en-us": "Smith's Damascus Steel Gauntlets",
      "zh-cn": "名冶的镔铁护手",
      "zh-tw": "名冶的鑌鐵護手",
    },
    translation_set: {
      "en-us": "Divine-Querying Master Smith",
      "zh-cn": "叩问天工的名冶",
      "zh-tw": "叩問天工的名冶",
    },
    code: "DQMS",
    colour: "rgb(255, 0, 0)",
  },
  {
    id: "132_2",
    name: "Smith's Fireproof Garment",
    set: "Divine-Querying Master Smith",
    type: "Cavern Relics",
    translation: {
      "en-us": "Smith's Fireproof Garment",
      "zh-cn": "名冶的辟火匠衫",
      "zh-tw": "名冶的闢火匠衫",
    },
    translation_set: {
      "en-us": "Divine-Querying Master Smith",
      "zh-cn": "叩问天工的名冶",
      "zh-tw": "叩問天工的名冶",
    },
    code: "DQMS",
    colour: "rgb(255, 0, 0)",
  },
  {
    id: "132_3",
    name: "Smith's Unbridled Boots",
    set: "Divine-Querying Master Smith",
    type: "Cavern Relics",
    translation: {
      "en-us": "Smith's Unbridled Boots",
      "zh-cn": "名冶的无拘重靴",
      "zh-tw": "名冶的闢火匠衫",
    },
    translation_set: {
      "en-us": "Divine-Querying Master Smith",
      "zh-cn": "叩问天工的名冶",
      "zh-tw": "名冶的無拘重靴",
    },
    code: "DQMS",
    colour: "rgb(255, 0, 0)",
  },
  {
    id: "301_0",
    name: "Herta's Space Station",
    set: "Space Sealing Station",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Herta's Space Station",
      "zh-cn": "「黑塔」的空间站点",
      "zh-tw": "「黑塔」的空間站點",
    },
    translation_set: {
      "en-us": "Space Sealing Station",
      "zh-cn": "太空封印站",
      "zh-tw": "太空封印站",
    },
    code: "SSS",
    colour: "#9e8dc7",
  },
  {
    id: "301_1",
    name: "Herta's Wandering Trek",
    set: "Space Sealing Station",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Herta's Wandering Trek",
      "zh-cn": "「黑塔」的漫历轨迹",
      "zh-tw": "「黑塔」的漫歷軌跡",
    },
    translation_set: {
      "en-us": "Space Sealing Station",
      "zh-cn": "太空封印站",
      "zh-tw": "太空封印站",
    },
    code: "SSS",
    colour: "#9e8dc7",
  },
  {
    id: "302_0",
    name: "The Xianzhou Luofu's Celestial Ark",
    set: "Fleet of the Ageless",
    type: "Planar Ornaments",
    translation: {
      "en-us": "The Xianzhou Luofu's Celestial Ark",
      "zh-cn": "罗浮仙舟的天外楼船",
      "zh-tw": "羅浮仙舟的天外樓船",
    },
    translation_set: {
      "en-us": "Fleet of the Ageless",
      "zh-cn": "不老者的仙舟",
      "zh-tw": "不老者的仙舟",
    },
    code: "FA",
    colour: "#93d6c8",
  },
  {
    id: "302_1",
    name: "The Xianzhou Luofu's Ambrosial Arbor Vines",
    set: "Fleet of the Ageless",
    type: "Planar Ornaments",
    translation: {
      "en-us": "The Xianzhou Luofu's Ambrosial Arbor Vines",
      "zh-cn": "罗浮仙舟的建木枝蔓",
      "zh-tw": "羅浮仙舟的建木枝蔓",
    },
    translation_set: {
      "en-us": "Fleet of the Ageless",
      "zh-cn": "不老者的仙舟",
      "zh-tw": "不老者的仙舟",
    },
    code: "FA",
    colour: "#93d6c8",
  },
  {
    id: "303_0",
    name: "The IPC's Mega HQ",
    set: "Pan-Galactic Commercial Enterprise",
    type: "Planar Ornaments",
    translation: {
      "en-us": "The IPC's Mega HQ",
      "zh-cn": "公司的巨构总部",
      "zh-tw": "公司的巨構總部",
    },
    translation_set: {
      "en-us": "Pan-Galactic Commercial Enterprise",
      "zh-cn": "泛银河商业公司",
      "zh-tw": "泛銀河商業公司",
    },
    code: "PGCE",
    colour: "#e9ca73",
  },
  {
    id: "303_1",
    name: "The IPC's Trade Route",
    set: "Pan-Galactic Commercial Enterprise",
    type: "Planar Ornaments",
    translation: {
      "en-us": "The IPC's Trade Route",
      "zh-cn": "公司的贸易航道",
      "zh-tw": "公司的貿易航道",
    },
    translation_set: {
      "en-us": "Pan-Galactic Commercial Enterprise",
      "zh-cn": "泛银河商业公司",
      "zh-tw": "泛銀河商業公司",
    },
    code: "PGCE",
    colour: "#e9ca73",
  },
  {
    id: "304_0",
    name: "Belobog's Fortress of Preservation",
    set: "Belobog of the Architects",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Belobog's Fortress of Preservation",
      "zh-cn": "贝洛伯格的存护堡垒",
      "zh-tw": "貝洛伯格的存護堡壘",
    },
    translation_set: {
      "en-us": "Belobog of the Architects",
      "zh-cn": "筑城者的贝洛伯格",
      "zh-tw": "築城者的貝洛伯格",
    },
    code: "BA",
    colour: "#75d1ea",
  },
  {
    id: "304_1",
    name: "Belobog's Iron Defense",
    set: "Belobog of the Architects",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Belobog's Iron Defense",
      "zh-cn": "贝洛伯格的铁卫防线",
      "zh-tw": "貝洛伯格的鐵衛防線",
    },
    translation_set: {
      "en-us": "Belobog of the Architects",
      "zh-cn": "筑城者的贝洛伯格",
      "zh-tw": "築城者的貝洛伯格",
    },
    code: "BA",
    colour: "#75d1ea",
  },
  {
    id: "305_0",
    name: "Planet Screwllum's Mechanical Sun",
    set: "Celestial Differentiator",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Planet Screwllum's Mechanical Sun",
      "zh-cn": "螺丝星的机械烈阳",
      "zh-tw": "螺絲星的機械烈陽",
    },
    translation_set: {
      "en-us": "Celestial Differentiator",
      "zh-cn": "星体差分机",
      "zh-tw": "星體差分機",
    },
    code: "CD",
    colour: "#556ec5",
  },
  {
    id: "305_1",
    name: "Planet Screwllum's Ring System",
    set: "Celestial Differentiator",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Planet Screwllum's Ring System",
      "zh-cn": "螺丝星的环星孔带",
      "zh-tw": "螺絲星的環星孔帶",
    },
    translation_set: {
      "en-us": "Celestial Differentiator",
      "zh-cn": "星体差分机",
      "zh-tw": "星體差分機",
    },
    code: "CD",
    colour: "#556ec5",
  },
  {
    id: "306_0",
    name: "Salsotto's Moving City",
    set: "Inert Salsotto",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Salsotto's Moving City",
      "zh-cn": "萨尔索图的移动城市",
      "zh-tw": "薩爾索圖的移動城市",
    },
    translation_set: {
      "en-us": "Inert Salsotto",
      "zh-cn": "停转的萨尔索图",
      "zh-tw": "停轉的薩爾索圖",
    },
    code: "IS",
    colour: "#f8e8e5",
  },
  {
    id: "306_1",
    name: "Salsotto's Terminator Line",
    set: "Inert Salsotto",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Salsotto's Terminator Line",
      "zh-cn": "萨尔索图的晨昏界线",
      "zh-tw": "薩爾索圖的晨昏界線",
    },
    translation_set: {
      "en-us": "Inert Salsotto",
      "zh-cn": "停转的萨尔索图",
      "zh-tw": "停轉的薩爾索圖",
    },
    code: "IS",
    colour: "#f8e8e5",
  },
  {
    id: "307_0",
    name: "Talia's Nailscrap Town",
    set: "Talia: Kingdom of Banditry",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Talia's Nailscrap Town",
      "zh-cn": "塔利亚的钉壳小镇",
      "zh-tw": "塔利亞的釘殼小鎮",
    },
    translation_set: {
      "en-us": "Talia: Kingdom of Banditry",
      "zh-cn": "盗贼公国塔利亚",
      "zh-tw": "盜賊公國塔利亞",
    },
    code: "TKB",
    colour: "#c4b9a4",
  },
  {
    id: "307_1",
    name: "Talia's Exposed Electric Wire",
    set: "Talia: Kingdom of Banditry",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Talia's Exposed Electric Wire",
      "zh-cn": "塔利亚的裸皮电线",
      "zh-tw": "塔利亞的裸皮電線",
    },
    translation_set: {
      "en-us": "Talia: Kingdom of Banditry",
      "zh-cn": "盗贼公国塔利亚",
      "zh-tw": "盜賊公國塔利亞",
    },
    code: "TKB",
    colour: "#c4b9a4",
  },
  {
    id: "308_0",
    name: "Vonwacq's Island of Birth",
    set: "Sprightly Vonwacq",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Vonwacq's Island of Birth",
      "zh-cn": "翁瓦克的诞生之岛",
      "zh-tw": "翁瓦克的誕生之島",
    },
    translation_set: {
      "en-us": "Sprightly Vonwacq",
      "zh-cn": "生命的翁瓦克",
      "zh-tw": "生命的翁瓦克",
    },
    code: "SV",
    colour: "#51d2d7",
  },
  {
    id: "308_1",
    name: "Vonwacq's Islandic Coast",
    set: "Sprightly Vonwacq",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Vonwacq's Islandic Coast",
      "zh-cn": "翁瓦克的环岛海岸",
      "zh-tw": "翁瓦克的環島海岸",
    },
    translation_set: {
      "en-us": "Sprightly Vonwacq",
      "zh-cn": "生命的翁瓦克",
      "zh-tw": "生命的翁瓦克",
    },
    code: "SV",
    colour: "#51d2d7",
  },
  {
    id: "309_0",
    name: "Taikiyan Laser Stadium",
    set: "Rutilant Arena",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Taikiyan Laser Stadium",
      "zh-cn": "泰科铵的镭射球场",
      "zh-tw": "泰科銨的鐳射球場",
    },
    translation_set: {
      "en-us": "Rutilant Arena",
      "zh-cn": "繁星竞技场",
      "zh-tw": "繁星競技場",
    },
    code: "RA",
    colour: "#d18f8a",
  },
  {
    id: "309_1",
    name: "Taikiyan's Arclight Race Track",
    set: "Rutilant Arena",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Taikiyan's Arclight Race Track",
      "zh-cn": "泰科铵的弧光赛道",
      "zh-tw": "泰科銨的弧光賽道",
    },
    translation_set: {
      "en-us": "Rutilant Arena",
      "zh-cn": "繁星竞技场",
      "zh-tw": "繁星競技場",
    },
    code: "RA",
    colour: "#d18f8a",
  },
  {
    id: "310_0",
    name: "Insumousu's Whalefall Ship",
    set: "Broken Keel",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Insumousu's Whalefall Ship",
      "zh-cn": "伊须磨洲的残船鲸落",
      "zh-tw": "伊須磨洲的殘船鯨落",
    },
    translation_set: {
      "en-us": "Broken Keel",
      "zh-cn": "折断的龙骨",
      "zh-tw": "折斷的龍骨",
    },
    code: "BK",
    colour: "#43adc4",
  },
  {
    id: "310_1",
    name: "Insumousu's Frayed Hawser",
    set: "Broken Keel",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Insumousu's Frayed Hawser",
      "zh-cn": "伊须磨洲的坼裂缆索",
      "zh-tw": "伊須磨洲的坼裂纜索",
    },
    translation_set: {
      "en-us": "Broken Keel",
      "zh-cn": "折断的龙骨",
      "zh-tw": "折斷的龍骨",
    },
    code: "BK",
    colour: "#43adc4",
  },

  {
    id: "311_0",
    name: "Glamoth's Iron Cavalry Regiment",
    set: "Firmament Frontline: Glamoth",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Glamoth's Iron Cavalry Regiment",
      "zh-cn": "格拉默的铁骑兵团",
      "zh-tw": "格拉默的鐵騎兵團",
    },
    translation_set: {
      "en-us": "Firmament Frontline: Glamoth",
      "zh-cn": "苍穹战线格拉默",
      "zh-tw": "蒼穹戰線格拉默",
    },
    code: "FF",
    colour: "#F87896",
  },
  {
    id: "311_1",
    name: "Glamoth's Silent Tombstone",
    set: "Firmament Frontline: Glamoth",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Glamoth's Silent Tombstone",
      "zh-cn": "格拉默的寂静坟碑",
      "zh-tw": "格拉默的寂靜墳碑",
    },
    translation_set: {
      "en-us": "Firmament Frontline: Glamoth",
      "zh-cn": "苍穹战线格拉默",
      "zh-tw": "蒼穹戰線格拉默",
    },
    code: "FF",
    colour: "#F87896",
  },
  {
    id: "312_0",
    name: "Penacony's Grand Hotel",
    set: "Penacony, Land of the Dreams",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Penacony's Grand Hotel",
      "zh-cn": "匹诺康尼的堂皇酒店",
      "zh-tw": "匹諾康尼的堂皇飯店",
    },
    translation_set: {
      "en-us": "Penacony, Land of the Dreams",
      "zh-cn": "梦想之地匹诺康尼",
      "zh-tw": "夢想之地匹諾康尼",
    },
    code: "PL",
    colour: "#9E90FD",
  },
  {
    id: "312_1",
    name: "Penacony's Dream-Seeking Tracks",
    set: "Penacony, Land of the Dreams",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Penacony's Dream-Seeking Tracks",
      "zh-cn": "匹诺康尼的逐梦轨道",
      "zh-tw": "匹諾康尼的逐夢軌道",
    },
    translation_set: {
      "en-us": "Penacony, Land of the Dreams",
      "zh-cn": "梦想之地匹诺康尼",
      "zh-tw": "夢想之地匹諾康尼",
    },
    code: "PL",
    colour: "#9E90FD",
  },

  {
    id: "313_0",
    name: "Sigonia's Gaiathra Berth",
    set: "Sigonia, the Unclaimed Desolation",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Sigonia's Gaiathra Berth",
      "zh-cn": "茨冈尼亚的母神卧榻",
      "zh-tw": "茨岡尼亞的母神臥榻",
    },
    translation_set: {
      "en-us": "Sigonia, the Unclaimed Desolation",
      "zh-cn": "无主荒星茨冈尼亚",
      "zh-tw": "無主荒星茨岡尼亞",
    },
    code: "SUD",
    colour: "#fbf6b6",
  },
  {
    id: "313_1",
    name: "Sigonia's Knot of Cyclicality",
    set: "Sigonia, the Unclaimed Desolation",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Sigonia's Knot of Cyclicality",
      "zh-cn": "茨冈尼亚的轮回纽结",
      "zh-tw": "茨岡尼亞的輪迴紐結",
    },
    translation_set: {
      "en-us": "Sigonia, the Unclaimed Desolation",
      "zh-cn": "无主荒星茨冈尼亚",
      "zh-tw": "無主荒星茨岡尼亞",
    },
    code: "SUD",
    colour: "#fbf6b6",
  },

  {
    id: "314_0",
    name: "Izumo's Magatsu no Morokami",
    set: "Izumo Gensei and Takama Divine Realm",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Izumo's Magatsu no Morokami",
      "zh-cn": "出云的祸津众神",
      "zh-tw": "出雲的禍津眾神",
    },
    translation_set: {
      "en-us": "Izumo Gensei and Takama Divine Realm",
      "zh-cn": "出云显世与高天神国",
      "zh-tw": "出雲顯世與高天神國",
    },
    code: "IGT",
    colour: "#dc6c9b",
  },
  {
    id: "314_1",
    name: "Izumo's Blades of Origin and End",
    set: "Izumo Gensei and Takama Divine Realm",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Izumo's Blades of Origin and End",
      "zh-cn": "出云的终始一刀",
      "zh-tw": "出雲的終始一刀",
    },
    translation_set: {
      "en-us": "Izumo Gensei and Takama Divine Realm",
      "zh-cn": "出云显世与高天神国",
      "zh-tw": "出雲顯世與高天神國",
    },
    code: "IGT",
    colour: "#dc6c9b",
  },

  {
    id: "315_0",
    name: "Duran’s Tent of Golden Sky",
    set: "Duran, Dynasty of Running Wolves",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Duran’s Tent of Golden Sky",
      "zh-cn": "都蓝的穹窿金帐",
      "zh-tw": "都蓝的穹窿金帐",
    },
    translation_set: {
      "en-us": "Duran, Dynasty of Running Wolves",
      "zh-cn": "奔狼的都蓝王朝",
      "zh-tw": "奔狼的都藍王朝",
    },
    code: "DDRW",
    colour: "#5c8ef0",
  },
  {
    id: "315_1",
    name: "Duran's Mechabeast Bridle",
    set: "Duran, Dynasty of Running Wolves",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Duran's Mechabeast Bridle",
      "zh-cn": "都蓝的器兽缰辔",
      "zh-tw": "都蓝的器兽缰辔",
    },
    translation_set: {
      "en-us": "Duran, Dynasty of Running Wolves",
      "zh-cn": "奔狼的都蓝王朝",
      "zh-tw": "奔狼的都藍王朝",
    },
    code: "DDRW",
    colour: "#5c8ef0",
  },
  {
    id: "316_0",
    name: "Forge's Lotus Lantern Wick",
    set: "Forge of the Kalpagni Lantern",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Forge's Lotus Lantern Wick",
      "zh-cn": "铸炼宫的莲华灯芯",
      "zh-tw": "铸炼宫的莲华灯芯",
    },
    translation_set: {
      "en-us": "Forge of the Kalpagni Lantern",
      "zh-cn": "劫火莲灯铸炼宫",
      "zh-tw": "劫火蓮燈鑄煉宮",
    },
    code: "FKL",
    colour: "#dc7e90",
  },
  {
    id: "316_1",
    name: "Forge’s Heavenly Flamewheel Silk",
    set: "Forge of the Kalpagni Lantern",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Forge’s Heavenly Flamewheel Silk",
      "zh-cn": "铸炼宫的焰轮天绸",
      "zh-tw": "铸炼宫的焰轮天绸",
    },
    translation_set: {
      "en-us": "Forge of the Kalpagni Lantern",
      "zh-cn": "劫火莲灯铸炼宫",
      "zh-tw": "劫火蓮燈鑄煉宮",
    },
    code: "FKL",
    colour: "#dc7e90",
  },
  {
    id: "317_0",
    name: "Lushaka's Waterscape",
    set: "Lushaka, the Sunken Seas",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Lushaka's Waterscape",
      "zh-cn": "露莎卡的水朽苍都",
      "zh-tw": "露莎卡的水朽蒼都",
    },
    translation_set: {
      "en-us": "Lushaka, the Sunken Seas",
      "zh-cn": "沉陆海域露莎卡",
      "zh-tw": "沉陸海域露莎卡",
    },
    code: "LSS",
    colour: "#2eb5df",
  },
  {
    id: "317_1",
    name: "Lushaka's Twinlanes",
    set: "Lushaka, the Sunken Seas",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Lushaka's Twinlanes",
      "zh-cn": "露莎卡的双生航道",
      "zh-tw": "露莎卡的雙生航道",
    },
    translation_set: {
      "en-us": "Lushaka, the Sunken Seas",
      "zh-cn": "沉陆海域露莎卡",
      "zh-tw": "沉陸海域露莎卡",
    },
    code: "LSS",
    colour: "#2eb5df",
  },
  {
    id: "318_0",
    name: "BananAmusement Park's BananAxis Plaza",
    set: "The Wondrous BananAmusement Park",
    type: "Planar Ornaments",
    translation: {
      "en-us": "BananAmusement Park's BananAxis Plaza",
      "zh-cn": "蕉乐园的蕉芯广场",
      "zh-tw": "蕉樂園的蕉芯廣場",
    },
    translation_set: {
      "en-us": "The Wondrous BananAmusement Park",
      "zh-cn": "奇想蕉乐园",
      "zh-tw": "奇想蕉樂園",
    },
    code: "TWBP",
    colour: "#d5b0e3",
  },
  {
    id: "318_1",
    name: "BananAmusement Park's Memetic Cables",
    set: "The Wondrous BananAmusement Park",
    type: "Planar Ornaments",
    translation: {
      "en-us": "BananAmusement Park's Memetic Cables",
      "zh-cn": "蕉乐园的模因线缆",
      "zh-tw": "蕉樂園的迷因纜線",
    },
    translation_set: {
      "en-us": "The Wondrous BananAmusement Park",
      "zh-cn": "奇想蕉乐园",
      "zh-tw": "奇想蕉樂園",
    },
    code: "TWBP",
    colour: "#d5b0e3",
  },
  {
    id: "319_0",
    name: "Aidonia's Deceased Gravestones",
    set: "Bone Collection's Serene Demesne",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Aidonia's Deceased Gravestones",
      "zh-cn": "哀地里亚的殁名祭碑",
      "zh-tw": "哀地里亞的歿名祭碑",
    },
    translation_set: {
      "en-us": "Bone Collection's Serene Demesne",
      "zh-cn": "谧宁拾骨地",
      "zh-tw": "謐寧拾骨地",
    },
    code: "BCS",
    colour: "#b3b1f4",
  },
  {
    id: "319_1",
    name: "Aidonia’s Deathward Bone Chains",
    set: "Bone Collection's Serene Demesne",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Aidonia’s Deathward Bone Chains",
      "zh-cn": "哀地里亚的入溟骨链",
      "zh-tw": "哀地里亞的入溟骨鏈",
    },
    translation_set: {
      "en-us": "Bone Collection's Serene Demesne",
      "zh-cn": "谧宁拾骨地",
      "zh-tw": "謐寧拾骨地",
    },
    code: "BCS",
    colour: "#b3b1f4",
  },
  {
    id: "320_0",
    name: "Grove of Epiphany's Pondering Colossus",
    set: "Giant Tree of Rapt Brooding",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Grove of Epiphany's Pondering Colossus",
      "zh-cn": "神悟树庭的沉思巨桹",
      "zh-tw": "神悟樹庭的沉思巨桹",
    },
    translation_set: {
      "en-us": "Giant Tree of Rapt Brooding",
      "zh-cn": "渊思寂虑的巨树",
      "zh-tw": "淵思寂慮的巨樹",
    },
    code: "GTRB",
    colour: "#d0eed4",
  },
  {
    id: "320_1",
    name: "Grove of Epiphany's Interwoven Veins",
    set: "Giant Tree of Rapt Brooding",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Grove of Epiphany's Interwoven Veins",
      "zh-cn": "神悟树庭的联识叶路",
      "zh-tw": "神悟樹庭的聯識葉路",
    },
    translation_set: {
      "en-us": "Giant Tree of Rapt Brooding",
      "zh-cn": "渊思寂虑的巨树",
      "zh-tw": "淵思寂慮的巨樹",
    },
    code: "GTRB",
    colour: "#d0eed4",
  },
  {
    id: "321_0",
    name: "Membrance Maze's Serene Treehouse",
    set: "Arcadia of Woven Dreams",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Membrance Maze's Serene Treehouse",
      "zh-cn": "迷路迷境的恬梦树屋",
      "zh-tw": "迷路迷境的恬夢樹屋",
    },
    translation_set: {
      "en-us": "Arcadia of Woven Dreams",
      "zh-cn": "妖精织梦的乐园",
      "zh-tw": "妖精織夢的樂園",
    },
    code: "AWD",
    colour: "#bc9dd5",
  },
  {
    id: "321_1",
    name: "Membrance Maze's Wishing Whistle",
    set: "Arcadia of Woven Dreams",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Membrance Maze's Wishing Whistle",
      "zh-cn": "迷路迷境的祈愿笛哨",
      "zh-tw": "迷路迷境的祈願笛哨",
    },
    translation_set: {
      "en-us": "Arcadia of Woven Dreams",
      "zh-cn": "妖精织梦的乐园",
      "zh-tw": "妖精織夢的樂園",
    },
    code: "AWD",
    colour: "#bc9dd5",
  },
  {
    id: "322_0",
    name: "Warbling Shores' Blazing Beacon",
    set: "Revelry by the Sea",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Warbling Shores' Blazing Beacon",
      "zh-cn": "酣歌海垠的礁屿灯塔",
      "zh-tw": "酣歌海垠的礁嶼燈塔",
    },
    translation_set: {
      "en-us": "Revelry by the Sea",
      "zh-cn": "沉欢醉饮的海隅",
      "zh-tw": "沉歡醉飲的海隅",
    },
    code: "RTS",
    colour: "#6159c2",
  },
  {
    id: "322_1",
    name: "Warbling Shores' Cantillation Trail",
    set: "Revelry by the Sea",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Warbling Shores' Cantillation Trail",
      "zh-cn": "酣歌海垠的歌咏步道",
      "zh-tw": "酣歌海垠的歌詠步道",
    },
    translation_set: {
      "en-us": "Revelry by the Sea",
      "zh-cn": "沉欢醉饮的海隅",
      "zh-tw": "沉歡醉飲的海隅",
    },
    code: "RTS",
    colour: "#6159c2",
  },
  {
    id: "323_0",
    name: "Last West Wind of Amphoreus",
    set: "Amphoreus, The Eternal Land",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Last West Wind of Amphoreus",
      "zh-cn": "翁法罗斯的西风尽途",
      "zh-tw": "翁法羅斯的西風盡途",
    },
    translation_set: {
      "en-us": "Amphoreus, The Eternal Land",
      "zh-cn": "永恒之地翁法罗斯",
      "zh-tw": "永恆之地翁法羅斯",
    },
    code: "ATEL",
    colour: "#f156ffff",
  },
  {
    id: "323_1",
    name: "Eternal Verses of Amphoreus",
    set: "Amphoreus, The Eternal Land",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Eternal Verses of Amphoreus",
      "zh-cn": "翁法罗斯的永恒诗篇",
      "zh-tw": "翁法羅斯的永恆詩篇",
    },
    translation_set: {
      "en-us": "Amphoreus, The Eternal Land",
      "zh-cn": "永恒之地翁法罗斯",
      "zh-tw": "永恆之地翁法羅斯",
    },
    code: "ATEL",
    colour: "#f156ffff",
  },
  {
    id: "324_0",
    name: "Livestream's Protean Vistas",
    set: "Tengoku@Livestream",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Livestream's Protean Vistas",
      "zh-cn": "直播间的千窗万面",
      "zh-tw": "直播頻道的千窗萬面",
    },
    translation_set: {
      "en-us": "Tengoku@Livestream",
      "zh-cn": "天国@直播间",
      "zh-tw": "天國@直播頻道",
    },
    code: "TL",
    colour: "#f156ffff",
  },
  {
    id: "324_1",
    name: "Livestream's Chatter Banter",
    set: "Tengoku@Livestream",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Livestream's Chatter Banter",
      "zh-cn": "直播间的畅聊语流",
      "zh-tw": "直播頻道的暢聊語流",
    },
    translation_set: {
      "en-us": "Tengoku@Livestream",
      "zh-cn": "天国@直播间",
      "zh-tw": "天國@直播頻道",
    },
    code: "TL",
    colour: "#f156ffff",
  },
  {
    id: "325_0",
    name: "Punklorde's Rainbow City",
    set: "Punklorde Stage Zero",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Punklorde's Rainbow City",
      "zh-cn": "朋克洛德的虹霓都市",
      "zh-tw": "龐克洛德的虹霓都市",
    },
    translation_set: {
      "en-us": "Punklorde Stage Zero",
      "zh-cn": "零号关卡朋克洛德",
      "zh-tw": "零號關卡龐克洛德",
    },
    code: "PSZ",
    colour: "rgb(86, 244, 255)",
  },
  {
    id: "325_1",
    name: "Punklorde's Data Deluge",
    set: "Punklorde Stage Zero",
    type: "Planar Ornaments",
    translation: {
      "en-us": "Punklorde's Data Deluge",
      "zh-cn": "朋克洛德的数据洪流",
      "zh-tw": "龐克洛德的資訊洪流",
    },
    translation_set: {
      "en-us": "Punklorde Stage Zero",
      "zh-cn": "零号关卡朋克洛德",
      "zh-tw": "零號關卡龐克洛德",
    },
    code: "PSZ",
    colour: "rgb(86, 244, 255)",
  },
];

export const mainStats = [
  {
    id: "body",
    name: "body",
    translation: {
      "en-us": "Body",
      "zh-cn": "躯干",
      "zh-tw": "軀幹",
    },
    image: require("../components/image/icon/body.webp"),
  },
  {
    id: "feet",
    name: "feet",
    translation: {
      "en-us": "Feet",
      "zh-cn": "脚部",
      "zh-tw": "腳部",
    },
    image: require("../components/image/icon/feet.webp"),
  },
  {
    id: "planar_sphere",
    name: "planar_sphere",
    translation: {
      "en-us": "Planar Sphere",
      "zh-cn": "面位球",
      "zh-tw": "面位球",
    },
    image: require("../components/image/icon/planar_sphere.webp"),
  },
  {
    id: "link_rope",
    name: "link_rope",
    translation: {
      "en-us": "Link Rope",
      "zh-cn": "连结绳",
      "zh-tw": "連結繩",
    },
    image: require("../components/image/icon/link_rope.webp"),
  },
];

export const property = [
  {
    id: "A",
    name: "ATK",
    translation: {
      "en-us": "ATK",
      "zh-cn": "攻击力",
      "zh-tw": "攻擊力",
    },
    type: "relic",
    image: require("../components/image/property/a.webp"),
  },
  {
    id: "AR",
    name: "ATT",
    translation: {
      "en-us": "ATK %",
      "zh-cn": "攻击力 %",
      "zh-tw": "攻擊力 %",
    },
    type: "relic",
    image: require("../components/image/property/a.webp"),
  },
  {
    id: "BE",
    name: "Break Effect",
    translation: {
      "en-us": "Break Effect",
      "zh-cn": "击破特攻",
      "zh-tw": "擊破特攻",
    },
    type: "relic",
    image: require("../components/image/property/be.webp"),
  },
  {
    id: "CR",
    name: "CRIT Rate",
    translation: {
      "en-us": "CRIT Rate",
      "zh-cn": "暴击率",
      "zh-tw": "暴擊率",
    },
    type: "relic",
    image: require("../components/image/property/cr.webp"),
  },
  {
    id: "CD",
    name: "CRIT DMG",
    translation: {
      "en-us": "CRIT DMG",
      "zh-cn": "暴击伤害",
      "zh-tw": "暴擊傷害",
    },
    type: "relic",
    image: require("../components/image/property/cd.webp"),
  },
  {
    id: "D",
    name: "DEF",
    translation: {
      "en-us": "DEF",
      "zh-cn": "防御力",
      "zh-tw": "防禦力",
    },
    type: "relic",
    image: require("../components/image/property/d.webp"),
  },
  {
    id: "DR",
    name: "DEF",
    translation: {
      "en-us": "DEF %",
      "zh-cn": "防御力 %",
      "zh-tw": "防禦力 %",
    },
    type: "relic",
    image: require("../components/image/property/d.webp"),
  },
  {
    id: "DB",
    name: "DMG Boost",
    type: "",
  },
  {
    id: "DBF",
    name: "Fire DMG Boost",
    translation: {
      "en-us": "Fire DMG Boost",
      "zh-cn": "火属性伤害提高",
      "zh-tw": "火屬性傷害提高",
    },
    type: "relic",
    image: fireIcon,
  },
  {
    id: "DBI",
    name: "Ice DMG Boost",
    translation: {
      "en-us": "Ice DMG Boost",
      "zh-cn": "冰属性伤害提高",
      "zh-tw": "冰屬性傷害提高",
    },
    type: "relic",
    image: iceIcon,
  },
  {
    id: "DBM",
    name: "Imaginary DMG Boost",
    translation: {
      "en-us": "Imaginary DMG Boost",
      "zh-cn": "虚数属性伤害提高",
      "zh-tw": "虛數屬性傷害提高",
    },
    type: "relic",
    image: imaginaryIcon,
  },
  {
    id: "DBP",
    name: "Physical DMG Boost",
    translation: {
      "en-us": "Physical DMG Boost",
      "zh-cn": "物理属性伤害提高",
      "zh-tw": "物理屬性傷害提高",
    },
    type: "relic",
    image: physicalIcon,
  },
  {
    id: "DBL",
    name: "Lightning DMG Boost",
    translation: {
      "en-us": "Lightning DMG Boost",
      "zh-cn": "雷属性伤害提高",
      "zh-tw": "雷屬性傷害提高",
    },
    type: "relic",
    image: lightningIcon,
  },
  {
    id: "DBQ",
    name: "Quantum DMG Boost",
    translation: {
      "en-us": "Quantum DMG Boost",
      "zh-cn": "量子属性伤害提高",
      "zh-tw": "量子屬性傷害提高",
    },
    type: "relic",
    image: quantumIcon,
  },
  {
    id: "DBW",
    name: "Wind DMG Boost",
    translation: {
      "en-us": "Wind DMG Boost",
      "zh-cn": "风属性伤害提高",
      "zh-tw": "風屬性傷害提高",
    },
    type: "relic",
    image: windIcon,
  },
  {
    id: "E",
    name: "Energy",
    translation: {
      "en-us": "Energy",
      "zh-cn": "能量上限",
      "zh-tw": "能量上限",
    },
    type: "",
  },
  {
    id: "EG",
    name: "Energy Regeneration Rate",
    translation: {
      "en-us": "Energy Regeneration Rate",
      "zh-cn": "能量恢复效率",
      "zh-tw": "能量恢復效率",
    },
    type: "relic",
    image: require("../components/image/property/eg.webp"),
  },
  {
    id: "EH",
    name: "Effect Hit Rate",
    translation: {
      "en-us": "Effect Hit Rate",
      "zh-cn": "效果命中",
      "zh-tw": "效果命中",
    },
    type: "relic",
    image: require("../components/image/property/eh.webp"),
  },
  {
    id: "EL",
    name: "Elation",
    translation: {
      "en-us": "Elation",
      "zh-cn": "欢愉",
      "zh-tw": "歡愉",
    },
    type: "relic",
    image: require("../components/image/property/el.webp"),
  },
  {
    id: "ER",
    name: "Effect RES",
    translation: {
      "en-us": "Effect RES",
      "zh-cn": "效果抵抗",
      "zh-tw": "效果抵抗",
    },
    type: "relic",
    image: require("../components/image/property/er.webp"),
  },
  {
    id: "H",
    name: "HP",
    translation: {
      "en-us": "HP",
      "zh-cn": "生命值",
      "zh-tw": "生命值",
    },
    type: "relic",
    image: require("../components/image/property/h.webp"),
  },
  {
    id: "HR",
    name: "HP",
    translation: {
      "en-us": "HP %",
      "zh-cn": "生命值 %",
      "zh-tw": "生命值 %",
    },
    type: "relic",
    image: require("../components/image/property/h.webp"),
  },
  {
    id: "O",
    name: "Outgoing Healing Boost",
    translation: {
      "en-us": "Outgoing Healing Boost",
      "zh-cn": "治疗量加成",
      "zh-tw": "治療量加成",
    },
    type: "relic",
    image: require("../components/image/property/o.webp"),
  },
  {
    id: "S",
    name: "SPD",
    translation: {
      "en-us": "SPD",
      "zh-cn": "速度",
      "zh-tw": "速度",
    },
    type: "relic",
    image: require("../components/image/property/s.webp"),
  },
];

export const path = [
  {
    id: "abundance",
    name: "Abundance",
    translation: {
      "en-us": "Abundance",
      "zh-cn": "丰饶",
      "zh-tw": "豐饒",
    },
    checked: false,
    image: abundanceIcon,
  },
  {
    id: "destruction",
    name: "Destruction",
    translation: {
      "en-us": "Destruction",
      "zh-cn": "毁灭",
      "zh-tw": "毀滅",
    },
    checked: false,
    image: destructionIcon,
  },
  {
    id: "erudition",
    name: "Erudition",
    translation: {
      "en-us": "Erudition",
      "zh-cn": "智识",
      "zh-tw": "智識",
    },
    checked: false,
    image: eruditionIcon,
  },
  {
    id: "harmony",
    name: "Harmony",
    translation: {
      "en-us": "Harmony",
      "zh-cn": "同谐",
      "zh-tw": "同諧",
    },
    checked: false,
    image: harmonyIcon,
  },
  {
    id: "hunt",
    name: "Hunt",
    translation: {
      "en-us": "Hunt",
      "zh-cn": "巡猎",
      "zh-tw": "巡獵",
    },
    checked: false,
    image: huntIcon,
  },
  {
    id: "nihility",
    name: "Nihility",
    translation: {
      "en-us": "Nihility",
      "zh-cn": "虚无",
      "zh-tw": "虛無",
    },
    checked: false,
    image: nihilityIcon,
  },
  {
    id: "preservation",
    name: "Preservation",
    translation: {
      "en-us": "Preservation",
      "zh-cn": "存护",
      "zh-tw": "存護",
    },
    checked: false,
    image: preservationIcon,
  },
];

export const rarity = [
  {
    id: 4,
    name: "4 Stars",
    rarity_number: "four-star",
    translation: {
      "en-us": "4 Stars",
      "zh-cn": "4 星",
      "zh-tw": "4 星",
    },
    checked: false,
    image: fourStarsIcon,
  },
  {
    id: 5,
    name: "5 Stars",
    rarity_number: "five-star",
    translation: {
      "en-us": "5 Stars",
      "zh-cn": "5 星",
      "zh-tw": "5 星",
    },
    checked: false,
    image: fiveStarsIcon,
  },
];

export const elements = [
  {
    id: "fire",
    name: "Fire",
    translation: {
      "en-us": "Fire",
      "zh-cn": "火",
      "zh-tw": "火",
    },
    checked: false,
    image: fireIcon,
  },
  {
    id: "ice",
    name: "Ice",
    translation: {
      "en-us": "Ice",
      "zh-cn": "冰",
      "zh-tw": "冰",
    },
    checked: false,
    image: iceIcon,
  },
  {
    id: "imaginary",
    name: "Imaginary",
    translation: {
      "en-us": "Imaginary",
      "zh-cn": "虚数",
      "zh-tw": "虛數",
    },
    checked: false,
    image: imaginaryIcon,
  },
  {
    id: "lightning",
    name: "Lightning",
    translation: {
      "en-us": "Lightning",
      "zh-cn": "雷",
      "zh-tw": "雷",
    },
    checked: false,
    image: lightningIcon,
  },
  {
    id: "physical",
    name: "Physical",
    translation: {
      "en-us": "Physical",
      "zh-cn": "物理",
      "zh-tw": "物理",
    },
    checked: false,
    image: physicalIcon,
  },
  {
    id: "quantum",
    name: "Quantum",
    translation: {
      "en-us": "Quantum",
      "zh-cn": "量子",
      "zh-tw": "量子",
    },
    checked: false,
    image: quantumIcon,
  },
  {
    id: "wind",
    name: "Wind",
    translation: {
      "en-us": "Wind",
      "zh-cn": "风",
      "zh-tw": "風",
    },
    checked: false,
    image: windIcon,
  },
];

export const lightConeRows = [
  {
    id: "20000",
    name: "Arrows",
    translation: {
      "en-us": "Arrows",
      "zh-cn": "锋镝",
      "zh-tw": "鋒鏑",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20001",
    name: "Cornucopia",
    translation: {
      "en-us": "Cornucopia",
      "zh-cn": "物穰",
      "zh-tw": "物穰",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20002",
    name: "Collapsing Sky",
    translation: {
      "en-us": "Collapsing Sky",
      "zh-cn": "天倾",
      "zh-tw": "天傾",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20003",
    name: "Amber",
    translation: {
      "en-us": "Amber",
      "zh-cn": "琥珀",
      "zh-tw": "琥珀",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20004",
    name: "Void",
    translation: {
      "en-us": "Void",
      "zh-cn": "幽邃",
      "zh-tw": "幽邃",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20005",
    name: "Chorus",
    translation: {
      "en-us": "Chorus",
      "zh-cn": "齐颂",
      "zh-tw": "齊頌",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20006",
    name: "Data Bank",
    translation: {
      "en-us": "Data Bank",
      "zh-cn": "智库",
      "zh-tw": "智庫",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20007",
    name: "Darting Arrow",
    translation: {
      "en-us": "Darting Arrow",
      "zh-cn": "离弦",
      "zh-tw": "離弦",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20008",
    name: "Fine Fruit",
    translation: {
      "en-us": "Fine Fruit",
      "zh-cn": "嘉果",
      "zh-tw": "嘉果",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20009",
    name: "Shattered Home",
    translation: {
      "en-us": "Shattered Home",
      "zh-cn": "乐圮",
      "zh-tw": "樂圮",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20010",
    name: "Defense",
    translation: {
      "en-us": "Defense",
      "zh-cn": "戍御",
      "zh-tw": "戍禦",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20011",
    name: "Loop",
    translation: {
      "en-us": "Loop",
      "zh-cn": "渊环",
      "zh-tw": "淵環",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20012",
    name: "Meshing Cogs",
    translation: {
      "en-us": "Meshing Cogs",
      "zh-cn": "轮契",
      "zh-tw": "輪契",
    },
    hp: "846",
    atk: "317",
    def: "264",
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20013",
    name: "Passkey",
    translation: {
      "en-us": "Passkey",
      "zh-cn": "灵钥",
      "zh-tw": "靈鑰",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20014",
    name: "Adversarial",
    translation: {
      "en-us": "Adversarial",
      "zh-cn": "相抗",
      "zh-tw": "相抗",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20015",
    name: "Multiplication",
    translation: {
      "en-us": "Multiplication",
      "zh-cn": "蕃息",
      "zh-tw": "蕃息",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20016",
    name: "Mutual Demise",
    translation: {
      "en-us": "Mutual Demise",
      "zh-cn": "俱殁",
      "zh-tw": "俱歿",
    },
    hp: "846",
    atk: "370",
    def: "198",
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20017",
    name: "Pioneering",
    translation: {
      "en-us": "Pioneering",
      "zh-cn": "开疆",
      "zh-tw": "開疆",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20018",
    name: "Hidden Shadow",
    translation: {
      "en-us": "Hidden Shadow",
      "zh-cn": "匿影",
      "zh-tw": "匿影",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20019",
    name: "Mediation",
    translation: {
      "en-us": "Mediation",
      "zh-cn": "调和",
      "zh-tw": "調和",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20020",
    name: "Sagacity",
    translation: {
      "en-us": "Sagacity",
      "zh-cn": "睿见",
      "zh-tw": "睿見",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20021",
    name: "Shadowburn",
    translation: {
      "en-us": "Shadowburn",
      "zh-cn": "焚影",
      "zh-tw": "焚影",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20022",
    name: "Reminiscence",
    translation: {
      "en-us": "Reminiscence",
      "zh-cn": "溯忆",
      "zh-tw": "溯忆",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  {
    id: "20023",
    name: "Sneering",
    translation: {
      "en-us": "Sneering",
      "zh-cn": "嗤笑",
      "zh-tw": "嗤笑",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  /*
  {
    id: "20024",
    name: "Lingering Tear",
    translation: {
      "en-us": "Lingering Tear",
      "zh-cn": "残泪",
      "zh-tw": "殘淚",
    },
    rarity_number: "three-star",
    rarity: threeStarsIcon,
  },
  */
  {
    id: "21000",
    name: "Post-Op Conversation",
    translation: {
      "en-us": "Post-Op Conversation",
      "zh-cn": "一场术后对话",
      "zh-tw": "一場術後對話",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21001",
    name: "Good Night and Sleep Well",
    translation: {
      "en-us": "Good Night and Sleep Well",
      "zh-cn": "晚安与睡颜",
      "zh-tw": "晚安與睡顏",
    },
    hp: "952",
    atk: "476",
    def: "330",
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21002",
    name: "Day One of My New Life",
    translation: {
      "en-us": "Day One of My New Life",
      "zh-cn": "余生的第一天",
      "zh-tw": "餘生的第一天",
    },
    hp: "952",
    atk: "370",
    def: "463",
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21003",
    name: "Only Silence Remains",
    translation: {
      "en-us": "Only Silence Remains",
      "zh-cn": "唯有沉默",
      "zh-tw": "唯有沉默",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21004",
    name: "Memories of the Past",
    translation: {
      "en-us": "Memories of the Past",
      "zh-cn": "记忆中的模样",
      "zh-tw": "記憶中的模樣",
    },
    hp: "952",
    atk: "423",
    def: "396",
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21005",
    name: "The Moles Welcome You",
    translation: {
      "en-us": "The Moles Welcome You",
      "zh-cn": "鼹鼠党欢迎你",
      "zh-tw": "鼴鼠黨歡迎你",
    },
    hp: "952",
    atk: "476",
    def: "330",
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21006",
    name: "The Birth of the Self",
    translation: {
      "en-us": "The Birth of the Self",
      "zh-cn": "「我」的诞生",
      "zh-tw": "「我」的誕生",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21007",
    name: "Shared Feeling",
    translation: {
      "en-us": "Shared Feeling",
      "zh-cn": "同一种心情",
      "zh-tw": "同一種心情",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21008",
    name: "Eyes of the Prey",
    translation: {
      "en-us": "Eyes of the Prey",
      "zh-cn": "猎物的视线",
      "zh-tw": "獵物的視線",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21009",
    name: "Landau's Choice",
    translation: {
      "en-us": "Landau's Choice",
      "zh-cn": "朗道的选择",
      "zh-tw": "朗道的選擇",
    },
    hp: "952",
    atk: "423",
    def: "396",
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21010",
    name: "Swordplay",
    translation: {
      "en-us": "Swordplay",
      "zh-cn": "论剑",
      "zh-tw": "論劍",
    },
    hp: "952",
    atk: "476",
    def: "330",
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21011",
    name: "Planetary Rendezvous",
    translation: {
      "en-us": "Planetary Rendezvous",
      "zh-cn": "与行星相会",
      "zh-tw": "與行星相會",
    },
    hp: "1058",
    atk: "423",
    def: "330",
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21012",
    name: "A Secret Vow",
    translation: {
      "en-us": "A Secret Vow",
      "zh-cn": "秘密誓心",
      "zh-tw": "秘密誓心",
    },
    hp: "1058",
    atk: "476",
    def: "264",
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21013",
    name: "Make the World Clamor",
    translation: {
      "en-us": "Make the World Clamor",
      "zh-cn": "别让世界静下来",
      "zh-tw": "別讓世界靜下來",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21014",
    name: "Perfect Timing",
    translation: {
      "en-us": "Perfect Timing",
      "zh-cn": "此时恰好",
      "zh-tw": "此時恰好",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21015",
    name: "Resolution Shines As Pearls of Sweat",
    translation: {
      "en-us": "Resolution Shines As Pearls of Sweat",
      "zh-cn": "决心如汗珠般闪耀",
      "zh-tw": "決心如汗珠般閃耀",
    },
    hp: "952",
    atk: "476",
    def: "330",
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21016",
    name: "Trend of the Universal Market",
    translation: {
      "en-us": "Trend of the Universal Market",
      "zh-cn": "宇宙市场趋势",
      "zh-tw": "宇宙市場趨勢",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21017",
    name: "Subscribe for More!",
    translation: {
      "en-us": "Subscribe for More!",
      "zh-cn": "点个关注吧！",
      "zh-tw": "點個關注吧！",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21018",
    name: "Dance! Dance! Dance!",
    translation: {
      "en-us": "Dance! Dance! Dance!",
      "zh-cn": "舞！舞！舞！",
      "zh-tw": "舞！舞！舞！",
    },
    hp: "952",
    atk: "423",
    def: "396",
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21019",
    name: "Under the Blue Sky",
    translation: {
      "en-us": "Under the Blue Sky",
      "zh-cn": "在蓝天下",
      "zh-tw": "在藍天下",
    },
    hp: "952",
    atk: "476",
    def: "330",
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21020",
    name: "Geniuses' Repose",
    translation: {
      "en-us": "Geniuses' Repose",
      "zh-cn": "天才们的休憩",
      "zh-tw": "天才們的休憩",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21021",
    name: "Quid Pro Quo",
    translation: {
      "en-us": "Quid Pro Quo",
      "zh-cn": "等价交换",
      "zh-tw": "等價交換",
    },
    hp: "952",
    atk: "423",
    def: "396",
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21022",
    name: "Fermata",
    translation: {
      "en-us": "Fermata",
      "zh-cn": "延长记号",
      "zh-tw": "延長記號",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21023",
    name: "We Are Wildfire",
    translation: {
      "en-us": "We Are Wildfire",
      "zh-cn": "我们是地火",
      "zh-tw": "我們是地火",
    },
    hp: "740",
    atk: "476",
    def: "463",
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21024",
    name: "River Flows in Spring",
    translation: {
      "en-us": "River Flows in Spring",
      "zh-cn": "春水初生",
      "zh-tw": "春水初生",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21025",
    name: "Past and Future",
    translation: {
      "en-us": "Past and Future",
      "zh-cn": "过往未来",
      "zh-tw": "過往未來",
    },
    hp: "952",
    atk: "423",
    def: "396",
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21026",
    name: "Woof! Walk Time!",
    translation: {
      "en-us": "Woof! Walk Time!",
      "zh-cn": "汪！散步时间！",
      "zh-tw": "汪！散步時間！",
    },
    hp: "952",
    atk: "476",
    def: "330",
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21027",
    name: "The Seriousness of Breakfast",
    translation: {
      "en-us": "The Seriousness of Breakfast",
      "zh-cn": "早餐的仪式感",
      "zh-tw": "早餐的儀式感",
    },
    hp: "846",
    atk: "476",
    def: "396",
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21028",
    name: "Warmth Shortens Cold Nights",
    translation: {
      "en-us": "Warmth Shortens Cold Nights",
      "zh-cn": "暖夜不会漫长",
      "zh-tw": "暖夜不會漫長",
    },
    hp: "1058",
    atk: "370",
    def: "396",
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21029",
    name: "We Will Meet Again",
    translation: {
      "en-us": "We Will Meet Again",
      "zh-cn": "后会有期",
      "zh-tw": "後會有期",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21030",
    name: "This Is Me!",
    translation: {
      "en-us": "This Is Me!",
      "zh-cn": "这就是我啦！",
      "zh-tw": "這就是我啦！",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21031",
    name: "Return to Darkness",
    translation: {
      "en-us": "Return to Darkness",
      "zh-cn": "重返幽冥",
      "zh-tw": "重返幽冥",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21032",
    name: "Carve the Moon, Weave the Clouds",
    translation: {
      "en-us": "Carve the Moon, Weave the Clouds",
      "zh-cn": "镂月裁云之意",
      "zh-tw": "鏤月裁雲之意",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21033",
    name: "Nowhere to Run",
    translation: {
      "en-us": "Nowhere to Run",
      "zh-cn": "无处可逃",
      "zh-tw": "無處可逃",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21034",
    name: "Today Is Another Peaceful Day",
    translation: {
      "en-us": "Today Is Another Peaceful Day",
      "zh-cn": "今日亦是和平的一日",
      "zh-tw": "今日亦是和平的一日",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21035",
    name: "What Is Real?",
    translation: {
      "en-us": "What Is Real?",
      "zh-cn": "何物为真",
      "zh-tw": "何物為真",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21036",
    name: "Dreamville Adventure",
    translation: {
      "en-us": "Dreamville Adventure",
      "zh-cn": "美梦小镇大冒险",
      "zh-tw": "美夢小鎮大冒險",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21037",
    name: "Final Victor",
    translation: {
      "en-us": "Final Victor",
      "zh-cn": "最后的赢家",
      "zh-tw": "最後的贏家",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21038",
    name: "Flames Afar",
    translation: {
      "en-us": "Flames Afar",
      "zh-cn": "在火的远处",
      "zh-tw": "在火的遠處",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21039",
    name: "Destiny's Threads Forewoven",
    translation: {
      "en-us": "Destiny's Threads Forewoven",
      "zh-cn": "织造命运之线",
      "zh-tw": "織造命運之線",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21040",
    name: "The Day The Cosmos Fell",
    translation: {
      "en-us": "The Day The Cosmos Fell",
      "zh-cn": "银河沦陷日",
      "zh-tw": "銀河淪陷日",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21041",
    name: "It's Showtime",
    translation: {
      "en-us": "It's Showtime",
      "zh-cn": "好戏开演",
      "zh-tw": "好戲開演",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21042",
    name: "Indelible Promise",
    translation: {
      "en-us": "Indelible Promise",
      "zh-cn": "铭记于心的约定",
      "zh-tw": "銘記於心的約定",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21043",
    name: "Concert for Two",
    translation: {
      "en-us": "Concert for Two",
      "zh-cn": "两个人的演唱会",
      "zh-tw": "兩個人的演唱會",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21044",
    name: "Boundless Choreo",
    translation: {
      "en-us": "Boundless Choreo",
      "zh-cn": "无边曼舞",
      "zh-tw": "無邊曼舞",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21045",
    name: "After the Charmony Fall",
    translation: {
      "en-us": "After the Charmony Fall",
      "zh-cn": "谐乐静默之后",
      "zh-tw": "諧樂靜默之後",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21046",
    name: "Poised to Bloom",
    translation: {
      "en-us": "Poised to Bloom",
      "zh-cn": "芳华待灼",
      "zh-tw": "芳華待灼",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21047",
    name: "Shadowed by Night",
    translation: {
      "en-us": "Shadowed by Night",
      "zh-cn": "黑夜如影随行",
      "zh-tw": "黑夜如影隨行",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21048",
    name: "Dream's Montage",
    translation: {
      "en-us": "Dream's Montage",
      "zh-cn": "梦的蒙太奇",
      "zh-tw": "夢的蒙太奇",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21050",
    name: "Victory In a Blink",
    translation: {
      "en-us": "Victory In a Blink",
      "zh-cn": "胜利只在朝夕间",
      "zh-tw": "胜利只在朝夕间",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21051",
    name: "Geniuses' Greetings",
    translation: {
      "en-us": "Geniuses' Greetings",
      "zh-cn": "天才们的问候",
      "zh-tw": "天才們的問候",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21052",
    name: "Sweat Now, Cry Less",
    translation: {
      "en-us": "Sweat Now, Cry Less",
      "zh-cn": "多流汗，少流泪",
      "zh-tw": "多流汗，少流淚",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21053",
    name: "Journey, Forever Peaceful",
    translation: {
      "en-us": "Journey, Forever Peaceful",
      "zh-cn": "愿旅途永远坦然",
      "zh-tw": "願旅途永遠坦然",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21054",
    name: "The Story's Next Page",
    translation: {
      "en-us": "The Story's Next Page",
      "zh-cn": "故事的下一页",
      "zh-tw": "故事的下一頁",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21055",
    name: "Unto Tomorrow's Morrow",
    translation: {
      "en-us": "Unto Tomorrow's Morrow",
      "zh-cn": "直到明天的明天",
      "zh-tw": "直到明天的明天",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21056",
    name: "In Pursuit of the Wind",
    translation: {
      "en-us": "In Pursuit of the Wind",
      "zh-cn": "追逐风的时候",
      "zh-tw": "追逐風的時候",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21057",
    name: "The Flower Remembers",
    translation: {
      "en-us": "The Flower Remembers",
      "zh-cn": "花儿不会忘记",
      "zh-tw": "花兒不會忘記",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21058",
    name: "A Trail of Bygone Blood",
    translation: {
      "en-us": "A Trail of Bygone Blood",
      "zh-cn": "一行往日的血",
      "zh-tw": "一行往日的血",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21060",
    name: "A Dream Scented in Wheat",
    translation: {
      "en-us": "A Dream Scented in Wheat",
      "zh-cn": "氤氲麦香的梦",
      "zh-tw": "氤氳麥香的夢",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21061",
    name: "Holiday Thermae Escapade",
    translation: {
      "en-us": "Holiday Thermae Escapade",
      "zh-cn": "假日浴场大冒险",
      "zh-tw": "假日浴場大冒險",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21062",
    name: "See You at the End",
    translation: {
      "en-us": "See You at the End",
      "zh-cn": "于那终点再见",
      "zh-tw": "於那終點再見",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21064",
    name: "Mushy Shroomy's Adventures",
    translation: {
      "en-us": "Mushy Shroomy's Adventures",
      "zh-cn": "菇菇嘎嘎历险记",
      "zh-tw": "菇菇嘎嘎歷險記",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "21065",
    name: "Today's Good Luck",
    translation: {
      "en-us": "Today's Good Luck",
      "zh-cn": "今日好手气",
      "zh-tw": "今日好手氣",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "22000",
    name: "Before the Tutorial Mission Starts",
    translation: {
      "en-us": "Before the Tutorial Mission Starts",
      "zh-cn": "新手任务开始前",
      "zh-tw": "新手任務開始前",
    },
    hp: "952",
    atk: "476",
    def: "330",
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },

  {
    id: "22001",
    name: "Hey, Over Here",
    translation: {
      "en-us": "Hey, Over Here",
      "zh-cn": "嘿，我在这儿",
      "zh-tw": "嘿，我在這裡",
    },
    hp: "952",
    atk: "423",
    def: "396",
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },

  {
    id: "22002",
    name: "For Tomorrow's Journey",
    translation: {
      "en-us": "For Tomorrow's Journey",
      "zh-cn": "为了明日的旅途",
      "zh-tw": "为了明日的旅途",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "22003",
    name: "Ninja Record: Sound Hunt",
    translation: {
      "en-us": "Ninja Record: Sound Hunt",
      "zh-cn": "忍事录•音律狩猎",
      "zh-tw": "忍事錄•音律狩獵",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "22004",
    name: "The Great Cosmic Enterprise",
    translation: {
      "en-us": "The Great Cosmic Enterprise",
      "zh-cn": "宇宙大生意",
      "zh-tw": "宇宙大生意",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "22005",
    name: "The Forever Victual",
    translation: {
      "en-us": "The Forever Victual",
      "zh-cn": "永远的迷境饭",
      "zh-tw": "永遠的迷境飯",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "22006",
    name: "Fly Into a Pink Tomorrow",
    translation: {
      "en-us": "Fly Into a Pink Tomorrow",
      "zh-cn": "飞向粉色的明天",
      "zh-tw": "飛向粉色的明天",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
  },
  {
    id: "23000",
    name: "Night on the Milky Way",
    translation: {
      "en-us": "Night on the Milky Way",
      "zh-cn": "银河铁道之夜",
      "zh-tw": "銀河鐵道之夜",
    },
    hp: "1164",
    atk: "582",
    def: "396",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23001",
    name: "In the Night",
    translation: {
      "en-us": "In the Night",
      "zh-cn": "于夜色中",
      "zh-tw": "於夜色中",
    },
    hp: "1058",
    atk: "582",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23002",
    name: "Something Irreplaceable",
    translation: {
      "en-us": "Something Irreplaceable",
      "zh-cn": "无可取代的东西",
      "zh-tw": "無可取代的東西",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23003",
    name: "But the Battle Isn't Over",
    translation: {
      "en-us": "But the Battle Isn't Over",
      "zh-cn": "但战斗还未结束",
      "zh-tw": "但戰鬥還未結束",
    },
    hp: "1283",
    atk: "529",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23004",
    name: "In the Name of the World",
    translation: {
      "en-us": "In the Name of the World",
      "zh-cn": "以世界之名",
      "zh-tw": "以世界之名",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23005",
    name: "Moment of Victory",
    translation: {
      "en-us": "Moment of Victory",
      "zh-cn": "制胜的瞬间",
      "zh-tw": "制勝的瞬間",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23006",
    name: "Patience Is All You Need",
    translation: {
      "en-us": "Patience Is All You Need",
      "zh-cn": "只需等待",
      "zh-tw": "只需等待",
    },
    hp: "1058",
    atk: "582",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23007",
    name: "Incessant Rain",
    translation: {
      "en-us": "Incessant Rain",
      "zh-cn": "雨一直下",
      "zh-tw": "雨一直下",
    },
    hp: "1270",
    atk: "582",
    def: "330",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23008",
    name: "Echoes of the Coffin",
    translation: {
      "en-us": "Echoes of the Coffin",
      "zh-cn": "棺的回响",
      "zh-tw": "棺的迴響",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23009",
    name: "The Unreachable Side",
    translation: {
      "en-us": "The Unreachable Side",
      "zh-cn": "到不了的彼岸",
      "zh-tw": "到不了的彼岸",
    },
    hp: "1270",
    atk: "582",
    def: "330",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23010",
    name: "Before Dawn",
    translation: {
      "en-us": "Before Dawn",
      "zh-cn": "拂晓之前",
      "zh-tw": "拂曉之前",
    },
    hp: "1058",
    atk: "582",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23011",
    name: "She Already Shut Her Eyes",
    translation: {
      "en-us": "She Already Shut Her Eyes",
      "zh-cn": "她已闭上双眼",
      "zh-tw": "她已閉上雙眼",
    },
    hp: "1270",
    atk: "423",
    def: "529",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23012",
    name: "Sleep Like the Dead",
    translation: {
      "en-us": "Sleep Like the Dead",
      "zh-cn": "如泥酣眠",
      "zh-tw": "如泥酣眠",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23013",
    name: "Time Waits for No One",
    translation: {
      "en-us": "Time Waits for No One",
      "zh-cn": "时节不居",
      "zh-tw": "時節不居",
    },
    hp: "1270",
    atk: "476",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "24000",
    name: "On the Fall of an Aeon",
    translation: {
      "en-us": "On the Fall of an Aeon",
      "zh-cn": "记一位星神的陨落",
      "zh-tw": "記一位星神的隕落",
    },
    hp: "1058",
    atk: "529",
    def: "396",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "24001",
    name: "Cruising in the Stellar Sea",
    translation: {
      "en-us": "Cruising in the Stellar Sea",
      "zh-cn": "星海巡航",
      "zh-tw": "星海巡航",
    },
    hp: "952",
    atk: "529",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "24002",
    name: "Texture of Memories",
    translation: {
      "en-us": "Texture of Memories",
      "zh-cn": "记忆的质料",
      "zh-tw": "記憶的質料",
    },
    hp: "1058",
    atk: "423",
    def: "529",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "24003",
    name: "Solitary Healing",
    translation: {
      "en-us": "Solitary Healing",
      "zh-cn": "孤独的疗愈",
      "zh-tw": "孤獨的療愈",
    },
    hp: "1058",
    atk: "529",
    def: "396",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },

  {
    id: "24004",
    name: "Eternal Calculus",
    translation: {
      "en-us": "Eternal Calculus",
      "zh-cn": "不息的演算",
      "zh-tw": "不息的演算",
    },
    hp: "1058",
    atk: "529",
    def: "396",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },

  {
    id: "24005",
    name: "Memory's Curtain Never Falls",
    translation: {
      "en-us": "Memory's Curtain Never Falls",
      "zh-cn": "记忆永不落幕",
      "zh-tw": "记忆永不落幕",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23014",
    name: "I Shall Be My Own Sword",
    translation: {
      "en-us": "I Shall Be My Own Sword",
      "zh-cn": "此身为剑",
      "zh-tw": "此身為劍",
    },
    hp: "1164",
    atk: "582",
    def: "396",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23015",
    name: "Brighter Than the Sun",
    translation: {
      "en-us": "Brighter Than the Sun",
      "zh-cn": "比阳光更明亮的",
      "zh-tw": "比陽光更明亮的",
    },
    hp: "1058",
    atk: "635",
    def: "396",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23016",
    name: "Worrisome, Blissful",
    translation: {
      "en-us": "Worrisome, Blissful",
      "zh-cn": "烦恼着，幸福着",
      "zh-tw": "煩惱著，幸福著",
    },
    hp: "1058",
    atk: "582",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23017",
    name: "	Night of Fright",
    translation: {
      "en-us": "Night of Fright",
      "zh-cn": "惊魂夜",
      "zh-tw": "驚魂夜",
    },
    hp: "1164",
    atk: "476",
    def: "529",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23018",
    name: "An Instant Before A Gaze",
    translation: {
      "en-us": "An Instant Before A Gaze",
      "zh-cn": "片刻，留在眼底",
      "zh-tw": "片刻，留在眼底",
    },
    hp: "1058",
    atk: "582",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23019",
    name: "Past Self in Mirror",
    translation: {
      "en-us": "Past Self in Mirror",
      "zh-cn": "镜中故我",
      "zh-tw": "鏡中故我",
    },
    hp: "1058",
    atk: "529",
    def: "529",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23020",
    name: "Baptism of Pure Thought",
    translation: {
      "en-us": "Baptism of Pure Thought",
      "zh-cn": "纯粹思维的洗礼",
      "zh-tw": "純粹思維的洗禮",
    },
    hp: "953",
    atk: "582",
    def: "529",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },

  {
    id: "23021",
    name: "Earthly Escapade",
    translation: {
      "en-us": "Earthly Escapade",
      "zh-cn": "游戏尘寰",
      "zh-tw": "遊戲塵寰",
    },
    hp: "1164",
    atk: "529",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23022",
    name: "Reforged Remembrance",
    translation: {
      "en-us": "Reforged Remembrance",
      "zh-cn": "重塑时光之忆",
      "zh-tw": "重塑時光之憶",
    },
    hp: "1058",
    atk: "582",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },

  {
    id: "23023",
    name: "Inherently Unjust Destiny",
    translation: {
      "en-us": "Inherently Unjust Destiny",
      "zh-cn": "命运从未公平",
      "zh-tw": "命運從未公平",
    },
    hp: "1058",
    atk: "423",
    def: "661",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23024",
    name: "Along the Passing Shore",
    translation: {
      "en-us": "Along the Passing Shore",
      "zh-cn": "行于流逝的岸",
      "zh-tw": "行於流逝的岸",
    },
    hp: "1058",
    atk: "582",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23025",
    name: "Whereabouts Should Dreams Rest",
    translation: {
      "en-us": "Whereabouts Should Dreams Rest",
      "zh-cn": "梦应归于何处",
      "zh-tw": "夢應歸於何處",
    },
    hp: "1058",
    atk: "582",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },

  {
    id: "23026",
    name: "Flowing Nightglow",
    translation: {
      "en-us": "Flowing Nightglow",
      "zh-cn": "夜色流光溢彩",
      "zh-tw": "夜色流光溢彩",
    },
    hp: "953",
    atk: "635",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },

  {
    id: "23027",
    name: "Sailing Towards a Second Life",
    translation: {
      "en-us": "Sailing Towards a Second Life",
      "zh-cn": "驶向第二次生命",
      "zh-tw": "駛向第二次生命",
    },
    hp: "953",
    atk: "635",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },

  {
    id: "23028",
    name: "Yet Hope Is Priceless",
    translation: {
      "en-us": "Yet Hope Is Priceless",
      "zh-cn": "偏偏希望无价",
      "zh-tw": "偏偏希望無價",
    },
    hp: "953",
    atk: "582",
    def: "529",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },

  {
    id: "23029",
    name: "Those Many Springs",
    translation: {
      "en-us": "Those Many Springs",
      "zh-cn": "那无数个春天",
      "zh-tw": "那無數個春天",
    },
    hp: "953",
    atk: "582",
    def: "529",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23030",
    name: "Dance at Sunset",
    translation: {
      "en-us": "Dance at Sunset",
      "zh-cn": "落日时起舞",
      "zh-tw": "落日時起舞",
    },
    hp: "1058",
    atk: "582",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23031",
    name: "I Venture Forth to Hunt",
    translation: {
      "en-us": "I Venture Forth to Hunt",
      "zh-cn": "我将，巡征追猎",
      "zh-tw": "我將，巡徵追獵",
    },
    hp: "953",
    atk: "635",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },

  {
    id: "23032",
    name: "Scent Alone Stays True",
    translation: {
      "en-us": "Scent Alone Stays True",
      "zh-cn": "唯有香如故",
      "zh-tw": "唯有香如故",
    },
    hp: "1058",
    atk: "529",
    def: "529",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },

  {
    id: "23033",
    name: "Ninjutsu Inscription: Dazzling Evilbreaker",
    translation: {
      "en-us": "Ninjutsu Inscription: Dazzling Evilbreaker",
      "zh-cn": "忍法帖•缭乱破魔",
      "zh-tw": "忍法帖•繚亂破魔",
    },
    hp: "953",
    atk: "582",
    def: "529",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23034",
    name: "A Grounded Ascent",
    translation: {
      "en-us": "A Grounded Ascent",
      "zh-cn": "回到大地的飞行",
      "zh-tw": "回到大地的飛行",
    },
    hp: "1164",
    atk: "476",
    def: "529",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23035",
    name: "Long Road Leads Home",
    translation: {
      "en-us": "Long Road Leads Home",
      "zh-cn": "长路终有归途",
      "zh-tw": "長路終有歸途",
    },
    hp: "953",
    atk: "476",
    def: "661",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23036",
    name: "Time Woven Into Gold",
    translation: {
      "en-us": "Time Woven Into Gold",
      "zh-cn": "将光阴织成黄金",
      "zh-tw": "將光陰織成黃金",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23037",
    name: "Into the Unreachable Veil",
    translation: {
      "en-us": "Into the Unreachable Veil",
      "zh-cn": "向着不可追问处",
      "zh-tw": "向著不可追問處",
    },
    hp: "953",
    atk: "635",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23038",
    name: "If Time Were a Flower",
    translation: {
      "en-us": "If Time Were a Flower",
      "zh-cn": "如果时间是一朵花",
      "zh-tw": "如果時間是一朵花",
    },
    hp: "1270",
    atk: "529",
    def: "396",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23039",
    name: "Flame of Blood, Blaze My Path",
    translation: {
      "en-us": "Flame of Blood, Blaze My Path",
      "zh-cn": "血火啊，燃烧前路",
      "zh-tw": "血火啊，燃燒前路",
    },
    hp: "1376",
    atk: "476",
    def: "396",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23040",
    name: "Make Farewells More Beautiful",
    translation: {
      "en-us": "Make Farewells More Beautiful",
      "zh-cn": "让告别，更美一些",
      "zh-tw": "讓告別，更美一點",
    },
    hp: "1270",
    atk: "529",
    def: "396",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23041",
    name: "Life Should Be Cast to Flames",
    translation: {
      "en-us": "Life Should Be Cast to Flames",
      "zh-cn": "生命当付之一炬",
      "zh-tw": "生命當付之一炬",
    },
    hp: "953",
    atk: "582",
    def: "529",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23042",
    name: "Long May Rainbows Adorn the Sky",
    translation: {
      "en-us": "Long May Rainbows Adorn the Sky",
      "zh-cn": "愿虹光永驻天空",
      "zh-tw": "願虹光永駐天空",
    },
    hp: "1164",
    atk: "476",
    def: "529",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23043",
    name: "Lies Dance on the Breeze",
    translation: {
      "en-us": "Lies Dance on the Breeze",
      "zh-cn": "谎言在风中飘扬",
      "zh-tw": "謊言在風中飄揚",
    },
    hp: "953",
    atk: "582",
    def: "529",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23044",
    name: "Thus Burns the Dawn",
    translation: {
      "en-us": "Thus Burns the Dawn",
      "zh-cn": "黎明恰如此燃烧",
      "zh-tw": "黎明恰如此燃燒",
    },
    hp: "953",
    atk: "688",
    def: "396",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23045",
    name: "A Thankless Coronation",
    translation: {
      "en-us": "A Thankless Coronation",
      "zh-cn": "没有回报的加冕",
      "zh-tw": "沒有回報的加冕",
    },
    hp: "953",
    atk: "582",
    def: "529",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23046",
    name: "The Hell Where Ideals Burn",
    translation: {
      "en-us": "The Hell Where Ideals Burn",
      "zh-cn": "理想燃烧的地狱",
      "zh-tw": "理想燃燒的地獄",
    },
    hp: "953",
    atk: "582",
    def: "529",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23047",
    name: "Why Does the Ocean Sing",
    translation: {
      "en-us": "Why Does the Ocean Sing",
      "zh-cn": "海洋为何而歌",
      "zh-tw": "海洋為何而歌",
    },
    hp: "953",
    atk: "582",
    def: "529",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23048",
    name: "Epoch Etched in Golden Blood",
    translation: {
      "en-us": "Epoch Etched in Golden Blood",
      "zh-cn": "金血铭刻的时代",
      "zh-tw": "金血銘刻的時代",
    },
    hp: "953",
    atk: "582",
    def: "529",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23049",
    name: "To Evernight's Stars",
    translation: {
      "en-us": "To Evernight's Stars",
      "zh-cn": "致长夜的星光",
      "zh-tw": "致長夜的星光",
    },
    hp: "1164",
    atk: "529",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23050",
    name: "Never Forget Her Flame",
    translation: {
      "en-us": "Never Forget Her Flame",
      "zh-cn": "勿忘她的火焰",
      "zh-tw": "勿忘她的火焰",
    },
    hp: "1164",
    atk: "529",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23051",
    name: "Though Worlds Apart",
    translation: {
      "en-us": "Though Worlds Apart",
      "zh-cn": "纵然山河万程",
      "zh-tw": "縱然山河萬程",
    },
    hp: "1058",
    atk: "582",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23052",
    name: "This Love, Forever",
    translation: {
      "en-us": "This Love, Forever",
      "zh-cn": "爱如此刻永恒",
      "zh-tw": "愛如此刻永恆",
    },
    hp: "1270",
    atk: "476",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23053",
    name: "Dazzled by a Flowery World",
    translation: {
      "en-us": "Dazzled by a Flowery World",
      "zh-cn": "花花世界迷人眼",
      "zh-tw": "花花世界迷人眼",
    },
    hp: "1058",
    atk: "582",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23054",
    name: "When She Decided to See",
    translation: {
      "en-us": "When She Decided to See",
      "zh-cn": "当她决定看见",
      "zh-tw": "當她決定看見",
    },
    hp: "1058",
    atk: "529",
    def: "529",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23056",
    name: "The Finale of a Lie",
    translation: {
      "en-us": "The Finale of a Lie",
      "zh-cn": "一场谎言的终幕",
      "zh-tw": "一場謊言的終幕",
    },
    hp: "847",
    atk: "529",
    def: "635",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23057",
    name: "Welcome to the Cosmic City",
    translation: {
      "en-us": "Welcome to the Cosmic City",
      "zh-cn": "欢迎来到银河城",
      "zh-tw": "歡迎來到銀河城",
    },
    hp: "1164",
    atk: "529",
    def: "476",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23058",
    name: "Until the Flowers Bloom Again",
    translation: {
      "en-us": "Until the Flowers Bloom Again",
      "zh-cn": "邂逅于下一个花季",
      "zh-tw": "邂逅於下一個花季",
    },
    hp: "953",
    atk: "635",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
  {
    id: "23059",
    name: "Reforged in Hellfire",
    translation: {
      "en-us": "Reforged in Hellfire",
      "zh-cn": "灼尽炼狱的新骸",
      "zh-tw": "灼盡煉獄的新骸",
    },
    hp: "1376",
    atk: "423",
    def: "463",
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
  },
];

export const briefCharacterRows = [
  {
    id: "1008",
    name: "arlan",
    translation: {
      "en-us": "Arlan",
      "zh-cn": "阿兰",
      "zh-tw": "阿蘭",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Destruction",
    element: "Lightning",
    pathIcon: destructionIcon,
    elementIcon: lightningIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1009",
    name: "asta",
    translation: {
      "en-us": "Asta",
      "zh-cn": "艾丝妲",
      "zh-tw": "艾絲妲",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Harmony",
    element: "Fire",
    pathIcon: harmonyIcon,
    elementIcon: fireIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1211",
    name: "bailu",
    translation: {
      "en-us": "Bailu",
      "zh-cn": "白露",
      "zh-tw": "白露",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Abundance",
    element: "Lightning",
    pathIcon: abundanceIcon,
    elementIcon: lightningIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1217",
    name: "huohuo",
    translation: {
      "en-us": "Huohuo",
      "zh-cn": "藿藿",
      "zh-tw": "藿藿",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Abundance",
    element: "Wind",
    pathIcon: abundanceIcon,
    elementIcon: windIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1218",
    name: "jiaoqiu",
    translation: {
      "en-us": "Jiaoqiu",
      "zh-cn": "椒丘",
      "zh-tw": "椒丘",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Fire",
    pathIcon: nihilityIcon,
    elementIcon: fireIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1220",
    name: "feixiao",
    translation: {
      "en-us": "Feixiao",
      "zh-cn": "飞霄",
      "zh-tw": "飛霄",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Hunt",
    element: "Wind",
    pathIcon: huntIcon,
    elementIcon: windIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1221",
    name: "yunli",
    translation: {
      "en-us": "Yunli",
      "zh-cn": "云璃",
      "zh-tw": "雲璃",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Physical",
    pathIcon: destructionIcon,
    elementIcon: physicalIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1222",
    name: "lingsha",
    translation: {
      "en-us": "Lingsha",
      "zh-cn": "灵砂",
      "zh-tw": "靈砂",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Abundance",
    element: "Fire",
    pathIcon: abundanceIcon,
    elementIcon: fireIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1223",
    name: "moze",
    translation: {
      "en-us": "Moze",
      "zh-cn": "貊泽",
      "zh-tw": "貊澤",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Hunt",
    element: "Wind",
    pathIcon: huntIcon,
    elementIcon: windIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1205",
    name: "blade",
    translation: {
      "en-us": "Blade",
      "zh-cn": "刃",
      "zh-tw": "刃",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Wind",
    pathIcon: destructionIcon,
    elementIcon: windIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1101",
    name: "bronya",
    translation: {
      "en-us": "Bronya",
      "zh-cn": "布洛妮娅",
      "zh-tw": "布洛妮婭",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Harmony",
    element: "Wind",
    pathIcon: harmonyIcon,
    elementIcon: windIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1107",
    name: "clara",
    translation: {
      "en-us": "Clara",
      "zh-cn": "克拉拉",
      "zh-tw": "克拉拉",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Physical",
    pathIcon: destructionIcon,
    elementIcon: physicalIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1301",
    name: "gallagher",
    translation: {
      "en-us": "Gallagher",
      "zh-cn": "加拉赫",
      "zh-tw": "加拉赫",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Abundance",
    element: "Fire",
    pathIcon: abundanceIcon,
    elementIcon: fireIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1302",
    name: "argenti",
    translation: {
      "en-us": "Argenti",
      "zh-cn": "银枝",
      "zh-tw": "銀枝",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Erudition",
    element: "Physical",
    pathIcon: eruditionIcon,
    elementIcon: physicalIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1303",
    name: "ruan-mei",
    translation: {
      "en-us": "Ruan Mei",
      "zh-cn": "阮•梅",
      "zh-tw": "阮•梅",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Harmony",
    element: "Ice",
    pathIcon: harmonyIcon,
    elementIcon: iceIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1304",
    name: "aventurine",
    translation: {
      "en-us": "Aventurine",
      "zh-cn": "砂金",
      "zh-tw": "砂金",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Preservation",
    element: "Imaginary",
    pathIcon: preservationIcon,
    elementIcon: imaginaryIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1305",
    name: "dr._ratio",
    translation: {
      "en-us": "Dr. Ratio",
      "zh-cn": "真理医生",
      "zh-tw": "真理醫生",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Hunt",
    element: "Imaginary",
    pathIcon: huntIcon,
    elementIcon: imaginaryIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1306",
    name: "sparkle",
    translation: {
      "en-us": "Sparkle",
      "zh-cn": "花火",
      "zh-tw": "花火",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Harmony",
    element: "Quantum",
    pathIcon: harmonyIcon,
    elementIcon: quantumIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1307",
    name: "black_swan",
    translation: {
      "en-us": "Black Swan",
      "zh-cn": "黑天鹅",
      "zh-tw": "黑天鵝",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Wind",
    pathIcon: nihilityIcon,
    elementIcon: windIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1308",
    name: "acheron",
    translation: {
      "en-us": "Acheron",
      "zh-cn": "黄泉",
      "zh-tw": "黃泉",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Lightning",
    pathIcon: nihilityIcon,
    elementIcon: lightningIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1309",
    name: "robin",
    translation: {
      "en-us": "Robin",
      "zh-cn": "知更鸟",
      "zh-tw": "知更鳥",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Harmony",
    element: "Physical",
    pathIcon: harmonyIcon,
    elementIcon: physicalIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1310",
    name: "firefly",
    translation: {
      "en-us": "Firefly",
      "zh-cn": "流萤",
      "zh-tw": "流螢",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Fire",
    pathIcon: destructionIcon,
    elementIcon: fireIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1312",
    name: "misha",
    translation: {
      "en-us": "Misha",
      "zh-cn": "米沙",
      "zh-tw": "米沙",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Destruction",
    element: "Ice",
    pathIcon: destructionIcon,
    elementIcon: iceIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1313",
    name: "sunday",
    translation: {
      "en-us": "Sunday",
      "zh-cn": "星期日",
      "zh-tw": "星期日",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Harmony",
    element: "Imaginary",
    pathIcon: harmonyIcon,
    elementIcon: imaginaryIcon,
    type: "live",
    guide: false,
  },

  {
    id: "1314",
    name: "jade",
    translation: {
      "en-us": "Jade",
      "zh-cn": "翡翠",
      "zh-tw": "翡翠",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Erudition",
    element: "Quantum",
    pathIcon: eruditionIcon,
    elementIcon: quantumIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1315",
    name: "boothill",
    translation: {
      "en-us": "Boothill",
      "zh-cn": "波提欧",
      "zh-tw": "波提歐",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Hunt",
    element: "Physical",
    pathIcon: huntIcon,
    elementIcon: physicalIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1317",
    name: "rappa",
    translation: {
      "en-us": "Rappa",
      "zh-cn": "乱破",
      "zh-tw": "亂破",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Erudition",
    element: "Imaginary",
    pathIcon: eruditionIcon,
    elementIcon: imaginaryIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1321",
    name: "the-dahlia",
    translation: {
      "en-us": "The Dahlia",
      "zh-cn": "大丽花",
      "zh-tw": "大理花",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Fire",
    pathIcon: nihilityIcon,
    elementIcon: fireIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1401",
    name: "the-herta",
    translation: {
      "en-us": "The Herta",
      "zh-cn": "大黑塔",
      "zh-tw": "大黑塔",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Erudition",
    element: "Ice",
    pathIcon: eruditionIcon,
    elementIcon: iceIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1402",
    name: "aglaea",
    translation: {
      "en-us": "Aglaea",
      "zh-cn": "阿格莱雅",
      "zh-tw": "阿格萊雅",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Remembrance",
    element: "Lightning",
    pathIcon: remembranceIcon,
    elementIcon: lightningIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1403",
    name: "tribbie",
    translation: {
      "en-us": "Tribbie",
      "zh-cn": "缇宝",
      "zh-tw": "緹寶",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Harmony",
    element: "Quantum",
    pathIcon: harmonyIcon,
    elementIcon: quantumIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1404",
    name: "mydei",
    translation: {
      "en-us": "Mydei",
      "zh-cn": "万敌",
      "zh-tw": "萬敵",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Imaginary",
    pathIcon: destructionIcon,
    elementIcon: imaginaryIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1405",
    name: "anaxa",
    translation: {
      "en-us": "Anaxa",
      "zh-cn": "那刻夏",
      "zh-tw": "那刻夏",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Erudition",
    element: "Wind",
    pathIcon: eruditionIcon,
    elementIcon: windIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1406",
    name: "cipher",
    translation: {
      "en-us": "Cipher",
      "zh-cn": "赛飞儿",
      "zh-tw": "賽飛兒",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Quantum",
    pathIcon: nihilityIcon,
    elementIcon: quantumIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1407",
    name: "castorice",
    translation: {
      "en-us": "Castorice",
      "zh-cn": "遐蝶",
      "zh-tw": "遐蝶",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Remembrance",
    element: "Quantum",
    pathIcon: remembranceIcon,
    elementIcon: quantumIcon,
    type: "upcoming",
    guide: false,
  },
  {
    id: "1408",
    name: "phainon",
    translation: {
      "en-us": "Phainon",
      "zh-cn": "白厄",
      "zh-tw": "白厄",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Physical",
    pathIcon: destructionIcon,
    elementIcon: physicalIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1409",
    name: "hyacine",
    translation: {
      "en-us": "Hyacine",
      "zh-cn": "风堇",
      "zh-tw": "風堇",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Remembrance",
    element: "Wind",
    pathIcon: remembranceIcon,
    elementIcon: windIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1410",
    name: "hysilens",
    translation: {
      "en-us": "Hysilens",
      "zh-cn": "海瑟音",
      "zh-tw": "海瑟音",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Physical",
    pathIcon: nihilityIcon,
    elementIcon: physicalIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1412",
    name: "cerydra",
    translation: {
      "en-us": "Cerydra",
      "zh-cn": "刻律德菈",
      "zh-tw": "刻律德菈",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Harmony",
    element: "Wind",
    pathIcon: harmonyIcon,
    elementIcon: windIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1413",
    name: "evernight",
    translation: {
      "en-us": "Evernight",
      "zh-cn": "长夜月",
      "zh-tw": "長夜月",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Remembrance",
    element: "Ice",
    pathIcon: remembranceIcon,
    elementIcon: iceIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1414",
    name: "dan-heng-permansor-terrae",
    translation: {
      "en-us": "Dan Heng • Permansor Terrae",
      "zh-cn": "丹恒•腾荒",
      "zh-tw": "丹恆•騰荒",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Preservation",
    element: "Physical",
    pathIcon: preservationIcon,
    elementIcon: physicalIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1415",
    name: "cyrene",
    translation: {
      "en-us": "Cyrene",
      "zh-cn": "昔涟",
      "zh-tw": "昔漣",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Remembrance",
    element: "Ice",
    pathIcon: remembranceIcon,
    elementIcon: iceIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1501",
    name: "sparxie",
    translation: {
      "en-us": "Sparxie",
      "zh-cn": "火花",
      "zh-tw": "火花",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Elation",
    element: "Fire",
    pathIcon: elationIcon,
    elementIcon: fireIcon,
    type: "upcoming",
    guide: false,
  },
  {
    id: "1502",
    name: "yao-guang",
    translation: {
      "en-us": "Yao Guang",
      "zh-cn": "爻光",
      "zh-tw": "爻光",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Elation",
    element: "Physical",
    pathIcon: elationIcon,
    elementIcon: physicalIcon,
    type: "upcoming",
    guide: false,
  },
  {
    id: "1504",
    name: "ashveil",
    translation: {
      "en-us": "Ashveil",
      "zh-cn": "不死途",
      "zh-tw": "不死途",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Hunt",
    element: "Lightning",
    pathIcon: huntIcon,
    elementIcon: lightningIcon,
    type: "upcoming",
    guide: false,
  },
  {
    id: "1505",
    name: "evanescia",
    translation: {
      "en-us": "Evanescia",
      "zh-cn": "绯英",
      "zh-tw": "緋英",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Elation",
    element: "Physical",
    pathIcon: elationIcon,
    elementIcon: physicalIcon,
    type: "upcoming",
    guide: false,
  },
  {
    id: "1506",
    name: "silver-wolf-lv999",
    translation: {
      "en-us": "Silver Wolf LV.999",
      "zh-cn": "银狼LV.999",
      "zh-tw": "銀狼LV.999",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Elation",
    element: "Imaginary",
    pathIcon: elationIcon,
    elementIcon: imaginaryIcon,
    type: "upcoming",
    guide: false,
  },
  {
    id: "1507",
    name: "mortenax-blade",
    translation: {
      "en-us": "Mortenax Blade",
      "zh-cn": "千冶•刃",
      "zh-tw": "千冶•刃",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Fire",
    pathIcon: nihilityIcon,
    elementIcon: fireIcon,
    type: "upcoming",
    guide: false,
  },
  {
    id: "1002",
    name: "dan-heng",
    translation: {
      "en-us": "Dan Heng",
      "zh-cn": "丹恒",
      "zh-tw": "丹恆",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Hunt",
    element: "Wind",
    pathIcon: huntIcon,
    elementIcon: windIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1104",
    name: "gepard",
    translation: {
      "en-us": "Gepard",
      "zh-cn": "杰帕德",
      "zh-tw": "傑帕德",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Preservation",
    element: "Ice",
    pathIcon: preservationIcon,
    elementIcon: iceIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1013",
    name: "herta",
    translation: {
      "en-us": "Herta",
      "zh-cn": "黑塔",
      "zh-tw": "黑塔",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Erudition",
    element: "Ice",
    pathIcon: eruditionIcon,
    elementIcon: iceIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1014",
    name: "saber",
    translation: {
      "en-us": "Saber",
      "zh-cn": "Saber",
      "zh-tw": "Saber",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Wind",
    pathIcon: destructionIcon,
    elementIcon: windIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1015",
    name: "archer",
    translation: {
      "en-us": "Archer",
      "zh-cn": "Archer",
      "zh-tw": "Archer",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Hunt",
    element: "Quantum",
    pathIcon: huntIcon,
    elementIcon: quantumIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1003",
    name: "himeko",
    translation: {
      "en-us": "Himeko",
      "zh-cn": "姬子",
      "zh-tw": "姬子",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Erudition",
    element: "Fire",
    pathIcon: eruditionIcon,
    elementIcon: fireIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1109",
    name: "hook",
    translation: {
      "en-us": "Hook",
      "zh-cn": "虎克",
      "zh-tw": "虎克",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Destruction",
    element: "Fire",
    pathIcon: destructionIcon,
    elementIcon: fireIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1210",
    name: "guinaifen",
    translation: {
      "en-us": "Guinaifen",
      "zh-cn": "桂乃芬",
      "zh-tw": "桂乃芬",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Nihility",
    element: "Fire",
    pathIcon: nihilityIcon,
    elementIcon: fireIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1112",
    name: "topaz%26numby",
    translation: {
      "en-us": "Topaz & Numby",
      "zh-cn": "托帕 & 账账",
      "zh-tw": "托帕 & 帳賬",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Hunt",
    element: "Fire",
    pathIcon: huntIcon,
    elementIcon: fireIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
    guide: false,
  },
  {
    id: "1212",
    name: "jingliu",
    translation: {
      "en-us": "Jingliu",
      "zh-cn": "镜流",
      "zh-tw": "鏡流",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Ice",
    pathIcon: destructionIcon,
    elementIcon: iceIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
    guide: false,
  },
  {
    id: "1204",
    name: "jing-yuan",
    translation: {
      "en-us": "Jing Yuan",
      "zh-cn": "景元",
      "zh-tw": "景元",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Erudition",
    element: "Lightning",
    pathIcon: eruditionIcon,
    elementIcon: lightningIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1005",
    name: "kafka",
    translation: {
      "en-us": "Kafka",
      "zh-cn": "卡芙卡",
      "zh-tw": "卡芙卡",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Lightning",
    pathIcon: nihilityIcon,
    elementIcon: lightningIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1215",
    name: "hanya",
    translation: {
      "en-us": "Hanya",
      "zh-cn": "寒鸦",
      "zh-tw": "寒鴉",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Harmony",
    element: "Physical",
    pathIcon: harmonyIcon,
    elementIcon: physicalIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1111",
    name: "luka",
    translation: {
      "en-us": "Luka",
      "zh-cn": "卢卡",
      "zh-tw": "盧卡",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Nihility",
    element: "Physical",
    pathIcon: nihilityIcon,
    elementIcon: physicalIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1203",
    name: "luocha",
    translation: {
      "en-us": "Luocha",
      "zh-cn": "罗刹",
      "zh-tw": "羅剎",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Abundance",
    element: "Imaginary",
    pathIcon: abundanceIcon,
    elementIcon: imaginaryIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1001",
    name: "march7th",
    translation: {
      "en-us": "March 7th",
      "zh-cn": "三月七",
      "zh-tw": "三月七",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Preservation",
    element: "Ice",
    pathIcon: preservationIcon,
    elementIcon: iceIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1224",
    name: "march7th-hunt",
    translation: {
      "en-us": "March 7th",
      "zh-cn": "三月七",
      "zh-tw": "三月七",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Hunt",
    element: "Imaginary",
    pathIcon: huntIcon,
    elementIcon: imaginaryIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1225",
    name: "fugue",
    translation: {
      "en-us": "Fugue",
      "zh-cn": "忘归人",
      "zh-tw": "忘歸人",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Fire",
    pathIcon: nihilityIcon,
    elementIcon: fireIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1105",
    name: "natasha",
    translation: {
      "en-us": "Natasha",
      "zh-cn": "娜塔莎",
      "zh-tw": "娜塔莎",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Abundance",
    element: "Physical",
    pathIcon: abundanceIcon,
    elementIcon: physicalIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1106",
    name: "pela",
    translation: {
      "en-us": "Pela",
      "zh-cn": "佩拉",
      "zh-tw": "佩拉",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Nihility",
    element: "Ice",
    pathIcon: nihilityIcon,
    elementIcon: iceIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1201",
    name: "qingque",
    translation: {
      "en-us": "Qingque",
      "zh-cn": "青雀",
      "zh-tw": "青雀",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Erudition",
    element: "Quantum",
    color: "#1C29BA",
    pathIcon: eruditionIcon,
    elementIcon: quantumIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1108",
    name: "sampo",
    translation: {
      "en-us": "Sampo",
      "zh-cn": "桑博",
      "zh-tw": "桑博",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Nihility",
    element: "Wind",
    pathIcon: nihilityIcon,
    elementIcon: windIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1102",
    name: "seele",
    translation: {
      "en-us": "Seele",
      "zh-cn": "希儿",
      "zh-tw": "希兒",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Hunt",
    element: "Quantum",
    pathIcon: huntIcon,
    elementIcon: quantumIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1103",
    name: "serval",
    translation: {
      "en-us": "Serval",
      "zh-cn": "希露瓦",
      "zh-tw": "希露瓦",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Erudition",
    element: "Lightning",
    pathIcon: eruditionIcon,
    elementIcon: lightningIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1006",
    name: "silver-wolf",
    translation: {
      "en-us": "Silver Wolf",
      "zh-cn": "银狼",
      "zh-tw": "銀狼",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Quantum",
    pathIcon: nihilityIcon,
    elementIcon: quantumIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1206",
    name: "sushang",
    translation: {
      "en-us": "Sushang",
      "zh-cn": "素裳",
      "zh-tw": "素裳",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Hunt",
    element: "Physical",
    pathIcon: huntIcon,
    elementIcon: physicalIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1202",
    name: "tingyun",
    translation: {
      "en-us": "Tingyun",
      "zh-cn": "停云",
      "zh-tw": "停雲",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Harmony",
    element: "Lightning",
    pathIcon: harmonyIcon,
    elementIcon: lightningIcon,
    type: "live",
    guide: false,
  },
  {
    id: "8001",
    name: "trail-blazer-destruction",
    translation: {
      "en-us": "Trail Blazer",
      "zh-cn": "开拓者",
      "zh-tw": "開拓者",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Physical",
    pathIcon: destructionIcon,
    elementIcon: physicalIcon,
    type: "live",
    guide: false,
  },
  {
    id: "8002",
    name: "trail-blazer-destruction",
    translation: {
      "en-us": "Trail Blazer",
      "zh-cn": "开拓者",
      "zh-tw": "開拓者",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Physical",
    pathIcon: destructionIcon,
    elementIcon: physicalIcon,
    type: "live",
    guide: false,
  },
  {
    id: "8003",
    name: "trail-blazer-preservation",
    translation: {
      "en-us": "Trail Blazer",
      "zh-cn": "开拓者",
      "zh-tw": "開拓者",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Preservation",
    element: "Fire",
    pathIcon: preservationIcon,
    elementIcon: fireIcon,
    type: "live",
    guide: false,
  },
  {
    id: "8004",
    name: "trail-blazer-preservation",
    translation: {
      "en-us": "Trail Blazer",
      "zh-cn": "开拓者",
      "zh-tw": "開拓者",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Preservation",
    element: "Fire",
    pathIcon: preservationIcon,
    elementIcon: fireIcon,
    type: "live",
    guide: false,
  },
  {
    id: "8005",
    name: "trail-blazer-harmony",
    translation: {
      "en-us": "Trail Blazer",
      "zh-cn": "开拓者",
      "zh-tw": "開拓者",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Harmony",
    element: "Imaginary",
    pathIcon: harmonyIcon,
    elementIcon: imaginaryIcon,
    type: "live",
    guide: false,
  },
  {
    id: "8006",
    name: "trail-blazer-harmony",
    translation: {
      "en-us": "Trail Blazer",
      "zh-cn": "开拓者",
      "zh-tw": "開拓者",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Harmony",
    element: "Imaginary",
    pathIcon: harmonyIcon,
    elementIcon: imaginaryIcon,
    type: "live",
    guide: false,
  },
  {
    id: "8007",
    name: "trail-blazer-remembrance",
    translation: {
      "en-us": "Trail Blazer",
      "zh-cn": "开拓者",
      "zh-tw": "開拓者",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Remembrance",
    element: "Ice",
    pathIcon: remembranceIcon,
    elementIcon: iceIcon,
    type: "live",
    guide: false,
  },
  {
    id: "8008",
    name: "trail-blazer-remembrance",
    translation: {
      "en-us": "Trail Blazer",
      "zh-cn": "开拓者",
      "zh-tw": "開拓者",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Remembrance",
    element: "Ice",
    pathIcon: remembranceIcon,
    elementIcon: iceIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1004",
    name: "welt",
    translation: {
      "en-us": "Welt",
      "zh-cn": "瓦尔特",
      "zh-tw": "瓦爾特",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Imaginary",
    pathIcon: nihilityIcon,
    elementIcon: imaginaryIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1209",
    name: "yanqing",
    translation: {
      "en-us": "Yanqing",
      "zh-cn": "彦卿",
      "zh-tw": "彥卿",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Hunt",
    element: "Ice",
    pathIcon: huntIcon,
    elementIcon: iceIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1207",
    name: "yukong",
    translation: {
      "en-us": "Yukong",
      "zh-cn": "驭空",
      "zh-tw": "馭空",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Harmony",
    element: "Imaginary",
    pathIcon: harmonyIcon,
    elementIcon: imaginaryIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1213",
    name: "dan-heng-imbibitor-lunae",
    translation: {
      "en-us": "Dan Heng • Imbibitor Lunae",
      "zh-cn": "丹恒 • 饮月君",
      "zh-tw": "丹恆 • 飲月君",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Imaginary",
    pathIcon: destructionIcon,
    elementIcon: imaginaryIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1214",
    name: "xueyi",
    translation: {
      "en-us": "Xueyi",
      "zh-cn": "雪衣",
      "zh-tw": "雪衣",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Destruction",
    element: "Quantum",
    pathIcon: destructionIcon,
    elementIcon: quantumIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1208",
    name: "fuxuan",
    translation: {
      "en-us": "Fu Xuan",
      "zh-cn": "符玄",
      "zh-tw": "符玄",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Preservation",
    element: "Quantum",
    pathIcon: preservationIcon,
    elementIcon: quantumIcon,
    type: "live",
    guide: false,
  },
  {
    id: "1110",
    name: "lynx",
    translation: {
      "en-us": "Lynx",
      "zh-cn": "玲可",
      "zh-tw": "玲可",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Abundance",
    element: "Quantum",
    pathIcon: abundanceIcon,
    elementIcon: quantumIcon,
    type: "live",
    guide: false,
  },
];

export const characterRows = [
  {
    id: "1008",
    name: "arlan",
    translation: {
      "en-us": "Arlan",
      "zh-cn": "阿兰",
      "zh-tw": "阿蘭",
    },
    story: [
      {
        "en-us":
          "The inarticulate head of Herta Space Station's Security Department.",
        "zh-cn": "不善言辞的空间站「黑塔」防卫科负责人。",
        "zh-tw": "不善言辭的空間站「黑塔」防衛科負責人。",
      },
      {
        "en-us":
          "While scientific research is beyond his understanding, Arlan is willing to risk his life to protect the staff who value research so very much. He is used to the pain and wears his scars like badges of honor.",
        "zh-cn":
          "虽然不懂科研，但为了保护珍视研究的空间站科员顺利完成他们的研究，阿兰可以拼上性命。他早已习惯疼痛，并将负伤视作勋章。",
        "zh-tw":
          "雖然不懂科研，但為了保護珍視研究的空間站科員順利完成他們的研究，阿蘭可以拼上性命。他早已習慣疼痛，並將負傷視作勳章。",
      },
      {
        "en-us":
          "Only when holding Peppy does the boy finally let down his guard and show a rare smile.",
        "zh-cn": "也只有抱着佩佩时，男孩才会放下戒备，露出难得一见的笑容。",
        "zh-tw": "也只有抱著佩佩時，男孩才會放下戒備，露出難得一見的笑容。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 1.68,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(192% X ATT) * (100% + Lightning Boost %) * (100% - CR% + CR% x (100% + CD%))",
        "zh-cn":
          "(192% X 攻击力) * (100% + 雷属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%))",
        "zh-tw":
          "(192% X 攻擊力) * (100% + 雷屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%))",
      },
      calculation:
        "(192% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD)))",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Destruction",
    element: "Lightning",
    pathIcon: destructionIcon,
    elementIcon: lightningIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1009",
    name: "asta",
    translation: {
      "en-us": "Asta",
      "zh-cn": "艾丝妲",
      "zh-tw": "艾絲妲",
    },
    story: [
      {
        "en-us":
          "A fiercely inquisitive and energetic young girl, she is the Lead Researcher of Herta Space Station.",
        "zh-cn": "好奇心与精力都很旺盛的少女，空间站「黑塔」的名义站长。",
        "zh-tw": "好奇心與精力都很旺盛的少女，空間站「黑塔」的名義站長。",
      },
      {
        "en-us":
          "Whether it is managing opinionated staff, or courteously but firmly responding to the Intelligentsia Guild, Asta handles it all effortlessly.",
        "zh-cn":
          "无论是管理各抒己见的科员，还是直接又不失礼貌地回复博识学会的种种刁难，对艾丝妲来说都易如反掌。",
        "zh-tw":
          "無論是管理各抒己見的科員，還是直接又不失禮貌地回复博識學會的種種刁難，對艾絲妲來說都易如反掌。",
      },
      {
        "en-us":
          "After all... commanding a space station is much easier than taking over her family business!",
        "zh-cn": "毕竟指挥空间站…总比继承家业简单吧！",
        "zh-tw": "畢竟指揮空間站…總比繼承家業簡單吧！",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 1,
        CR: 2,
        CD: 1,
        D: 0.04,
        DR: 1.2,
        DBF: 1.68,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 1.5,
        H: 0.05,
        HR: 1.5,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        MTH4: 1,
        MTH2: 1,
        SV2: 1,
        FA2: 1,
        TKB2: 1,
        LD2: 1,
      },
      name: {
        "en-us": "Skill",
        "zh-cn": "战技",
      },
      description: {
        "en-us":
          "(100% + Break Effect %) * (100% + Energy Regeneration Rate %) * (100% + Effect RES %) * (Speed / 100) * (HP / 100) * (DEF / 100) * Relic Set",
        "zh-cn":
          "(100% + 击破特攻 %) * (100% + 能量恢复效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防御力 / 100) * 遗器套装",
        "zh-tw":
          "(100% + 擊破特攻 %) * (100% + 能量恢復效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防禦力 / 100) * 遺器套裝",
      },
      calculation:
        "(100%+(BE)) * (100%+(EG)) * (100%+(ER)) * ((S) / 100) * ((H)/100) * ((D)/100) * (RS)",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Harmony",
    element: "Fire",
    pathIcon: harmonyIcon,
    elementIcon: fireIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1211",
    name: "bailu",
    translation: {
      "en-us": "Bailu",
      "zh-cn": "白露",
      "zh-tw": "白露",
    },
    story: [
      {
        "en-us":
          'A vivacious young lady of the Vidyadhara race, she is known as the "Healer Lady" due to her expertise with medicine.',
        "zh-cn": "性格活泼的小女孩，持明族的「衔药龙女」，药到病除的名医。",
        "zh-tw": "性格活潑的小女孩，持明族的「銜藥龍女」，藥到病除的名醫。",
      },
      {
        "en-us":
          'She often dishes out unorthodox prescriptions such as "Stay well hydrated" and "Get a good night\'s rest."',
        "zh-cn": "经常开出不拘一格的药方，如「多喝热水」、「睡一觉就好了」。",
        "zh-tw": "經常開出不拘一格的藥方，如「多喝熱水」、「睡一覺就好了」。",
      },
      {
        "en-us":
          "Bailu cannot bear to see people suffer, and that's why you'll see her with her eyes shut tightly as she cures ailments.",
        "zh-cn": "见不得人受苦，治病时总是闭着眼睛。",
        "zh-tw": "見不得人受苦，治病時總是閉著眼睛。",
      },
      {},
      {
        "en-us": "As long as they're cured, that's all that matters, right?",
        "zh-cn": "——总之病好了就行！",
        "zh-tw": "——總之病好了就行！",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 0.2,
        BE: 0.5,
        CR: 0.2,
        CD: 0.1,
        D: 0.04,
        DR: 1.2,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.2,
        ER: 1.5,
        H: 0.05,
        HR: 1.5,
        O: 1.8,
        S: 2.5,
      },
      relic_set_stats: {
        MTH2: 1,
        PWC2: 1,
        LD2: 1,
        FA2: 1,
        BK2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% + Energy Regeneration Rate %) * (100% + Effect RES %) * (Speed / 100) * (100% + Outgoing Healing Boost %) * (HP / 100) * (DEF / 100)  * Relic Set",
        "zh-cn":
          "(100% + 能量恢复效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (100% + 治疗量加成 %) * (生命值 / 100) * (防御力 / 100) * 遗器套装",
        "zh-tw":
          "(100% + 能量恢復效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (100% + 治療量加成 %) * (生命值 / 100) * (防禦力 / 100) * 遺器套裝",
      },
      calculation:
        "(100%+(EG)) * (100%+(ER)) * ((S) / 100) * (100%+(O)) * ((H)/100) * ((D)/100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Abundance",
    element: "Lightning",
    pathIcon: abundanceIcon,
    elementIcon: lightningIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1217",
    name: "huohuo",
    translation: {
      "en-us": "Huohuo",
      "zh-cn": "藿藿",
      "zh-tw": "藿藿",
    },
    story: [
      {
        "en-us":
          'A pitiable and helpless Foxian girl who is also a Ten-Lords Commission Judge-in-training, who fears ghosts but must catch them. Due to having a heliobus named Tail sealed in her tail by the judges of the Ten-Lords Commission, she became a "cursed one" who attracts inhuman beings.',
        "zh-cn":
          "可怜又弱小的狐人小姑娘，也是怕鬼捉鬼的罗浮十王司见习判官。被叫作「尾巴」的岁阳被十王司的判官封印在她的颀尾上，使她成为了招邪的「贞凶之命」。",
        "zh-tw":
          "可憐又弱小的狐人小姑娘，也是怕鬼捉鬼的羅浮十王司見習判官。被叫作「尾巴」的歲陽被十王司的判官封印在她的頎尾上，使她成為了招邪的「貞兇之命」。",
      },
      {
        "en-us":
          "She fears demons and heliobi, but contrarily is tasked with their capture and entrusted with the heavy task of eradicating vile spirits. Though she believes herself lacking in ability, she is unable to muster the courage to resign and continues onward despite walking in a valley of her own fear.",
        "zh-cn":
          "害怕妖魔邪物，却总是受命捉拿邪祟，完成艰巨的除魔任务；自认能力不足，却无法鼓起勇气辞职，只好默默害怕地继续下去。",
        "zh-tw":
          "害怕妖魔邪物，卻總是受命捉拿邪祟，完成艱鉅的除魔任務；自認能力不足，卻無法鼓起勇氣辭職，只好默默害怕地繼續下去。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 0.2,
        BE: 0.5,
        CR: 0.2,
        CD: 0.1,
        D: 0.04,
        DR: 1.2,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.2,
        ER: 1.5,
        H: 0.05,
        HR: 1.5,
        O: 1.8,
        S: 2.5,
      },
      relic_set_stats: {
        MTH2: 1,
        PWC2: 1,
        LD2: 1,
        FA2: 1,
        BK2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% + Energy Regeneration Rate %) * (100% + Effect RES %) * (Speed / 100) * (HP / 100) * (DEF / 100) * Relic Set",
        "zh-cn":
          "(100% + 能量恢复效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防御力 / 100) * 遗器套装",
        "zh-tw":
          "(100% + 能量恢復效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防禦力 / 100) * 遺器套裝",
      },
      calculation:
        "(100%+(EG)) * (100%+(ER)) * ((S) / 100) * ((H)/100) * ((D)/100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Abundance",
    element: "Wind",
    pathIcon: abundanceIcon,
    elementIcon: windIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1218",
    name: "jiaoqiu",
    translation: {
      "en-us": "Jiaoqiu",
      "zh-cn": "椒丘",
      "zh-tw": "椒丘",
    },
    story: [
      {
        "en-us":
          "A foxian healer and counselor from the Xianzhou Yaoqing. Often greets people with a smile on his face and a scheme in his heart.",
        "zh-cn": "仙舟「曜青」的狐人医士、策士，常以笑脸迎人，实际颇有心计。",
        "zh-tw": "仙舟「曜青」的狐人醫士、策士，常以笑臉迎人，實際頗有心計。",
      },
      {
        "en-us":
          'Born into a prestigious Alchemy Commission family, he once withdrew from practicing medicine due to a broken heart. However, he returned to the field to treat "the Merlin\'s Claw," General Feixiao.',
        "zh-cn":
          "出身于丹鼎司名家，曾一度心死避世，不再行医，后为医治「天击将军」飞霄再度出山。",
        "zh-tw":
          "出身於丹鼎司名家，曾一度心死避世，不再行醫，後為醫治「天擊將軍」飛霄再度出山。",
      },
      {
        "en-us":
          'Skilled in the study of alchemical prescription that views food as medicine, especially those that induce a sensation of spiciness. They invented a cauldron-based medicinal formula known as the "nine-squared grid."',
        "zh-cn":
          "精于医食同源的丹方研究，尤其是能带给人痛感的辣味食物，发明了名为「九宫格」的鼎镬药式。",
        "zh-tw":
          "精於醫食同源的丹方研究，尤其是能帶給人痛感的辣味食物，發明了名為「九宮格」的鼎鑊藥式。",
      },
    ],
    formula: {
      stats: {
        A: 0.15,
        AR: 1.8,
        BE: 0.5,
        CR: 0.2,
        CD: 0.1,
        D: 0.02,
        DR: 0.1,
        DBF: 1.68,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 1.68,
        EG: 3.35,
        EH: 1.8,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.9,
      },
      relic_set_stats: {
        MTH2: 1,
        PDDW2: 1,
        PDC2: 1,
        PDC4: 1,
        ETL4: 1,
        PGCE2: 1,
        SV2: 1,
        BK2: 1,
        FF2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT)  * (100% + Energy Regeneration Rate %) * (100% + Fire Boost %) * (100% + Effect Hit Rate % / 2) * (Speed / 80) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 能量恢复效率 %) * (100% + 火属性伤害提高 %) * (100% + 效果命中 % / 2) * (速度/ 80) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 能量恢復效率 %) * (100% + 火屬性傷害提高 %) * (100% + 效果命中 % / 2) * (速度/ 80) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * (100%+(EG)) * (100%+(ED)) * (100%+(EH)/2) * ((S) / 80) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Fire",
    pathIcon: nihilityIcon,
    elementIcon: fireIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1220",
    name: "feixiao",
    translation: {
      "en-us": "Feixiao",
      "zh-cn": "飞霄",
      "zh-tw": "飛霄",
    },
    story: [
      {
        "en-us":
          "The Xianzhou Yaoqing's Merlin's Claw and one of the Seven Arbiter-Generals. Unconventional and straightforward, she exudes effortless charm.",
        "zh-cn":
          "仙舟「曜青」的天击将军，帝弓七天将之一，为人不拘一格，率直潇洒。",
        "zh-tw":
          "仙舟「曜青」的天擊將軍，帝弓七天將之一，為人不拘一格，率直瀟灑。",
      },
      {
        "en-us":
          'She is skilled in all forms of martial arts and has honed herself into a supreme weapon. She is widely adored by Xianzhou soldiers and civilians alike as "The Vanquishing General."',
        "zh-cn":
          "精通百般武艺，炼化躯体至极致，享有「大捷将军」美名，深受仙舟军民爱戴。",
        "zh-tw":
          "精通百般武藝，煉化軀體至極致，享有「大捷將軍」美名，深受仙舟軍民愛戴。",
      },
      {
        "en-us":
          "However, she bears the burden of the Moon Rage affliction. If she were to hunt down all the abominations in her limited lifetime — then the only enemy Feixiao has would be herself.",
        "zh-cn":
          "但身负「月狂」之症，如要在时限内猎尽孽物——飞霄唯一的敌手，便是自己。",
        "zh-tw":
          "但身負「月狂」之症，如要在時限內獵盡孽物——飛霄唯一的敵手，便是自己。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 1.68,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Talent",
        "zh-cn": "天赋",
        "zh-tw": "天賦",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Wind Boost %) * (100% - CR% + CR% x (100% + CD%)) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 风属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 風屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Hunt",
    element: "Wind",
    pathIcon: huntIcon,
    elementIcon: windIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1221",
    name: "yunli",
    translation: {
      "en-us": "Yunli",
      "zh-cn": "云璃",
      "zh-tw": "雲璃",
    },
    story: [
      {
        "en-us":
          'A sword hunter from the Xianzhou Zhuming and "the Flaming Heart" General Huaiyan\'s darling granddaughter. Frank and straightforward.',
        "zh-cn":
          "仙舟「朱明」的猎剑士，备受「烛渊将军」怀炎宠爱的孙女，性格直率。",
        "zh-tw":
          "仙舟「朱明」的獵劍士，備受「燭淵將軍」懷炎寵愛的孫女，性格直率。",
      },
      {
        "en-us":
          "She has learned swordplay and forging from Huaiyan since young, and thus is the second-youngest prodigy swordmaster of the Flamewheel Octet.",
        "zh-cn":
          "从小跟随怀炎学习剑艺与锻艺，乃「焰轮八叶」中次年幼的天才剑士。",
        "zh-tw":
          "從小跟隨懷炎學習劍藝與鍛藝，乃「焰輪八葉」中次年幼的天才劍士。",
      },
      {
        "en-us":
          'Fueled by an intense loathing for the cursed swords that emerged from the Zhuming, she vowed to "hunt down and wipe out all cursed swords."',
        "zh-cn": "对朱明流出的魔剑深恶痛绝，立誓要「搜猎魔剑，尽数断绝」。",
        "zh-tw": "對朱明流出的魔劍深惡痛絕，立誓要「搜獵魔劍，盡數斷絕」。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 1.68,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Talent",
        "zh-cn": "天赋",
        "zh-tw": "天賦",
      },
      description: {
        "en-us":
          "(80% X ATT) * (100% + Physical Boost %) * (100% - CR% + CR% x (100% + CD%))",
        "zh-cn":
          "(80% X 攻击力) * (100% + 物理属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%))",
        "zh-tw":
          "(80% X 攻擊力) * (100% + 物理屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%))",
      },
      calculation: "(80% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD)))",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Physical",
    pathIcon: destructionIcon,
    elementIcon: physicalIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1222",
    name: "lingsha",
    translation: {
      "en-us": "Lingsha",
      "zh-cn": "灵砂",
      "zh-tw": "靈砂",
    },
    story: [
      {
        "en-us":
          "The new Cauldron Master of the Xianzhou Luofu's Alchemy Commission is one perceptive and intelligent Vidyadhara healer.",
        "zh-cn": "仙舟「罗浮」丹鼎司新任司鼎，伶俐秀慧的持明医士。",
        "zh-tw": "仙舟「羅浮」丹鼎司新任司鼎，伶俐秀慧的持明醫士。",
      },
      {
        "en-us":
          "With a keen sense of smell, she diagnoses ailments and calms minds with aromatic therapy.",
        "zh-cn": "嗅觉敏锐，常以此识别病症，并以香薰安定他人心神。",
        "zh-tw": "嗅覺敏銳，常以此識別病症，並以香薰安定他人心神。",
      },
      {
        "en-us":
          "Adept at navigating complex social relationships, she can remain impeccably composed even when turmoil rages within.",
        "zh-cn":
          "善于处理混杂的人际关系，即使心底暴躁如雷，表面上依旧滴水不漏。",
        "zh-tw":
          "善於處理混雜的人際關係，即使心底暴躁如雷，表面上依舊滴水不漏。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 0.2,
        BE: 1,
        CR: 0.2,
        CD: 0.1,
        D: 0.04,
        DR: 1.2,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.2,
        ER: 1.5,
        H: 0.05,
        HR: 1.5,
        O: 1.8,
        S: 2.5,
      },
      relic_set_stats: {
        MTH2: 1,
        MTH4: 1,
        PWC4: 1,
        PWC2: 1,
        LD2: 1,
        FA2: 1,
        BK2: 1,
        SV2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% + Energy Regeneration Rate %) * (100% + Break Effect %) * (100% + Effect RES %) * (Speed / 100) * (100% + Outgoing Healing Boost %) * (HP / 100) * (DEF / 100)  * Relic Set",
        "zh-cn":
          "(100% + 能量恢复效率 %) * (100% + 击破特攻 %) * (100% + 效果抵抗 %) * (速度/ 100) * (100% + 治疗量加成 %) * (生命值 / 100) * (防御力 / 100) * 遗器套装",
        "zh-tw":
          "(100% + 能量恢復效率 %) * (100% + 擊破特攻 %) * (100% + 效果抵抗 %) * (速度/ 100) * (100% + 治療量加成 %) * (生命值 / 100) * (防禦力 / 100) * 遺器套裝",
      },
      calculation:
        "(100%+(EG)) * (100%+(BE)) * (100%+(ER)) * ((S) / 100) * (100%+(O)) * ((H)/100) * ((D)/100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Abundance",
    element: "Fire",
    pathIcon: abundanceIcon,
    elementIcon: fireIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1223",
    name: "moze",
    translation: {
      "en-us": "Moze",
      "zh-cn": "貊泽",
      "zh-tw": "貊澤",
    },
    story: [
      {
        "en-us":
          "A Shadow Guard of the Yaoqing, Moze is taciturn and solitary, always acting on his own.",
        "zh-cn": "仙舟「曜青」的影卫，沉默寡言、独来独往。",
        "zh-tw": "仙舟「曜青」的影衛，沉默寡言、獨來獨往。",
      },
      {
        "en-us":
          "As an expert in intelligence services and other operations that must remain covert, Moze rarely shows himself before others. The moment he reveals his blade usually spells doom for his enemies.",
        "zh-cn":
          "专司情报与不见光的事务，鲜少在人前露面。貊泽显露锋芒时，便是敌人的死期。",
        "zh-tw":
          "專司情報與不見光的事務，鮮少在人前露面。貊澤顯露鋒芒時，便是敵人的死期。",
      },
      {
        "en-us":
          "He commands a vast wealth of assassination techniques, coupled with an extraordinary obsession for orderliness and cleanliness.",
        "zh-cn": "刺杀手段丰富，对整洁和条理有超乎寻常的执着。",
        "zh-tw": "刺殺手段豐富，對整潔和條理有超乎尋常的執著。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 1.68,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Talent",
        "zh-cn": "天赋",
        "zh-tw": "天賦",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Wind Boost %) * (100% - CR% + CR% x (100% + CD%)) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 风属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 風屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * (RS)",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Hunt",
    element: "Wind",
    pathIcon: huntIcon,
    elementIcon: windIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1205",
    name: "blade",
    translation: {
      "en-us": "Blade",
      "zh-cn": "刃",
      "zh-tw": "刃",
    },
    story: [
      {
        "en-us":
          "A swordsman who abandoned his body to become a blade. Birth name unknown.",
        "zh-cn": "弃身锋刃的剑客，原名不详。",
        "zh-tw": "棄身鋒刃的劍客，原名不詳。",
      },
      {
        "en-us":
          "He pledged loyalty to Destiny's Slave and possessed a terrifying self-healing ability.",
        "zh-cn": "效忠于「命运的奴隶」，拥有可怖的自愈能力。",
        "zh-tw": "效忠於「命運的奴隸」，擁有可怖的自愈能力。",
      },
      {
        "en-us":
          "Blade wields an ancient sword riddled with cracks, just like his body and his mind.",
        "zh-cn": "手持古剑作战，剑身遍布破碎裂痕，正如其身，亦如其心。",
        "zh-tw": "手持古劍作戰，劍身遍布破碎裂痕，正如其身，亦如其心。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 0.8,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 1.68,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.05,
        HR: 1.5,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        LD4: 1,
        LD2: 0.9,
        ETL4: 0.8,
        ETL2: 0.88,
        RA2: 1,
        IS2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(5% X ATT + 95% X HP) * (100% + Wind Boost %) * (100% - CR% + CR% x (100% + CD%)) * Relic Set",
        "zh-cn":
          "(5% X 攻击力 + 95% X 生命值) * (100% + 风属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * 遗器套装",
        "zh-tw":
          "(5% X 攻擊力 + 95% X 生命值) * (100% + 風屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * 遺器套裝",
      },
      calculation:
        "(5% * (A) + 95%*(H)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Wind",
    pathIcon: destructionIcon,
    elementIcon: windIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1101",
    name: "bronya",
    translation: {
      "en-us": "Bronya",
      "zh-cn": "布洛妮娅",
      "zh-tw": "布洛妮婭",
    },
    story: [
      {
        "en-us":
          "Heir to the Supreme Guardian of Belobog, she is the young and capable commander of the Silvermane Guards.",
        "zh-cn": "贝洛伯格「大守护者」继承人，年轻干练的银鬃铁卫统领。",
        "zh-tw": "貝洛伯格「大守護者」繼承人，年輕幹練的銀鬃鐵衛統領。",
      },
      {
        "en-us":
          "Bronya received rigorous education from an early age, and possesses the grace and affinity as expected of an heir.",
        "zh-cn":
          "布洛妮娅从小接受着严格的教育，具备一名「继承人」所需的优雅举止与亲和力。",
        "zh-tw":
          "布洛妮婭從小接受著嚴格的教育，具備一名「繼承人」所需的優雅舉止與親和力。",
      },
      {
        "en-us":
          "However, after witnessing the abysmal conditions in the Underworld, seeds of doubt began growing in Belobog's future leader's mind.",
        "zh-cn": "但在看到下层区的恶劣环境后，未来的最高决策者逐渐生出了疑惑…",
        "zh-tw": "但在看到下層區的惡劣環境後，未來的最高決策者逐漸生出了疑惑…",
      },
      {
        "en-us":
          '"Can all the training I\'ve received really help me lead the people to the lives they want?"',
        "zh-cn": "「我所受的训练，真的能带领人民过上他们想要的生活么？」",
        "zh-tw": "「我所受的訓練，真的能帶領人民過上他們想要的生活麼？」",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 0.2,
        BE: 0.5,
        CR: 0.1,
        CD: 1.2,
        D: 0.04,
        DR: 1.2,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.2,
        ER: 1.5,
        H: 0.05,
        HR: 1.5,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        MTH4: 1,
        ETL4: 0.9,
        FA2: 1,
        BK2: 1,
        CD2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% + CD) * (100% + Energy Regeneration Rate %) * (100% + Effect RES %) * (Speed / 100) * (HP / 100) * (DEF / 100) * Relic Set",
        "zh-cn":
          "(100% + 暴伤) * (100% + 能量恢复效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防御力 / 100) * 遗器套装",
        "zh-tw":
          "(100% + 暴傷) * (100% + 能量恢復效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防禦力 / 100) * 遺器套裝",
      },
      calculation:
        "(100%+(CD)) * (100%+(EG)) * (100%+(ER)) * ((S) / 100) * ((H)/100) * ((D)/100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Harmony",
    element: "Wind",
    pathIcon: harmonyIcon,
    elementIcon: windIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1107",
    name: "clara",
    translation: {
      "en-us": "Clara",
      "zh-cn": "克拉拉",
      "zh-tw": "克拉拉",
    },
    story: [
      {
        "en-us":
          "A young girl raised by a robot, her perceptiveness and tenacity are far beyond her years.",
        "zh-cn": "被机器人养大的女孩，有着超越年龄的通透和坚持。",
        "zh-tw": "被機器人養大的女孩，有著超越年齡的通透和堅持。",
      },
      {
        "en-us":
          "For Clara, Svarog's logical calculations are law and infallible.",
        "zh-cn": "对克拉拉而言，史瓦罗理性的计算是世界法则，绝不会出错。",
        "zh-tw": "對克拉拉而言，史瓦羅理性的計算是世界法則，絕不會出錯。",
      },
      {
        "en-us":
          'That is, until she realized that the results from "calculations" don\'t always necessarily bring joy to everyone.',
        "zh-cn": "直到发现「计算」得到的结果，并不一定能带给大家幸福。",
        "zh-tw": "直到發現「計算」得到的結果，並不一定能帶給大家幸福。",
      },
      {
        "en-us":
          "The once shy little girl then decided to cast aside her timidness.",
        "zh-cn": "怯生生的女孩决定勇敢起来。",
        "zh-tw": "怯生生的女孩決定勇敢起來。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 1.68,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Talent",
        "zh-cn": "天赋",
        "zh-tw": "天賦",
      },
      description: {
        "en-us":
          "(80% X ATT) * (100% + Physical Boost %) * (100% - CR% + CR% x (100% + CD%))",
        "zh-cn":
          "(80% X 攻击力) * (100% + 物理属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%))",
        "zh-tw":
          "(80% X 攻擊力) * (100% + 物理屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%))",
      },
      calculation: "(80% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD)))",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Physical",
    pathIcon: destructionIcon,
    elementIcon: physicalIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1301",
    name: "gallagher",
    translation: {
      "en-us": "Gallagher",
      "zh-cn": "加拉赫",
      "zh-tw": "加拉赫",
    },
    story: [
      {
        "en-us": "A security officer of the Bloodhound Family at Penacony.",
        "zh-cn": "匹诺康尼猎犬家系的治安官，对来访宾客以礼相待，但保有戒心。",
        "zh-tw": "匹諾康尼獵犬家系的治安官，對來訪賓客以禮相待，但保有戒心。",
      },
      {
        "en-us":
          "He is always courteous toward visiting guests but keeps his vigilance about him. He seems to carry a weight of a complicated past, yet he never voluntarily divulges any details.",
        "zh-cn": "似乎有着诸多往事，却从不主动提及。",
        "zh-tw": "似乎有著諸多往事，卻從不主動提及。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 0.2,
        BE: 0.5,
        CR: 0.2,
        CD: 0.1,
        D: 0.04,
        DR: 1.2,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.2,
        ER: 1.5,
        H: 0.05,
        HR: 1.5,
        O: 1.8,
        S: 2.5,
      },
      relic_set_stats: {
        MTH2: 1,
        MTH4: 1,
        PWC4: 1,
        PWC2: 1,
        LD2: 1,
        FA2: 1,
        BK2: 1,
        SV2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% + Energy Regeneration Rate %) * (100% + Effect RES %) * (Speed / 100) * (100% + Outgoing Healing Boost %) * (HP / 100) * (DEF / 100)  * Relic Set",
        "zh-cn":
          "(100% + 能量恢复效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (100% + 治疗量加成 %) * (生命值 / 100) * (防御力 / 100) * 遗器套装",
        "zh-tw":
          "(100% + 能量恢復效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (100% + 治療量加成 %) * (生命值 / 100) * (防禦力 / 100) * 遺器套裝",
      },
      calculation:
        "(100%+(EG)) * (100%+(ER)) * ((S) / 100) * (100%+(O)) * ((H)/100) * ((D)/100) * (RS)",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Abundance",
    element: "Fire",
    pathIcon: abundanceIcon,
    elementIcon: fireIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1302",
    name: "argenti",
    translation: {
      "en-us": "Argenti",
      "zh-cn": "银枝",
      "zh-tw": "銀枝",
    },
    story: [
      {
        "en-us": "A classic knight of the Knights of Beauty.",
        "zh-cn": "「纯美骑士团」的古典骑士。",
        "zh-tw": "「純美騎士團」的古典騎士。",
      },
      {
        "en-us":
          "Forthright and candid, this noble and admirable man wanders the cosmos alone, resolutely following the Path of Beauty.",
        "zh-cn":
          "他为人正直、光明磊落，高贵的天性令人敬佩——一位游走宇宙间的独行者，坚定践行「纯美」。",
        "zh-tw":
          "他為人正直、光明磊落，高貴的天性令人敬佩——一位遊走宇宙間的獨行者，堅定實踐「純美」。",
      },
      {
        "en-us":
          "Upholding the good name of Beauty is Argenti's duty. To fulfill this responsibility, one must be pious when one initiates battle, and one must make their opponent yield willingly when one strikes with one's spear.",
        "zh-cn":
          "维护「纯美」在宇宙间的名誉，是银枝的职责：履行这一义务，起手需虔诚，落枪时则将要令人心悦诚服。",
        "zh-tw":
          "維護「純美」在宇宙間的名譽，是銀枝的職責：履行這項義務，起手需虔誠，落槍時則將要令人心悅誠服。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 1.68,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Talent",
        "zh-cn": "天赋",
        "zh-tw": "天賦",
      },
      description: {
        "en-us":
          "(80% X ATT) * (100% + Physical Boost %) * (100% - CR% + CR% x (100% + CD%))",
        "zh-cn":
          "(80% X 攻击力) * (100% + 物理属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%))",
        "zh-tw":
          "(80% X 攻擊力) * (100% + 物理屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%))",
      },
      calculation: "(80% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD)))",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Erudition",
    element: "Physical",
    pathIcon: eruditionIcon,
    elementIcon: physicalIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1303",
    name: "ruan-mei",
    translation: {
      "en-us": "Ruan Mei",
      "zh-cn": "阮•梅",
      "zh-tw": "阮•梅",
    },
    story: [
      {
        "en-us":
          "A sweet-tempered and elegant scholar. Member #81 of the Genius Society.",
        "zh-cn":
          "气质温婉优雅的学者、「天才俱乐部」#81号会员、生命科学领域的专家。",
        "zh-tw":
          "氣質溫婉優雅的學者、「天才俱樂部」#81號會員、生命科學領域的專家。",
      },
      {
        "en-us":
          "An expert in the biological sciences. She earned Nous' attention with her talent and terrifying perseverance, and began her research on the origin of life in a secret corner of the universe. For that, she was invited by Herta to collaborate with Screwllum and Stephen to develop the Simulated Universe.",
        "zh-cn":
          "凭借天赋与惊人的执着得到了博识尊的瞩目，在秘密的角落开始了对生命本源的研究与探索。并因此受到黑塔邀请，同螺丝咕姆、斯蒂芬联合开发了「模拟宇宙」。",
        "zh-tw":
          "憑藉天賦與驚人的執著得到了博識尊的矚目，在秘密的角落開始了對生命本源的研究與探索。並因此受到黑塔邀請，同螺絲咕姆、斯蒂芬聯合開發了「模擬宇宙」。",
      },
      {
        "en-us":
          "Secretly, she greatly enjoys traditional theater and desserts, and she is also very interested in embroidery.",
        "zh-cn": "私底下，她十分喜爱传统戏剧与点心，对刺绣也很感兴趣。",
        "zh-tw": "私底下，她十分喜愛傳統戲劇與點心，對刺繡也很感興趣。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 0.2,
        BE: 1,
        CR: 0.2,
        CD: 0.1,
        D: 0.04,
        DR: 1.2,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.2,
        ER: 1.5,
        H: 0.05,
        HR: 1.5,
        O: 1.8,
        S: 2.5,
      },
      relic_set_stats: {
        TSM4: 1,
        TSM2: 1,
        MTH2: 1,
        PL2: 1,
        TKB2: 1,
        FA2: 1,
        SV2: 1,
        BK2: 1,
      },
      name: {
        "en-us": "Talent",
        "zh-cn": "天赋",
        "zh-tw": "天賦",
      },
      description: {
        "en-us":
          "(100% + Energy Regeneration Rate %) * (100% + Break Effect %) * (100% + Effect RES %) * (Speed / 100) * (HP / 100) * (DEF / 100) * Relic Set",
        "zh-cn":
          "(100% + 能量恢复效率 %) * (100% + 击破特攻 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防御力 / 100) * 遗器套装",
        "zh-tw":
          "(100% + 能量恢復效率 %) * (100% + 擊破特攻 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防禦力 / 100) * 遺器套裝",
      },
      calculation:
        "(100%+(EG)) * (100%+(BE)) * (100%+(ER)) * ((S) / 100) * ((H)/100) * ((D)/100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Harmony",
    element: "Ice",
    pathIcon: harmonyIcon,
    elementIcon: iceIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1304",
    name: "aventurine",
    translation: {
      "en-us": "Aventurine",
      "zh-cn": "砂金",
      "zh-tw": "砂金",
    },
    story: [
      {
        "en-us":
          "A high-ranking executive of the IPC's Strategic Investment Department.",
        "zh-cn": "星际和平公司「战略投资部」的高层成员。",
        "zh-tw": "星際和平公司「策略投資部」的高層成員。",
      },
      {
        "en-us":
          "A risk-taker, his constant smile makes it difficult for people to discern his true feelings.",
        "zh-cn": "风险爱好者，常面带笑容，真心却难以揣测。",
        "zh-tw": "風險愛好者，常面帶笑容，真心卻難以揣測。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 0.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.04,
        DR: 1.3,
        DBF: 0,
        DBI: 0,
        DBM: 1.68,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.2,
        ER: 1.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        PDDW4: 1,
        PDDW2: 0.98,
        AGD2: 1,
        KPP4: 0.9,
        KPP2: 0.9,
        IS2: 1,
        BK2: 1,
      },
      name: {
        "en-us": "Talent",
        "zh-cn": "天赋",
        "zh-tw": "天賦",
      },
      description: {
        "en-us":
          "(100% + Imaginary Boost %) * (100% - CR% + CR% x (100% + CD%)) * (100% + Break Effect % / 8) * (100% + Effect RES % / 4) * (Speed / 100) * (HP / 500) * (DEF / 20) * Relic Set",
        "zh-cn":
          "(100% + 虚数属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (100% + 击破特攻 % / 8) * (100% + 效果抵抗 % / 4) * (速度/ 100) * (生命值 / 500) * (防御力 / 20) * 遗器套装",
        "zh-tw":
          "(100% + 虛數屬性傷害提高 %) * (100% - 爆擊% + 暴傷% x (100% + 暴傷%)) * (100% + 擊破特攻 % / 8) * (100% + 效果抵抗 % / 4) * (速度/ 100) * (生命值 / 500) * (防禦力 / 20) * 遺器套裝",
      },
      calculation:
        "(100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * (100%+(BE)/8) * (100%+(ER)/4) * ((S) / 100) * ((H)/500) * ((D)/20) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Preservation",
    element: "Imaginary",
    pathIcon: preservationIcon,
    elementIcon: imaginaryIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1305",
    name: "dr._ratio",
    translation: {
      "en-us": "Dr. Ratio",
      "zh-cn": "真理医生",
      "zh-tw": "真理醫生",
    },
    story: [
      {
        "en-us":
          "A candid and self-centered Intelligentsia Guild member, who often conceals his appearance with a strange plaster sculpture.",
        "zh-cn": "直率而自我的博识学会学者，常以奇怪的石膏头雕遮蔽面容。",
        "zh-tw": "直率而自我的博學學會學者，常以奇怪的石膏頭雕遮蔽面容。",
      },
      {
        "en-us":
          'He demonstrated unparalleled intelligence and talent since his youth, but now refers to himself as a "Mundanite." He firmly believes that intellect and creativity are not confined to geniuses. He seeks to distribute knowledge to the entire universe to cure the persistent disease named ignorance.',
        "zh-cn":
          "自幼便展露出过人的才智，如今却以「庸人」自居。坚信智慧与创造力并不为天才独有，致力于向全宇宙传播知识，医治名为愚钝的顽疾。",
        "zh-tw":
          "自幼便展露出過人的才智，如今卻以「庸人」自居。堅信智慧與創造力並非為天才獨有，致力於向全宇宙傳播知識，醫治名為愚鈍的頑疾。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 1.68,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 1,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        AGD2: 1,
        GBS4: 1,
        WBD2: 1,
        WBD4: 1,
        MWW2: 1,
        PDC2: 1,
        IS2: 1,
        FF2: 0.9,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(90% X ATT) * (100% + Imaginary Boost %) * (100% - CR% + CR% x (100% + CD%)) * Relic Set",
        "zh-cn":
          "(90% X 攻击力) * (100% + 虚数属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * 遗器套装",
        "zh-tw":
          "(90% X 攻擊力) * (100% + 虛數屬性傷害提高 %) * (100% - 爆擊% + 暴傷% x (100% + 暴傷%)) * 遺器套裝",
      },
      calculation:
        "(90% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD)))  * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Imaginary",
    pathIcon: nihilityIcon,
    elementIcon: imaginaryIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1306",
    name: "sparkle",
    translation: {
      "en-us": "Sparkle",
      "zh-cn": "花火",
      "zh-tw": "花火",
    },
    story: [
      {
        "en-us":
          "A member of the Masked Fools. Inscrutable and unscrupulous. A dangerous maestro of theatrics, utterly engrossed in the art of performance.",
        "zh-cn": "「假面愚者」的成员之一，难以捉摸，不择手段。",
        "zh-tw": "「假面愚者」的成員之一，難以捉摸，不擇手段。",
      },
      {
        "en-us":
          "Adorned with innumerable masks, she is the hero with a thousand faces.",
        "zh-cn": "危险的戏剧大师，沉迷于扮演，身怀千张假面，能化万种面相。",
        "zh-tw": "危險的戲劇大師，沉迷於扮演，身懷千張假面，能化萬種面相。",
      },
      {
        "en-us":
          'Wealth, status, power... None of those matters to Sparkle. The only thing that can get her attention is "amusement."',
        "zh-cn":
          "财富、地位、权利…于花火而言都不重要，能让她出手的，唯有「乐趣」。",
        "zh-tw":
          "財富、地位、權力…於花火而言都不重要，能讓她出手的，唯有「樂趣」。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 0.2,
        BE: 0.5,
        CR: 0.1,
        CD: 1.2,
        D: 0.04,
        DR: 1.2,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.2,
        ER: 1.5,
        H: 0.05,
        HR: 1.5,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        MTH4: 1,
        ETL4: 0.9,
        FA2: 1,
        BK2: 1,
        CD2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% + CD) * (100% + Energy Regeneration Rate %) * (100% + Effect RES %) * (Speed / 100) * (HP / 100) * (DEF / 100) * Relic Set",
        "zh-cn":
          "(100% + 暴伤) * (100% + 能量恢复效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防御力 / 100) * 遗器套装",
        "zh-tw":
          "(100% + 暴傷) * (100% + 能量恢復效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防禦力 / 100) * 遺器套裝",
      },
      calculation:
        "(100%+(CD)) * (100%+(EG)) * (100%+(ER)) * ((S) / 100) * ((H)/100) * ((D)/100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Harmony",
    element: "Quantum",
    pathIcon: harmonyIcon,
    elementIcon: quantumIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1307",
    name: "black_swan",
    translation: {
      "en-us": "Black Swan",
      "zh-cn": "黑天鹅",
      "zh-tw": "黑天鵝",
    },
    story: [
      {
        "en-us":
          "A Memokeeper of the Garden of Recollection. An indolent and mysterious soothsayer.",
        "zh-cn": "流光忆庭的忆者，慵懒神秘的占卜师。",
        "zh-tw": "流光憶庭的憶者，慵懶神秘的占卜師。",
      },
      {
        "en-us":
          '"Remembrance" of men are hers to heed, threads of fate are hers to tug.',
        "zh-cn": "耐心聆听他人「记忆」，诸般命运尽在掌握。",
        "zh-tw": "耐心聆聽他人「記憶」，諸般命運盡在掌握。",
      },
    ],
    formula: {
      stats: {
        A: 0.13,
        AR: 1.5,
        BE: 0.5,
        CR: 0.5,
        CD: 0.25,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 1.68,
        EG: 3.35,
        EH: 1.5,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        PDC4: 1,
        PDC2: 1,
        MWW4: 0.81,
        MWW2: 0.9,
        PGCE2: 1,
        FF2: 1,
        SSS2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Wind Boost %) * (100% + Effect Hit Rate % / 8) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 风属性伤害提高 %) * (100% + 效果命中 % / 8) * (速度/ 100) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 風屬性傷害提高 %) * (100% + 效果命中 % / 8) * (速度/ 100) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * (100%+(ED)) * (100%+(EH)/8) * ((S) / 100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Wind",
    pathIcon: nihilityIcon,
    elementIcon: windIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1308",
    name: "acheron",
    translation: {
      "en-us": "Acheron",
      "zh-cn": "黄泉",
      "zh-tw": "黃泉",
    },
    story: [
      {
        "en-us":
          "A drifter claiming to be a Galaxy Ranger. Her true name is unknown.",
        "zh-cn": "自称「巡海游侠」的旅人，本名不详。",
        "zh-tw": "自稱「巡海遊俠」的旅人，本名不詳。",
      },
      {
        "en-us": "She walks the cosmos alone, carrying with her a long sword.",
        "zh-cn": "身佩一柄长刀，独行银河",
        "zh-tw": "身佩一把長刀，獨行銀河。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 1.68,
        DBQ: 0,
        DBW: 0,
        EG: 0,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        PDDW4: 1,
        PDDW2: 1,
        BST4: 0.97,
        BST2: 0.97,
        IGT2: 1,
        IS2: 0.97,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Lightning Boost %) * (100% - CR% + CR% x (100% + CD%)) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 雷属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (速度/ 100) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 雷屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * (速度/ 100) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * ((S) / 100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Lightning",
    pathIcon: nihilityIcon,
    elementIcon: lightningIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1309",
    name: "robin",
    translation: {
      "en-us": "Robin",
      "zh-cn": "知更鸟",
      "zh-tw": "知更鳥",
    },
    story: [
      {
        "en-us":
          "A Halovian singer who was born in Penacony and has risen to cosmic fame. An elegant and demure young lady.",
        "zh-cn": "出生于匹诺康尼，闻名银河的天环族歌者，举止从容优雅的少女。",
        "zh-tw": "出生於匹諾康尼，聞名銀河的天環族歌者、舉止從容優雅的少女。",
      },
      {
        "en-us":
          "This time, she has been invited home by The Family to grace everyone with song during the Charmony Festival.",
        "zh-cn": "此次受家族宴请回到故乡，在「谐乐大典」为众宾献歌一曲。",
        "zh-tw": "此次受家族宴請回到故鄉，在「諧樂大典」為眾賓獻歌一曲。",
      },
      {
        "en-us":
          'She can use the power of "Harmony" to broadcast her music, manifesting "resonance" among not only her fans but all manner of lifeforms.',
        "zh-cn":
          "可以依靠「同谐」的力量传递歌声，在歌迷乃至万界生灵之中展现「共鸣」。",
        "zh-tw":
          "可以依靠「同諧」的力量傳遞歌聲，在歌迷乃至萬界生靈之中展現「共鳴」。",
      },
    ],
    formula: {
      stats: {
        A: 0.13,
        AR: 1.5,
        BE: 0.5,
        CR: 0.5,
        CD: 0.25,
        D: 0.04,
        DR: 1.2,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 1.68,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 1.5,
        H: 0.05,
        HR: 1.5,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        KPP4: 1,
        GWS2: 1,
        BA2: 1,
        FA2: 0.9,
        BK2: 0.9,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(1% X ATT) * (100% + Energy Regeneration Rate %) * (100% + Effect RES %) * (Speed / 100) * (HP / 200) * (DEF / 200) * Relic Set",
        "zh-cn":
          "(1% X 攻击力) * (100% + 能量恢复效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 200) * (防御力 / 200) * 遗器套装",
        "zh-tw":
          "(1% X 攻擊力) * (100% + 能量恢復效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 200) * (防禦力 / 200) * 遺器套裝",
      },
      calculation:
        "(1% * (A)) * (100%+(EG)) * (100%+(ER)) * ((S) / 100) * ((H)/200) * ((D)/200) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Harmony",
    element: "Physical",
    pathIcon: harmonyIcon,
    elementIcon: physicalIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1310",
    name: "firefly",
    translation: {
      "en-us": "Firefly",
      "zh-cn": "流萤",
      "zh-tw": "流螢",
    },
    story: [
      {
        "en-us":
          'A member of the Stellaron Hunters, clad in a set of mechanized armor known as "SAM." Her character is marked by unwavering loyalty and steely resolve.',
        "zh-cn": "星核猎手成员，身着机械装甲「萨姆」战斗。忠于任务，性格坚强。",
        "zh-tw": "星核獵手成員，身著機械裝甲「薩姆」戰鬥。忠於任務，性格堅強。",
      },
      {
        "en-us":
          "Engineered as a weapon against the Swarm, she experiences accelerated growth, but a tragically shortened lifespan.",
        "zh-cn":
          "作为战胜虫群的兵器而诞生，其生长速度异于常人，但生命非常短暂。",
        "zh-tw":
          "作為戰勝蟲群的兵器而誕生，其生長速度異於常人，但生命非常短暫。",
      },
      {
        "en-us":
          'She joined the Stellaron Hunters in a quest for a chance at "life", seeking to defy her fated demise.',
        "zh-cn": "为了找寻「生」的机会而加入星核猎手，找寻违抗命运的方式。",
        "zh-tw": "為了找出「生」的機會而加入星核獵手，找出違抗命運的方式。",
      },
    ],
    formula: {
      stats: {
        A: 0.15,
        AR: 1.8,
        BE: 1.15,
        CR: 0.5,
        CD: 0.25,
        D: 0.03,
        DR: 0.8,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 1.3,
        H: 0.04,
        HR: 1.2,
        O: 0,
        S: 2.9,
      },
      relic_set_stats: {
        ICAS4: 1,
        ICAS2: 1,
        WMDM2: 0.9,
        TSM2: 0.9,
        TKB2: 0.9,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(10% X ATT) * (100% + Break Effect % X 10) * (100% + Effect RES % / 8) * (Speed / 80) * Relic Set",
        "zh-cn":
          "(10% X 攻击力) * (100% + 击破特攻 % X 10) * (100% + 效果抵抗 % / 8) * (速度/ 80) * 遗器套装",
        "zh-tw":
          "(10% X 攻擊力) * (100% + 擊破特攻 % X 10) * (100% + 效果抵抗 % / 8) * (速度/ 80) * 遺器套裝",
      },
      calculation:
        "(10% * (A)) * (100%+(BE)*10) * (100%+(ER)/8) * ((S) / 80) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Fire",
    pathIcon: destructionIcon,
    elementIcon: fireIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1312",
    name: "misha",
    translation: {
      "en-us": "Misha",
      "zh-cn": "米沙",
      "zh-tw": "米沙",
    },
    story: [
      {
        "en-us":
          "A well-behaved young man serving as a hotel bellboy in Penacony.",
        "zh-cn": "匹诺康尼酒店的门童侍应，乖巧懂事的小男孩。",
        "zh-tw": "匹諾康尼飯店的門童侍應，乖巧懂事的小男孩。",
      },
      {
        "en-us":
          "Misha has a great longing for the Nameless and dreams of one day embarking on a journey of his own.",
        "zh-cn": "对无名客抱有极大憧憬，梦想有朝一日自己也能踏上旅途。",
        "zh-tw": "對無名客抱有極大憧憬，夢想有朝一日自己也能踏上旅途。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 1.68,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(120% X ATT) * (100% + Ice Boost %) * (100% - CR% + CR% x (100% + CD%))",
        "zh-cn":
          "(120% X 攻击力) * (100% + 冰属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%))",
        "zh-tw":
          "(120% X 攻擊力) * (100% + 冰屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%))",
      },
      calculation:
        "(120% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD)))",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Destruction",
    element: "Ice",
    pathIcon: destructionIcon,
    elementIcon: iceIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1313",
    name: "sunday",
    translation: {
      "en-us": "Sunday",
      "zh-cn": "星期日",
      "zh-tw": "星期日",
    },
    story: [
      {
        "en-us":
          "The dream of the Order has dissipated, yet there are still those who will not give up on their original intent.",
        "zh-cn": "「秩序」的美梦已然消散，但仍有人不会放下初愿。",
        "zh-tw": "「秩序」的美夢已然消散，但仍有人不會放下初願。",
      },
      {
        "en-us":
          "— The traveler whose wings were clipped... whereto shall his footsteps lead?",
        "zh-cn": "——折翼坠地的旅人，他的脚步将迈向何方？",
        "zh-tw": "——折翼墜地的旅人，他的腳步將邁向何方？",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 0.2,
        BE: 0.5,
        CR: 0.1,
        CD: 1.2,
        D: 0.04,
        DR: 1.2,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.2,
        ER: 1.5,
        H: 0.05,
        HR: 1.5,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        MTH4: 1,
        ETL4: 0.9,
        FA2: 1,
        BK2: 1,
        CD2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% + CD) * (100% + Energy Regeneration Rate %) * (100% + Effect RES %) * (Speed / 100) * (HP / 100) * (DEF / 100) * Relic Set",
        "zh-cn":
          "(100% + 暴伤) * (100% + 能量恢复效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防御力 / 100) * 遗器套装",
        "zh-tw":
          "(100% + 暴傷) * (100% + 能量恢復效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防禦力 / 100) * 遺器套裝",
      },
      calculation:
        "(100%+(CD)) * (100%+(EG)) * (100%+(ER)) * ((S) / 100) * ((H)/100) * ((D)/100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Harmony",
    element: "Imaginary",
    color: "#1C29BA",
    pathIcon: harmonyIcon,
    elementIcon: imaginaryIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1314",
    name: "jade",
    translation: {
      "en-us": "Jade",
      "zh-cn": "翡翠",
      "zh-tw": "翡翠",
    },
    story: [
      {
        "en-us":
          'A senior manager in the IPC Strategic Investment Department and one of the Ten Stonehearts, known for her cornerstone "Jade of Credit."',
        "zh-cn":
          "星际和平公司「战略投资部」的高级干部，「石心十人」之一，基石为「典贷翡翠」。",
        "zh-tw":
          "星際和平公司「策略投資部」的高級幹部，「石心十人」之一，基石為「典貸翡翠」。",
      },
      {
        "en-us":
          'A beautiful and elegant moneylender, she is skilled in deciphering the depths of people\'s minds, with a personal hobby called "Bonajade Exchange."',
        "zh-cn":
          "冷艳优雅的放贷人，善于洞悉人心，有着名为「慈玉典押」的个人爱好。",
        "zh-tw":
          "冷豔優雅的放貸人，善於洞悉人心，有著名為「慈玉典押」的個人愛好。",
      },
      {
        "en-us":
          "She's willing to wait patiently for high-value acquisitions and adept at extracting value from seemingly destitute clients.",
        "zh-cn":
          "愿意为获取高价值的事物耐心等待，也擅长从看似一无所有的客户身上榨取价值。",
        "zh-tw":
          "願意為獲取高價值的事物耐心等待，也擅長從看似一無所有的客戶身上榨取價值。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 1.68,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(120% X ATT) * (100% + Quantum Boost %) * (100% - CR% + CR% x (100% + CD%))",
        "zh-cn":
          "(120% X 攻击力) * (100% + 量子属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%))",
        "zh-tw":
          "(120% X 攻擊力) * (100% + 量子屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%))",
      },
      calculation:
        "(120% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD)))",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Erudition",
    element: "Quantum",
    color: "#1C29BA",
    pathIcon: eruditionIcon,
    elementIcon: quantumIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1315",
    name: "boothill",
    translation: {
      "en-us": "Boothill",
      "zh-cn": "波提欧",
      "zh-tw": "波提歐",
    },
    story: [
      {
        "en-us":
          "A cyborg cowboy drifting among the stars. Extremely optimistic and unrestrained.",
        "zh-cn": "浪迹银河的改造人牛仔，极度乐观、放荡不羁。",
        "zh-tw": "浪跡銀河的改造人牛仔，極度樂觀、放蕩不羈。",
      },
      {
        "en-us":
          "He is a member of the Galaxy Rangers who swore to punish the wretched by any and all means...",
        "zh-cn": "身为「巡海游侠」的一员，为惩奸除恶，可以无所不用其极——",
        "zh-tw": "身為「巡海遊俠」的一員，為懲奸除惡，可以無所不用其極——",
      },
      {
        "en-us":
          "His flamboyant and brash actions were all to draw the attention of the Interastral Peace Corporation — the target of his revenge.",
        "zh-cn": "高调行事的背后，渴望以此引起复仇对象「星际和平公司」的注意。",
        "zh-tw": "高調行事的背後，渴望以此引起復仇對象「星際和平公司」的注意。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 1.68,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Physical Boost %) * (100% - CR% + CR% x (100% + CD%))",
        "zh-cn":
          "(100% X 攻击力) * (100% + 物理属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%))",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 物理屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%))",
      },
      calculation:
        "(100% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD)))",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Hunt",
    element: "Physical",
    pathIcon: huntIcon,
    elementIcon: physicalIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1317",
    name: "rappa",
    translation: {
      "en-us": "Rappa",
      "zh-cn": "乱破",
      "zh-tw": "亂破",
    },
    story: [
      {
        "en-us":
          'A peculiar girl who appears in Penacony like a flashbang at the darkest hour of night, identifying herself as a ninja and attributing everything in the world to "ninjutsu."',
        "zh-cn":
          "如丑时三刻的闪光弹一般现身在匹诺康尼，以忍者自居，将世间一切归因于「忍法」的奇妙少女。",
        "zh-tw":
          "如丑時三刻的閃光彈一般現身在匹諾康尼，以忍者自居，將世間一切歸因於「忍法」的奇妙少女。",
      },
      {
        "en-us":
          "Upholding the recitation of ninja mantra, creating Dazzling Ninja Seals, and studying ninja scrolls — That is, the Way of the Ninja involves rap, graffiti, and manga — Through rigorous self-discipline, she roams the stars, upholding justice and righteousness.",
        "zh-cn":
          "贯彻吟诵忍•真言、绘制缭乱•忍符、修习忍•法帖的「忍•道」——即说唱，涂鸦，漫画——苦炼自身意志，驰骋星间行侠仗义。",
        "zh-tw":
          "貫徹吟誦忍•真言、繪製繚亂•忍符、修習忍•法帖的「忍•道」——即饒舌、塗鴉、漫畫——苦煉自身意志，馳騁星間行俠仗義。",
      },
      {
        "en-us":
          "As a member of the Galaxy Rangers, she relentlessly pursues the villain known as Evil Ninja Osaru, chasing them to the very edge of the Cosmos.",
        "zh-cn":
          "身为「巡海游侠」的一员，始终追猎着名为「御猿•邪忍」的恶党，直至银河尽头。",
        "zh-tw":
          "身為「巡海遊俠」的一員，始終追獵著名為「御猿•邪忍」的惡黨，直至銀河盡頭。",
      },
    ],
    formula: {
      stats: {
        A: 0.15,
        AR: 1.8,
        BE: 1.15,
        CR: 0.2,
        CD: 0.1,
        D: 0.03,
        DR: 0.8,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 1.3,
        H: 0.04,
        HR: 1.2,
        O: 0,
        S: 2.9,
      },
      relic_set_stats: {
        ICAS4: 1,
        ICAS2: 1,
        WMDM2: 0.9,
        TSM2: 0.9,
        TKB2: 0.9,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(10% X ATT) * (100% + Break Effect % X 10) * (100% + Effect RES % / 8) * (Speed / 80) * Relic Set",
        "zh-cn":
          "(10% X 攻击力) * (100% + 击破特攻 % X 10) * (100% + 效果抵抗 % / 8) * (速度/ 80) * 遗器套装",
        "zh-tw":
          "(10% X 攻擊力) * (100% + 擊破特攻 % X 10) * (100% + 效果抵抗 % / 8) * (速度/ 80) * 遺器套裝",
      },
      calculation:
        "(10% * (A)) * (100%+(BE)*10) * (100%+(ER)/8) * ((S) / 80) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Erudition",
    element: "Imaginary",
    pathIcon: eruditionIcon,
    elementIcon: imaginaryIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1321",    
    name: "the-dahlia",
    translation: {
      "en-us": "The Dahlia",
      "zh-cn": "大丽花",
      "zh-tw": "大理花",
    },
    story: [
      {
        "en-us":
          "The sweet dream burned down the Ever-Flame Mansion, taking with it every trace of \"her.\"",
        "zh-cn":
          "美梦燃烧了永火官邸，也带走关于「她」的点滴。",
        "zh-tw":
          "美夢燃燒了永火官邸，也帶走關於「她」的點滴。",
      },
      {
        "en-us":
          "Destruction, Remembrance... flowers of betrayal bloomed wherever they passed.",
        "zh-cn":
          "「毁灭」、「记忆」…背叛的花朵盛放在所经之地——",
        "zh-tw":
          "「毀滅」、「記憶」……背叛的花朵盛放在所經之地——",
      },
      {
        "en-us":
          "To return to the dreamscape no one remembers, who will be the one to set her aflame again?",
        "zh-cn":
          "重返无人知晓的梦境，将她再度点燃的会是何方？",
        "zh-tw":
          "重返無人知曉的夢境，將她再度點燃的會是何方？",
      },
    ],
    formula: {
      stats: {
        A: 0.15,
        AR: 1.8,
        BE: 1.15,
        CR: 0.2,
        CD: 0.1,
        D: 0.03,
        DR: 0.8,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 1.3,
        H: 0.04,
        HR: 1.2,
        O: 0,
        S: 2.9,
      },
      relic_set_stats: {
        ICAS4: 1,
        ICAS2: 1,
        WMDM2: 0.9,
        TSM2: 0.9,
        TKB2: 0.9,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(10% X ATT) * (100% + Break Effect % X 10) * (100% + Effect RES % / 8) * (Speed / 80) * Relic Set",
        "zh-cn":
          "(10% X 攻击力) * (100% + 击破特攻 % X 10) * (100% + 效果抵抗 % / 8) * (速度/ 80) * 遗器套装",
        "zh-tw":
          "(10% X 攻擊力) * (100% + 擊破特攻 % X 10) * (100% + 效果抵抗 % / 8) * (速度/ 80) * 遺器套裝",
      },
      calculation:
        "(10% * (A)) * (100%+(BE)*10) * (100%+(ER)/8) * ((S) / 80) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Fire",
    pathIcon: nihilityIcon,
    elementIcon: fireIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1401",
    name: "the-herta",
    translation: {
      "en-us": "The Herta",
      "zh-cn": "大黑塔",
      "zh-tw": "大黑塔",
    },
    story: [
      {
        "en-us":
          "Esteemed Genius Society #83, human, female, young, beautiful, attractive.",
        "zh-cn": "尊贵的「天才俱乐部」#83，人类，女性，年轻，貌美，可爱。",
        "zh-tw": "尊贵的「天才俱乐部」#83，人类，女性，年轻，貌美，可爱。",
      },
      {
        "en-us":
          "It's said that she lives in the far edge of the Cosmos, almost never leaving. Sounds like her appearance this time... must be for some issue that requires a personal touch, right?",
        "zh-cn":
          "传说她隐居在银河边境，几乎不踏出其间，想必此次现身—— 一定是为了某个不得不亲自出马的问题吧？",
        "zh-tw":
          "传说她隐居在银河边境，几乎不踏出其间，想必此次现身—— 一定是为了某个不得不亲自出马的问题吧？",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 1.68,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        MWW4: 1,
        MWW2: 1,
        WBD4: 1,
        WBD2: 1,
        RA2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(120% X ATT) * (100% + Ice Boost %) * (100% - CR% + CR% x (100% + CD%)) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(120% X 攻击力) * (100% + 冰属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (速度/ 100) * 遗器套装",
        "zh-tw":
          "(120% X 攻擊力) * (100% + 冰屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * (速度/ 100) * 遺器套裝",
      },
      calculation:
        "(120% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * ((S) / 100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Erudition",
    element: "Ice",
    color: "#1C29BA",
    pathIcon: eruditionIcon,
    elementIcon: iceIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1402",
    name: "aglaea",
    translation: {
      "en-us": "Aglaea",
      "zh-cn": "阿格莱雅",
      "zh-tw": "阿格萊雅",
    },
    story: [
      {
        "en-us":
          "In that holy city kissed by the dawn, the weaver caresses the golden threads, entwining fates.",
        "zh-cn": "在那黎明照拂的圣城，织者抚弄金丝，连缀命运。",
        "zh-tw": "在那黎明照拂的圣城，织者抚弄金丝，连缀命运。",
      },
      {
        "en-us":
          'The Chrysos Heir that bears the "Romance" Coreflame gathered the world\'s heroes, leading them on a long journey once more',
        "zh-cn":
          "背负「浪漫」火种的黄金裔，召集世间英雄，带领他们再度踏上漫长的征程",
        "zh-tw":
          "背负「浪漫」火种的黄金裔，召集世间英雄，带领他们再度踏上漫长的征程",
      },
      {
        "en-us":
          "— to topple the gods, reclaim the divine flame, and grant rebirth to the nearly fallen Amphoreus.",
        "zh-cn": "—— 击落众神，归还神火，予以几近覆灭的翁法罗斯新生。",
        "zh-tw": "—— 击落众神，归还神火，予以几近覆灭的翁法罗斯新生。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 1.68,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        HTS4: 1,
        HTS2: 1,
        TWBP2: 1,
        LSS2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Lightning Boost %) * (100% - CR% + CR% x (100% + CD%)) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 雷属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (速度/ 100) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 雷屬性傷害提高 %) * (100% - 爆擊% + 暴傷% x (100% + 暴傷%)) * (速度/ 100) * 遺器套裝",
      },
      calculation:
        "(100% * (A))  * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * ((S) / 100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Remembrance",
    element: "Lightning",
    color: "#1C29BA",
    pathIcon: remembranceIcon,
    elementIcon: lightningIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1403",
    name: "tribbie",
    translation: {
      "en-us": "Tribbie",
      "zh-cn": "缇宝",
      "zh-tw": "緹寶",
    },
    story: [
      {
        "en-us":
          "From that holy land blessed by the tripartite prophecy, the messenger split into a thousand forms, embarking on a long journey.",
        "zh-cn": "自那三相神谕垂怜的圣地，信使分作千身，启程远行。",
        "zh-tw": "自那三相神諭垂憐的聖地，信使分作千身，啟程遠行。",
      },
      {
        "en-us":
          "Tribios, Holy Maiden of Janusopolis, the Chrysos Heir who stole Passage's Coreflame, toiled for the masses and brought the news of deliverance to all domains.",
        "zh-cn":
          "雅努萨波利斯的圣女，缇里西庇俄丝，窃夺「门径」火种的黄金裔，为众生奔走，令救世的讯息晓喻大地",
        "zh-tw":
          "雅努薩波利斯的聖女，緹里西庇俄絲，竊奪「門徑」火種的黃金裔，為眾生奔走，令救世的訊息曉喻大地",
      },
      {
        "en-us":
          "—Seek the children of humanity with golden blood in their veins, shatter the dimmest dark in this world, and walk toward the tomorrow where the stars gleam.",
        "zh-cn":
          "——找寻那流淌黄金神血的人子，冲破世间至暗，去往星月满天的明日。",
        "zh-tw":
          "——找尋那流淌黃金神血的人子，衝破世間至暗，去往星月滿天的明日。",
      },
    ],
    formula: {
      stats: {
        A: 0.02,
        AR: 0.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 1.68,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.05,
        HR: 1.5,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        PMC4: 1,
        PMC2: 1,
        ETL4: 1,
        LSS2: 1,
        SV2: 1,
        PL2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(HP / 100) * (100% + Quantum Boost %) * (100% + CD% / 5) * (100% - CR% + CR% x (100% + CD%)) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(生命值 / 100) * (100% + 量子属性伤害提高 %) * (100% + 暴伤% / 5) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (速度 / 100) * 遗器套装",
        "zh-tw":
          "(生命值 / 100) * (100% + 量子屬性傷害提高 %) * (100% + 暴傷% / 5) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * (速度 / 100) * 遺器套裝",
      },
      calculation:
        "((H)/100) * (100%+(ED)) * (100%+(CD)/5) * (100%-(CR) + (CR)*(100%+(CD))) * ((S) / 100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Harmony",
    element: "Quantum",
    color: "#1C29BA",
    pathIcon: harmonyIcon,
    elementIcon: quantumIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1404",
    name: "mydei",
    translation: {
      "en-us": "Mydei",
      "zh-cn": "万敌",
      "zh-tw": "萬敵",
    },
    story: [
      {
        "en-us":
          "Kremnos, the mist-shrouded city of chaos and war! Its royal lineage is tainted with patricide, and its god bears the name of calamity.",
        "zh-cn":
          "那沉入迷雾的悬锋，纷乱与战争之城！它的王室流着弑亲的血脉，它的神明以灾厄为名。",
        "zh-tw":
          "那沉入迷霧的懸鋒，紛亂與戰爭之城！它的王室流著弒親的血脈，它的神明以災厄為名。",
      },
      {
        "en-us":
          "The undying Mydeimos, the lion apart from the rest. Chrysos Heir who seeks the Coreflame of Strife, must suffer a thousand deaths, be bathed in blood on the path home, and bear the madness of fate alone.",
        "zh-cn":
          "不死的迈德漠斯，离群的狮子，逐猎「纷争」火种的黄金裔。忍受万死，浴血还乡，孤身背负疯狂的宿命",
        "zh-tw":
          "不死的邁德漠斯，離群的獅子，逐獵「紛爭」火種的黃金裔。忍受萬死，浴血還鄉，孤身背負瘋狂的宿命",
      },
      {
        "en-us":
          "— Kingslayer be king, godslayer be god. Iron-hooves pound across the wilderness for the campaign, and must eventually soak in the blood of their homeland.",
        "zh-cn":
          "——弑王成王，弑神登神。征战的铁蹄踏遍荒野，终归要沾上故乡的血。",
        "zh-tw":
          "——弒王成王，弒神登神。征戰的鐵蹄踏遍荒野，終歸要沾上故鄉的血。",
      },
    ],
    formula: {
      stats: {
        A: 0.02,
        AR: 0.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 1.68,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.05,
        HR: 1.5,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        SLE4: 1,
        SLE2: 0.9,
        LD4: 1,
        LD2: 0.9,
        BCS2: 1,
        RA2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% + Imaginary Boost %) * (100% - CR% + CR% x (100% + CD%)) * (HP / 100) * (Speed / 50) * Relic Set",
        "zh-cn":
          "(100% + 虚数属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (生命值 / 50) * (速度/ 100) * 遗器套装",
        "zh-tw":
          "(100% + 虛數屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * (生命值 / 50) * (速度/ 100) * 遺器套裝",
      },
      calculation:
        "(100%+(ED)) * (100%+(CD)/5) * (100%-(CR) + (CR)*(100%+(CD))) * ((H)/50) * ((S) / 100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Imaginary",
    color: "#1C29BA",
    pathIcon: destructionIcon,
    elementIcon: imaginaryIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1405",
    name: "anaxa",
    translation: {
      "en-us": "Anaxa",
      "zh-cn": "那刻夏",
      "zh-tw": "那刻夏",
    },
    story: [
      {
        "en-us":
          "The Grove of Epiphany, where knowledge flourishes and philosophers are born.",
        "zh-cn": "神悟树庭，滋养知识的学府，诞育哲人的摇床。",
        "zh-tw": "神悟樹庭，滋養知識的學府，誕育哲人的搖床。",
      },
      {
        "en-us":
          "Yet here stands Anaxagoras the blasphemer, the Chrysos Heir who challenges the Coreflame of Reason. He is questioned: Would you defy the prophecy even if you must bear infamy, and insist on driving the thorns of doubt into the Sacred Tree of wisdom?",
        "zh-cn":
          "但渎神的阿那克萨戈拉斯，诘问「理性」火种的黄金裔，试问：你甘愿身负恶名，也要违逆预言，将怀疑的枝杈刺入智慧的圣树？",
        "zh-tw":
          "但瀆神的阿那克薩戈拉斯，詰問「理性」火種的黃金裔，試問：你甘願身負惡名，也要違逆預言，將懷疑的枝杈刺入智慧的聖樹？",
      },
      {
        "en-us":
          '——"Ridiculous. In a world full of lies, I am the only truth."',
        "zh-cn": "——「可笑。这世界遍地虚假，唯有我才是真实。」",
        "zh-tw": "——「可笑。這世界遍地虛假，唯有我才是真實。」",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 1.68,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        SLE4: 1,
        PDDW4: 1,
        IGT2: 1,
        SUD2: 1,
        RA2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(240% X ATT) * (100% + Wind Boost %) * (100% - CR% + CR% x (100% + CD%)) * Relic Set",
        "zh-cn":
          "(240% X 攻击力) * (100% + 风属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * 遗器套装",
        "zh-tw":
          "(240% X 攻擊力) * (100% + 風屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * 遺器套裝",
      },
      calculation:
        "(240% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Erudition",
    element: "Wind",
    color: "#1C29BA",
    pathIcon: eruditionIcon,
    elementIcon: windIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },

  {
    id: "1406",
    name: "cipher",
    translation: {
      "en-us": "Cipher",
      "zh-cn": "赛飞儿",
      "zh-tw": "賽飛兒",
    },
    story: [
      {
        "en-us":
          "In the fallen city of bandits, Dolos, the 300 Rogues run wild and free, the entire city at their mercy.",
        "zh-cn": "失落的盗寇之都多洛斯，三百侠盗纵情游戏，横行无忌。",
        "zh-tw": "失落的盜寇之都多洛斯，三百俠盜縱情遊戲，橫行無忌。",
      },
      {
        "en-us":
          "Race onward, fleet-Footed Thief Star Cifera, Chrysos Heir of the “Trickery” Coreflame, and may your web of lies spread with the breeze throughout all lands—",
        "zh-cn":
          "捷足的贼星赛法利娅，戏弄「诡计」火种的黄金裔，奔走吧。愿你的谎言随风同行，吹遍此世大地——",
        "zh-tw":
          "捷足的賊星賽法利婭，戲弄「詭計」火種的黃金裔，奔走吧。願你的謊言隨風同行，吹遍此世大地——",
      },
      {
        "en-us": "“Tryna trick me? Fetch better scripts!”",
        "zh-cn": "「呵，还想诓我？没门！」",
        "zh-tw": "「呵，還想誆我？門都沒有！」",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 1.68,
        DBW: 0,
        EG: 3.35,
        EH: 1.5,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        GBS4: 1,
        GBS2: 1,
        PGCE2: 1,
        IS2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Quantum Boost %) * (100% - CR% + CR% x (100% + CD%)) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 量子属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 量子屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Quantum",
    pathIcon: nihilityIcon,
    elementIcon: quantumIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1407",
    name: "castorice",
    translation: {
      "en-us": "Castorice",
      "zh-cn": "遐蝶",
      "zh-tw": "遐蝶",
    },
    story: [
      {
        "en-us":
          "Aidonia, the snowy land that respects and worships death, has already sunken into sweet slumber.",
        "zh-cn": "那敬爱死亡的国度，终日飘雪的哀地里亚，今日已沉入甘甜的酣眠。",
        "zh-tw": "那敬愛死亡的國度，終日飄雪的哀地里亞，今日已沉入甘甜的酣眠。",
      },
      {
        "en-us":
          "O Castorice, daughter of the River of Souls, the Chrysos Heir in search of the Coreflame of “Death,” set forth! Guard the lament of the souls in this world, and embrace the solitude of destiny.",
        "zh-cn":
          "冥河的女儿遐蝶，寻索「死亡」火种的黄金裔，启程吧。呵护世间魂灵的恸哭，拥抱命运的孤独",
        "zh-tw":
          "冥河的女兒遐蝶，尋索「死亡」火種的黃金裔，啟程吧。呵護世間魂靈的慟哭，擁抱命運的孤獨",
      },
      {
        "en-us":
          "— Life and death is a journey. When a butterfly rests on that dead branch, the withered will be reborn again.",
        "zh-cn": "——生死皆为旅途，当蝴蝶停落枝头，那凋零的又将新生。",
        "zh-tw": "——生死皆為旅途，當蝴蝶停落枝頭，那凋零的又將新生。",
      },
    ],
    formula: {
      stats: {
        A: 0.02,
        AR: 0.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 1.68,
        DBW: 0,
        EG: 0,
        EH: 0.3,
        ER: 0.5,
        H: 0.05,
        HR: 1.5,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        PMC4: 1,
        PMC2: 0.9,
        BCS2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(HP / 50) * (100% + Quantum Boost %) * (100% + CD% / 5) * (100% - CR% + CR% x (100% + CD%)) * Relic Set",
        "zh-cn":
          "(生命值 / 50) * (100% + 量子属性伤害提高 %) * (100% + 暴伤% / 5) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * 遗器套装",
        "zh-tw":
          "(生命值 / 50) * (100% + 量子屬性傷害提高 %) * (100% + 暴傷% / 5) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * 遺器套裝",
      },
      calculation:
        "((H)/50) * (100%+(ED)) * (100%+(CD)/5) * (100%-(CR) + (CR)*(100%+(CD))) * (RS)",
      leaderboard: [
        {
          id: "1407_1",
          name: {
            "en-us": "Castorice's Default",
            "zh-cn": "遐蝶的默认",
            "zh-tw": "遐蝶的默認",
          },
          relic_set_stats: {
            PMC4: 1,
            PMC2: 0.9,
            BCS2: 1,
          },
          description: {
            "en-us":
              "(HP / 50) * (100% + Quantum Boost %) * (100% + CD% / 5) * (100% - CR% + CR% x (100% + CD%)) * Relic Set",
            "zh-cn":
              "(生命值 / 50) * (100% + 量子属性伤害提高 %) * (100% + 暴伤% / 5) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * 遗器套装",
            "zh-tw":
              "(生命值 / 50) * (100% + 量子屬性傷害提高 %) * (100% + 暴傷% / 5) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * 遺器套裝",
          },
          calculation:
            "((H)/50) * (100%+(DBQ)) * (100%+(CD)/5) * (100%-(CR) + (CR)*(100%+(CD))) * (RS)",
        },
      ],
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Remembrance",
    element: "Quantum",
    color: "#6a2bffff",
    pathIcon: remembranceIcon,
    elementIcon: quantumIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "upcoming",
  },
  {
    id: "1408",
    name: "phainon",
    translation: {
      "en-us": "Phainon",
      "zh-cn": "白厄",
      "zh-tw": "白厄",
    },
    story: [
      {
        "en-us":
          "Aedes Elysiae, a remote frontier village isolated from the world, now lives on only in cryptic legends.",
        "zh-cn": "哀丽秘榭，遗世独立的边陲村落，如今只余晦涩的传说。",
        "zh-tw": "哀麗秘榭，遺世獨立的邊陲村落，如今只餘晦澀的傳說。",
      },
      {
        "en-us":
          "The Nameless hero, █████, the Chrysos Heir carrying the Coreflame of “Worldbearing,” memorizes the ideals of the entire world, carries the fate of millions, and brings the first light of dawn to the new world",
        "zh-cn":
          "无名的英雄█████，容纳「负世」火种的黄金裔，铭记全世的理想，背负万众的命运，为新世界带来第一缕曙光",
        "zh-tw":
          "無名的英雄█████，容納「負世」火種的黃金裔，銘記全世的理想，背負萬眾的命運，為新世界帶來第一縷曙光",
      },
      {
        "en-us":
          "—“But should dawn have never existed, let the fires of rage burn this body to ashes and transform into the blazing sun of tomorrow!”",
        "zh-cn": "——「但倘若黎明从不存在，就让怒火燃尽此身，化作明日的烈阳！」",
        "zh-tw": "——「但倘若黎明從不存在，就讓怒火燃盡此身，化作明日的烈陽！」",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 1.68,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        WC4: 1,
        WC2: 0.95,
        CSB4: 1,
        CSB2: 0.95,
        SLE4: 1,
        SLE2: 0.95,
        AWD2: 1,
        RA2: 1,
        SSS2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(80% X ATT) * (100% + Physical Boost %) * (100% - CR% + CR% x (100% + CD%)) * Relic Set",
        "zh-cn":
          "(80% X 攻击力) * (100% + 物理属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * 遗器套装",
        "zh-tw":
          "(80% X 攻擊力) * (100% + 物理屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * 遺器套裝",
      },
      calculation:
        "(80% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * (RS)",
      leaderboard: [
        {
          id: "1408_1",
          name: {
            "en-us": "Phainon's Default",
            "zh-cn": "白厄的默认",
            "zh-tw": "白厄的默認",
          },
          relic_set_stats: {
            PMC4: 1,
            PMC2: 0.9,
            BCS2: 1,
          },
          description: {
            "en-us":
              "(HP / 50) * (100% + Quantum Boost %) * (100% + CD% / 5) * (100% - CR% + CR% x (100% + CD%)) * Relic Set",
            "zh-cn":
              "(生命值 / 50) * (100% + 量子属性伤害提高 %) * (100% + 暴伤% / 5) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * 遗器套装",
            "zh-tw":
              "(生命值 / 50) * (100% + 量子屬性傷害提高 %) * (100% + 暴傷% / 5) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * 遺器套裝",
          },
          calculation:
            "((H)/50) * (100%+(DBQ)) * (100%+(CD)/5) * (100%-(CR) + (CR)*(100%+(CD))) * (RS)",
        },
      ],
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Physical",
    color: "#1C29BA",
    pathIcon: destructionIcon,
    elementIcon: physicalIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1409",
    name: "hyacine",
    translation: {
      "en-us": "Hyacine",
      "zh-cn": "风堇",
      "zh-tw": "風堇",
    },
    story: [
      {
        "en-us":
          "As the city-state in the clouds crumbles through time, the Twilight Courtyard opens its gates once more, bringing a glimmer of light to Evernight.",
        "zh-cn": "云间城邦随岁月离析，昏光庭院再度敞开门扉，为永夜捎来微光。",
        "zh-tw": "雲間城邦隨歲月離析，昏光庭院再度敞開門扉，為永夜捎來微光。",
      },
      {
        "en-us":
          "You, Physician Hyacinthia, Chrysos Heir who guards the Sky Coreflame, must inherit your ancestors' will and mend the torn fabric of dusk and dawn.",
        "zh-cn":
          "医师雅辛忒丝，守望「天空」火种的黄金裔。继承先祖的意志，缝补破裂的晨昏。",
        "zh-tw":
          "醫師雅辛忒絲，守望「天空」火種的黃金裔。繼承先祖的意志，縫補破裂的晨昏。",
      },
      {
        "en-us":
          "May the rainbow light pour down, dissolve all grudges, and bring the dawn back to this land.",
        "zh-cn": "——愿虹光洒落，仇怨消融，黎明重回大地。",
        "zh-tw": "——願虹光灑落，仇怨消融，黎明重回大地。",
      },
    ],
    formula: {
      stats: {
        A: 0.02,
        AR: 0.2,
        BE: 0.2,
        CR: 0,
        CD: 1,
        D: 0.04,
        DR: 1.2,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 1.68,
        EG: 3.35,
        EH: 0.3,
        ER: 1.5,
        H: 0.05,
        HR: 1.5,
        O: 1.8,
        S: 2.9,
      },
      relic_set_stats: {
        WGST4: 1,
        GTRB2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% + Energy Regeneration Rate %) * (100% + Effect RES %) * (Speed / 100) * (100% + Outgoing Healing Boost %) * (HP / 100) * (DEF / 100)  * Relic Set",
        "zh-cn":
          "(100% + 能量恢复效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (100% + 治疗量加成 %) * (生命值 / 100) * (防御力 / 100) * 遗器套装",
        "zh-tw":
          "(100% + 能量恢復效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (100% + 治療量加成 %) * (生命值 / 100) * (防禦力 / 100) * 遺器套裝",
      },
      calculation:
        "(100%+(EG)) * (100%+(ER)) * ((S) / 100) * (100%+(O)) * ((H)/100) * ((D)/100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Remembrance",
    element: "Wind",
    color: "#1C29BA",
    pathIcon: remembranceIcon,
    elementIcon: windIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1410",
    name: "hysilens",
    translation: {
      "en-us": "Hysilens",
      "zh-cn": "海瑟音",
      "zh-tw": "海瑟音",
    },
    story: [
      {
        "en-us":
          "Styxia, the coastal city of intoxication and dreams, where echoes of old songs still drift among the waves.",
        "zh-cn":
          "斯缇科西亚，醉与梦的海滨之城，旧日的歌声仍在浮浪间回荡。",
        "zh-tw":
          "斯緹科西亞，醉與夢的海濱之城，舊日的歌聲仍在浮浪間迴盪。",
      },
      {
        "en-us":
          "Helektra, Daughter of the Sea, Chrysos Heir who cleanses the Ocean's Coreflame, dispels the murky undercurrents and orchestrates a banquet of revelry for the heroes beyond the sky.",
        "zh-cn":
          "大海的女儿海列屈拉，清洗「海洋」火种的黄金裔，驱散污浊的暗流，为天外的英雄奏响不醉不归的盛宴",
        "zh-tw":
          "大海的女兒海列屈拉，清洗「海洋」火種的黃金裔，驅散汙濁的暗流，為天外的英雄奏響不醉不歸的盛宴",
      },
      {
        "en-us":
          "The show must go on. Even if hope is as fragile as bubbles, the waves will keep surging forward.",
        "zh-cn": "——散场之时未到，纵然希望如泡沫般易碎，浪花也将一往无前。",
        "zh-tw": "——散場之時未到，縱然希望如泡沫般易碎，浪花也將一往無前。",
      },
    ],
    formula: {
      stats: {
        A: 0.13,
        AR: 1.5,
        BE: 0.5,
        CR: 0.5,
        CD: 0.25,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 1.68,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 1,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        BST4: 1,
        BST2: 1,
        MWW4: 0.81,
        MWW2: 0.9,
        MTH4: 0.81,
        MTH2: 0.9,
        SSS2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Physical Boost %) * (100% + Break Effect % / 8) * (100% + Effect Hit Rate % / 8) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 物理属性伤害提高 %) * (100% + 击破特攻 % / 8) * (100% + 效果命中 % / 8) * (速度/ 100) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 物理屬性傷害提高 %) * (100% + 擊破特攻 % / 8) * (100% + 效果命中 % / 8) * (速度/ 100) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * (100%+(ED)) * (100%+(BE)/8) * (100%+(EH)/8) * ((S) / 100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Physical",
    pathIcon: nihilityIcon,
    elementIcon: physicalIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1412",
    name: "cerydra",
    translation: {
      "en-us": "Cerydra",
      "zh-cn": "刻律德菈",
      "zh-tw": "刻律德菈",
    },
    story: [
      {
        "en-us": "The Northern Empire, a lost dynasty, where its frozen lands burn with the fever of conquest.",
        "zh-cn": "北境帝国，失落的王朝，寒冷的疆土燃烧着征伐的野心。",
        "zh-tw": "北境帝國，失落的王朝，寒冷的疆土燃燒著征伐的野心。",
      },
      {
        "en-us":
          "Sovereign Cerydra, the Chrysos Heir who wields the Coreflame of “Law,” weaves her schemes, contends with the gods, passes judgment upon the faithless, and lays the foundation of Flame-Chase into this world.",
        "zh-cn":
          "君主刻律德菈，执握「律法」火种的黄金裔，布局设子，与神相弈，审判异心的罪囚，为此世奠定逐火的基业",
        "zh-tw":
          "君主刻律德菈，執握「律法」火種的黃金裔，佈局設子，與神相弈，審判異心的罪囚，為此世奠定逐火的基業",
      },
      {
        "en-us":
          "…“This is far from the end. Amphoreus’s journey is set to blaze across the stars!”",
        "zh-cn": "——「这绝非终点，翁法罗斯的征途，当是银河群星！」",
        "zh-tw": "——「這絕非終點，翁法羅斯的征途，當是銀河群星！」",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 1.68,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        SRO4: 1,
        LSS2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Energy Regeneration Rate %) * (100% + Effect RES %) * (Speed / 100) * (HP / 100) * (DEF / 100) * (100% - CR% + CR% x (100% + CD%)) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 能量恢复效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防御力 / 100) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 能量恢復效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防禦力 / 100) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) *  遺器套裝",
      },
      calculation:
        "(100% * (A)) * (100%+(EG)) * (100%+(ER)) * ((S) / 100) * ((H)/100) * ((D)/100) * (100%-(CR) + (CR)*(100%+(CD))) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Harmony",
    element: "Wind",
    color: "#1C29BA",
    pathIcon: harmonyIcon,
    elementIcon: windIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1413",
    name: "evernight",
    translation: {
      "en-us": "Evernight",
      "zh-cn": "长夜月",
      "zh-tw": "長夜月",
    },
    story: [
      {
        "en-us": "In the Memory Zone secluded from the world, candlelight reflects the past, silently extinguishing in the mist.",
        "zh-cn": "与世相隔的忆域，烛火映出过往，于迷雾中悄然熄去。",
        "zh-tw": "與世相隔的憶域，燭火映出過往，於迷霧中悄然熄去。",
      },
      {
        "en-us":
          "Evernight, child of Remembrance emerging from those shadows, the Chrysos Heir who conceals the Coreflame of \"Time,\" raises the waves of \"Oblivion\" to protect the wishes of those in the mirror",
        "zh-cn":
          "自那影中而来的记忆之子长夜月，隐匿「岁月」火种的黄金裔，掀起「忘却」的浪潮，守护镜中人的心愿",
        "zh-tw":
          "自那影中而來的記憶之子長夜月，隱匿「歲月」火種的黃金裔，掀起「忘卻」的浪潮，守護鏡中人的心願",
      },
      {
        "en-us":
          "\"Don't worry, I will guard the path of Trailblaze for you... at any cost. ♭\"",
        "zh-cn": "——「别担心，我会为你看护『开拓』的前路…不惜任何代价♭」",
        "zh-tw": "——「別擔心，我會為你看護『開拓』的前路…不惜任何代價♭」",
      },
    ],
    formula: {
      stats: {
        A: 0.02,
        AR: 0.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 1.68,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.05,
        HR: 1.5,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        SRO4: 1,
        LSS2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(HP / 50) * (100% + Ice Boost %) * (100% + CD% / 5) * (100% - CR% + CR% x (100% + CD%)) * Relic Set",
        "zh-cn":
          "(生命值 / 50) * (100% + 冰属性伤害提高 %) * (100% + 暴伤% / 5) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * 遗器套装",
        "zh-tw":
          "(生命值 / 50) * (100% + 冰屬性傷害提高 %) * (100% + 暴傷% / 5) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * 遺器套裝",
      },
      calculation:
        "((H)/50) * (100%+(ED)) * (100%+(CD)/5) * (100%-(CR) + (CR)*(100%+(CD))) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Remembrance",
    element: "Ice",
    color: "#1C29BA",
    pathIcon: remembranceIcon,
    elementIcon: iceIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1414",
    name: "dan-heng-permansor-terrae",
    translation: {
      "en-us": "Dan Heng • Permansor Terrae",
      "zh-cn": "丹恒•腾荒",
      "zh-tw": "丹恆•騰荒",
    },
    story: [
      {
        "en-us": "The chest of Georios, the body of the fallen dragon supporting the shattered earth, enduring millennia of pain.",
        "zh-cn": "吉奥里亚的胸膛，伏龙的身躯支撑破碎的大地，忍耐千年苦痛。",
        "zh-tw": "吉奧里亞的胸膛，伏龍的身軀支撐破碎的大地，忍耐千年苦痛。",
      },
      {
        "en-us":
          "Dan Heng, the Nameless and the Chrysos Heir who guards the Earth's Coreflame, steadies the world before it falls and guides all life across the land to a new home beyond.",
        "zh-cn":
          "无名客丹恒，捍卫「大地」火种的黄金裔，扶八荒之将倾，将地上生灵送往远方的天地",
        "zh-tw":
          "無名客丹恆——捍衛「大地」火種的黃金裔——扶八荒之將傾，將地上生靈送往遠方的天地",
      },
      {
        "en-us":
          "Rivers flow to the sea, mountains echo in harmony, and the eternal path stretches ten thousand miles.",
        "zh-cn": "——百川归海，群山合鸣，不朽的道途将绵延万里。",
        "zh-tw": "——百川歸海，群山合鳴，不朽的道途將綿延萬里。",
      },
    ],
    formula: {
      stats: {
        A: 0.13,
        AR: 1.5,
        BE: 0.5,
        CR: 0.5,
        CD: 0.25,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.05,
        HR: 1.5,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        SRO4: 1,
        LSS2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (速度/ 100) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (速度/ 100) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * ((S) / 100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Preservation",
    element: "Physical",
    color: "#1C29BA",
    pathIcon: preservationIcon,
    elementIcon: physicalIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1415",
    name: "cyrene",
    translation: {
      "en-us": "Cyrene",
      "zh-cn": "昔涟",
      "zh-tw": "昔漣",
    },
    story: [
      {
        "en-us": "A meteor streaks across the night sky, stirring ripples in the river of life, shimmering with thirteen hues.",
        "zh-cn": "流星划过夜空，生命的长河荡起涟漪，闪烁十三种光彩。",
        "zh-tw": "流星劃過夜空，生命的長河蕩起漣漪，閃爍十三種光彩。",
      },
      {
        "en-us":
          "Daughter of Aedes Elysiae, nurturer of the Chrysos Heir of “███,” plants the Seed of Memory, letting yesterday’s flowers bloom in tomorrow",
        "zh-cn":
          "哀丽秘榭的女儿，哺育「██」的黄金裔，栽下记忆的种子，让往昔的花朵在明日绽放",
        "zh-tw":
          "哀麗秘榭的女兒，哺育「██」的黃金裔，栽下記憶的種子，讓往昔的花朵在明日綻放",
      },
      {
        "en-us":
          "—“Now, let’s write a different kind of poem together♪”",
        "zh-cn": "——「然后，一起写下不同以往的诗篇吧♪」",
        "zh-tw": "——「然後，一起寫下不同以往的詩篇吧♪」",
      },
    ],
    formula: {
      stats: {
        A: 0.02,
        AR: 0.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 1.68,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.05,
        HR: 1.5,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        WRD4: 1,
        LSS2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (速度/ 100) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (速度/ 100) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * ((S) / 100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Remembrance",
    element: "Ice",
    color: "#1C29BA",
    pathIcon: remembranceIcon,
    elementIcon: iceIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  
  {
    id: "1501",
    name: "sparxie",
    translation: {
      "en-us": "Sparxie",
      "zh-cn": "火花",
      "zh-tw": "火花",
    },
    story: [
      {
        "en-us":
          "Like! Follow! Stream! Views! Party till the world ends!",
        "zh-cn": "点赞！关注！直播！流量！狂欢直到世界尽头！",
        "zh-tw": "按讚！追蹤！直播！流量！狂歡直到世界盡頭！",
      },
      {
        "en-us":
          "Sparxie and Sparkle, the Mask and the Fool are fundamentally the same.",
        "zh-cn":
          "火花和花火，假面与愚者本无不同——",
        "zh-tw":
          "火花和花火，假面與愚者本無不同——",
      },
      {
        "en-us":
          "Whoever is seen, whoever is liked, is the correct answer!",
        "zh-cn": "谁被看见，谁被喜欢，谁就是正确答案！",
        "zh-tw": "誰被看見、誰被喜歡，誰就是正確答案！",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 1.68,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        WC4: 1,
        WC2: 0.95,
        CSB4: 1,
        CSB2: 0.95,
        SLE4: 1,
        SLE2: 0.95,
        AWD2: 1,
        RA2: 1,
        SSS2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Fire Boost %) * (100% - CR% + CR% x (100% + CD%)) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 火属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (速度/ 100) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 火屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * (速度/ 100) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * ((S) / 100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Elation",
    element: "Fire",
    color: "#1C29BA",
    pathIcon: elationIcon,
    elementIcon: fireIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "upcoming",
  },
  {
    id: "1502",
    name: "yao-guang",
    translation: {
      "en-us": "Yao Guang",
      "zh-cn": "爻光",
      "zh-tw": "爻光",
    },
    story: [
      {
        "en-us":
          "Mysterious, bold, radical… her quest for change is stunning.",
        "zh-cn": "神秘，大胆，激进，求变之举令人瞠目结舌。",
        "zh-tw": "神秘、大膽、激進、求變之舉令人瞠目結舌。",
      },
      {
        "en-us":
          "With the “eye” of The Hunt, she sees all fates. Though she knows fate is immutable, the Seer Strategist still walks into danger alone.",
        "zh-cn":
          "以巡猎之「眼」遍观吉凶，明知天意难违，「戎韬将军」仍旧孤身涉险。",
        "zh-tw":
          "以巡獵之「眼」遍觀吉凶，明知天意難違，「戎韜將軍」仍舊孤身涉險。",
      },
      {
        "en-us":
          "With the odds stacked against her, how can she possibly change her destiny?",
        "zh-cn": "这一支下下签，如何能够改运换天？",
        "zh-tw": "這一支下下籤，如何能夠改運換天？",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 1.68,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        WC4: 1,
        WC2: 0.95,
        CSB4: 1,
        CSB2: 0.95,
        SLE4: 1,
        SLE2: 0.95,
        AWD2: 1,
        RA2: 1,
        SSS2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(80% X ATT) * (100% + Physical Boost %) * (100% - CR% + CR% x (100% + CD%)) * Relic Set",
        "zh-cn":
          "(80% X 攻击力) * (100% + 物理属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * 遗器套装",
        "zh-tw":
          "(80% X 攻擊力) * (100% + 物理屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * 遺器套裝",
      },
      calculation:
        "(80% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Elation",
    element: "Physical",
    color: "#1C29BA",
    pathIcon: elationIcon,
    elementIcon: physicalIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "upcoming",
  },
  {
    id: "1505",
    name: "evanescia",
    translation: {
      "en-us": "Evanescia",
      "zh-cn": "绯英",
      "zh-tw": "緋英",
    },
    story: [
      {
        "en-us":
          "One season the Phantasmoon waxes full, one season the mortal world shifts anew: The mysterious girl reappears in Planarcadia!",
        "zh-cn": "一季幻月满盈，一季人世更迭，神秘少女再度现身二相乐园！",
        "zh-tw": "一季幻月滿盈，一季人世更迭，神秘少女再度現身二相樂園！",
      },
      {
        "en-us":
          "Fallen petals scatter with ease, and her stay was but a fleeting instant. Everything about this new era enthralls her, and she will not allow anyone to bring it to ruin...",
        "zh-cn":
          "落英易散，她的停留也不过刹那。新时代的一切令她痴迷，绝不容许有人破坏——",
        "zh-tw":
          "落英易散，她的停留也不過剎那。新時代的一切令她痴迷，絕不容許有人破壞——",
      },
      {
        "en-us":
          "A single ruler blade judges right from wrong, but who can say how much good or evil lies within oneself?",
        "zh-cn": "一把尺刀裁定正邪，可谁又能知，己身善恶几何？",
        "zh-tw": "一把尺刀裁定正邪，可誰又能知，己身善惡幾何？",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        EGMG4: 1,
        PSZ2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% - CR% + CR% x (100% + CD%)) * (100% + Effect RES %) * (Speed / 60) * (HP / 100) * (DEF / 100) * Relic Set",
        "zh-cn":
          "(100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (100% + 效果抵抗 %) * (速度/ 60) * (生命值 / 100) * (防御力 / 100) * 遗器套装",
        "zh-tw":
          "(100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * (100% + 效果抵抗 %) * (速度/ 60) * (生命值 / 100) * (防禦力 / 100) * 遺器套裝",
      },
      calculation:
        "(100%-(CR) + (CR)*(100%+(CD))) * (100%+(ER)) * ((S) / 60) * ((H)/100) * ((D)/100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Elation",
    element: "Physical",
    color: "#1C29BA",
    pathIcon: elationIcon,
    elementIcon: physicalIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "upcoming",
  },
  {
    id: "1504",
    name: "ashveil",
    translation: {
      "en-us": "Ashveil",
      "zh-cn": "不死途",
      "zh-tw": "不死途",
    },
    story: [
      {
        "en-us":
          "He takes cases on a whim, cracks them with hard-core logic, and solves the strangest crimes on sheer instinct.",
        "zh-cn": "随缘营业，硬核推理，全凭直觉却屡破奇案。",
        "zh-tw": "隨緣營業，硬核推理，全憑直覺卻屢破奇案。",
      },
      {
        "en-us":
          "With a monkey for an assistant and his heart set on retirement, the detective sleeps in a refrigerator, waiting for the bait to catch its willing prey.",
        "zh-cn":
          "猴子当助手，一心盼退休，侦探睡在冰箱，只为等愿者上钩。",
        "zh-tw":
          "猴子當助手，一心盼退休，偵探睡在冰箱，只為等願者上鉤。",
      },
      {
        "en-us":
          "Under the light of the Phantasmoon, the vile beast howls. How will he draw the net on this hunt?",
        "zh-cn": "幻月下，恶兽长嗥，他的追猎游戏会如何收网？",
        "zh-tw": "幻月下，惡獸長嗥，他的追獵遊戲會如何收網？",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        EGMG4: 1,
        PSZ2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% - CR% + CR% x (100% + CD%)) * (100% + Effect RES %) * (Speed / 60) * (HP / 100) * (DEF / 100) * Relic Set",
        "zh-cn":
          "(100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (100% + 效果抵抗 %) * (速度/ 60) * (生命值 / 100) * (防御力 / 100) * 遗器套装",
        "zh-tw":
          "(100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * (100% + 效果抵抗 %) * (速度/ 60) * (生命值 / 100) * (防禦力 / 100) * 遺器套裝",
      },
      calculation:
        "(100%-(CR) + (CR)*(100%+(CD))) * (100%+(ER)) * ((S) / 60) * ((H)/100) * ((D)/100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Hunt",
    element: "Lightning",
    color: "#1C29BA",
    pathIcon: huntIcon,
    elementIcon: lightningIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "upcoming",
  },
  {
    id: "1506",
    name: "silver-wolf-lv999",
    translation: {
      "en-us": "Silver Wolf LV.999",
      "zh-cn": "银狼LV.999",
      "zh-tw": "銀狼LV.999",
    },
    story: [
      {
        "en-us":
          "A new season of Elation begins, featuring the limited-time return of the invincible player \"Silver Wolf LV.999\"!",
        "zh-cn": "新一轮欢愉赛季，无敌玩家「银狼LV.999」限时回归中！",
        "zh-tw": "新一輪歡愉賽季，無敵玩家「銀狼LV.999」限時回歸中！",
      },
      {
        "en-us":
          "She's conquered the universe, unlocked every cosmic achievement... What's left to play?",
        "zh-cn":
          "成为宇宙大赢家，银河通关全成就，接下来还要怎么玩？",
        "zh-tw":
          "成為宇宙大贏家，銀河完成全成就，接下來還要怎麼玩？",
      },
      {
        "en-us":
          "\"Reach the peak of 'Elation'? Boring... Since I've got the cartridge now, I make the rules~\"",
        "zh-cn": "「走上『欢愉』巅峰？无聊到爆好嘛…既然卡带到手，就我说了算咯~」",
        "zh-tw": "「走上『歡愉』巔峰？無聊到爆好嗎…既然卡帶到手，就我說了算囉～」",
      },
    ],
    formula: {
      stats: {
        A: 0.02,
        AR: 0.2,
        BE: 0.4,
        CR: 2.4,
        CD: 1,
        D: 0.04,
        DR: 1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 0,
        EH: 0.05,
        ER: 0.1,
        H: 0.04,
        HR: 1,
        O: 0,
        S: 3.2,
      },
      relic_set_stats: {
        EGMG4: 1,
        PSZ2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% - CR% + CR% x (100% + CD%)) * (100% + Effect RES %) * (Speed / 60) * (HP / 100) * (DEF / 100) * Relic Set",
        "zh-cn":
          "(100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (100% + 效果抵抗 %) * (速度/ 60) * (生命值 / 100) * (防御力 / 100) * 遗器套装",
        "zh-tw":
          "(100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * (100% + 效果抵抗 %) * (速度/ 60) * (生命值 / 100) * (防禦力 / 100) * 遺器套裝",
      },
      calculation:
        "(100%-(CR) + (CR)*(100%+(CD))) * (100%+(ER)) * ((S) / 60) * ((H)/100) * ((D)/100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Imaginary",
    element: "Elation",
    color: "#1C29BA",
    pathIcon: elationIcon,
    elementIcon: imaginaryIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "upcoming",
  },
  {
    id: "1507",
    name: "mortenax-blade",
    translation: {
      "en-us": "Mortenax Blade",
      "zh-cn": "千冶•刃",
      "zh-tw": "千冶•刃",
    },
    story: [
      {
        "en-us":
          "Body like spring wood, heart like dead ash. Yet embers of a craftsman's spark still linger at his fingertips.",
        "zh-cn": "身如春木，心若死灰，指尖仍留工匠的火星。",
        "zh-tw": "身如春木，心若死灰，指尖仍留工匠的火星。",
      },
      {
        "en-us":
          "As ancient grudges are ignited once more, he promises to send both himself and the gods to the other side...",
        "zh-cn":
          "累世宿怨再度点燃，他许诺将自己与神明一同送往彼岸——",
        "zh-tw":
          "累世宿怨再度點燃，他許諾將自己與神明一同送往彼岸——",
      },
      {
        "en-us":
          "Torn flesh, tempered a thousand times into a blade... What answer will it create?",
        "zh-cn": "支离此身，千冶成刃…会铸就何种答案？",
        "zh-tw": "支離此身，千冶成刃……會鑄就何種答案？",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 1.68,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        PDDW2: 1,
        DQMS4: 1
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X HP) * (100% + Fire Boost %) * (100% - CR% + CR% x (100% + CD%)) * Relic Set",
        "zh-cn":
          "(100% X 生命值) * (100% + 火属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * 遗器套装",
        "zh-tw":
          "(100% X 生命值) * (100% + 火屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * 遺器套裝",
      },
      calculation:
        "(100%*(H)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Fire",
    color: "#1C29BA",
    pathIcon: nihilityIcon,
    elementIcon: fireIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "upcoming",
  },
  {
    id: "1002",
    name: "dan-heng",
    translation: {
      "en-us": "Dan Heng",
      "zh-cn": "丹恒",
      "zh-tw": "丹恆",
    },
    story: [
      {
        "en-us":
          "A cold and reserved young man who wields a spear known as Cloud-Piercer. ",
        "zh-cn":
          "清冷寡言的少年，持有名为「击云」的长枪，于列车漫长的开拓之旅中担任护卫。",
        "zh-tw":
          "清冷寡言的少年，持有名為「擊雲」的長槍，於列車漫長的開拓之旅中擔任護衛。",
      },
      {
        "en-us":
          "He acts as the Express' guard on its long trailblazing expedition. ",
        "zh-cn":
          "丹恒对自己的过往始终讳莫如深，他与列车同行正是为了摆脱自己曾亲手造就的一切。",
        "zh-tw":
          "丹恆對自己的過往始終諱莫如深，他與列車同行正是為了擺脫自己曾親手造就的一切。",
      },
      {
        "en-us":
          "Dan Heng never talks much about his past. In fact, he joined the Express Crew to escape from it. But can the Express really help him outrun his past?",
        "zh-cn": "然而，列车真的会带着他远离「过去」么？",
        "zh-tw": "然而，列車真的會帶著他遠離「過去」麼？",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 1.68,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(240% X ATT) * (100% + Wind Boost %) * (100% - CR% + CR% x (100% + CD%))",
        "zh-cn":
          "(240% X 攻击力) * (100% + 风属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%))",
        "zh-tw":
          "(240% X 攻擊力) * (100% + 風屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%))",
      },
      calculation:
        "(240% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD)))",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Hunt",
    element: "Wind",
    pathIcon: huntIcon,
    elementIcon: windIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1104",
    name: "gepard",
    translation: {
      "en-us": "Gepard",
      "zh-cn": "杰帕德",
      "zh-tw": "傑帕德",
    },
    story: [
      {
        "en-us":
          "The honorable and upstanding captain of the Silvermane Guards who bears the noble Landau family name.",
        "zh-cn": "高洁正直的银鬃铁卫戍卫官，出身于血脉高贵的郎道家族。",
        "zh-tw": "高潔正直的銀鬃鐵衛戍衛官，出身於血脈高貴的郎道家族。",
      },
      {
        "en-us":
          "In the frost-whipped city of Belobog, life can still go on in normality...",
        "zh-cn": "在时刻遭受风雪侵凌的贝洛伯格，人们的衣食住行尚能如旧——",
        "zh-tw": "在時刻遭受風雪侵凌的貝洛伯格，人們的衣食住行尚能如舊——",
      },
      {
        "en-us":
          "This is in no small part thanks to Gepard and his Silvermane Guards who protect the peace of everyday life.",
        "zh-cn": "正是因为杰帕德与他率领的银鬃铁卫在守护这平淡无奇的日常生活。",
        "zh-tw": "正是因為傑帕德與他率領的銀鬃鐵衛在守護這平淡無奇的日常生活。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.04,
        DR: 1.2,
        DBF: 0,
        DBI: 1.68,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us": "30% X DEF",
        "zh-cn": "30% X 防御力",
        "zh-tw": "30% X 防禦力",
      },
      calculation: "30% * (D)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Preservation",
    element: "Ice",
    pathIcon: preservationIcon,
    elementIcon: iceIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1013",
    name: "herta",
    translation: {
      "en-us": "Herta",
      "zh-cn": "黑塔",
      "zh-tw": "黑塔",
    },
    story: [
      {
        "en-us": "Herta Space Station's true master.",
        "zh-cn": "空间站「黑塔」真正的主人。",
        "zh-tw": "空間站「黑塔」真正的主人。",
      },
      {
        "en-us":
          "As the human with the highest IQ on The Blue, she only does what she's interested in, dropping whatever project immediately the moment she loses interest — the best example being the space station.",
        "zh-cn":
          "身为湛蓝星智商最高的人类，只做自己感兴趣的事，一旦失去兴趣就立刻走人——空间站就是最好的例子。",
        "zh-tw":
          "身為湛藍星智商最高的人類，只做自己感興趣的事，一旦失去興趣就立刻走人——空間站就是最好的例子。",
      },
      {
        "en-us":
          "She typically appears in the form of a remote-controlled puppet.",
        "zh-cn": "平时以远程操纵的人偶形态登场：",
        "zh-tw": "平時以遠程操縱的人偶形態登場：",
      },
      {
        "en-us":
          '"It\'s about seventy percent similar to how I looked as a child." — Herta',
        "zh-cn": "“跟我小时候比，勉强七分相似吧。”——黑塔本人。",
        "zh-tw": "“跟我小時候比，勉強七分相似吧。”——黑塔本人。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 1.68,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(120% X ATT) * (100% + Ice Boost %) * (100% - CR% + CR% x (100% + CD%))",
        "zh-cn":
          "(120% X 攻击力) * (100% + 冰属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%))",
        "zh-tw":
          "(120% X 攻擊力) * (100% + 冰屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%))",
      },
      calculation:
        "(120% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD)))",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Erudition",
    element: "Ice",
    pathIcon: eruditionIcon,
    elementIcon: iceIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },

  {
    id: "1014",
    name: "saber",
    translation: {
      "en-us": "Saber",
      "zh-cn": "Saber",
      "zh-tw": "Saber",
    },
    story: [
      {
        "en-us":
          "The solitary Heroic Spirit traverses the long night of fate. The banner of the round table remains unfurled in a dream. Alas, the knight-king of Camelot has yet to reach that ever-distant utopia.",
        "zh-cn":
          "孤独的英灵走过命运的长夜， 圆桌的旗帜仍在梦中舒展。卡美洛的骑士之王，此时尚未抵达理想乡。",
        "zh-tw":
          "孤獨的英靈走過命運的長夜， 圓桌的旗幟仍在夢中舒展。卡美洛的騎士之王，此時尚未抵達理想鄉。",
      },
      {
        "en-us":
          "Though still a young maiden, she has heeded the call for this most unique iteration of the Holy Grail War. With the Sword in the Stone offering its choice once more, how shall she shatter the illusions of the past?",
        "zh-cn":
          "仍是少女的她于这场特殊的「圣杯战争」中应召前来，当再度面临石中剑的抉择，她将如何突破过往的幻境？",
        "zh-tw":
          "仍是少女的她於這場特殊的「聖杯戰爭」中應召前來，當再度面臨石中劍的抉擇，她將如何突破過往的幻境？",
      },
      {
        "en-us": "— “The wishes I did not fulfill will end here.”",
        "zh-cn": "——「我未实现的愿望，也将在此作结。」",
        "zh-tw": "——「我未實現的願望，也將在此作結。」",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 1.68,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        WC2: 1,
        WC4: 1,
        SLE4: 1,
        SLE2: 1,
        MWW4: 1,
        MWW2: 1,
        IS2: 1,
        SSS2: 1,
        RA2: 1,
      },
      name: {
        "en-us": "Talent",
        "zh-cn": "天赋",
        "zh-tw": "天賦",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Wind Boost %) * (100% - CR% + CR% x (100% + CD%)) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 风属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 風屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Wind",
    pathIcon: destructionIcon,
    elementIcon: windIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },

  {
    id: "1015",
    name: "archer",
    translation: {
      "en-us": "Archer",
      "zh-cn": "Archer",
      "zh-tw": "Archer",
    },
    story: [
      {
        "en-us":
          "Despair plays in cycles between the past and future. Countless ideals were incinerated before that red Holy Shroud. Yet, do not let this smear of ashes fool you —",
        "zh-cn":
          "绝望轮番上演于过去与未来之间，无数理想曾在红色圣骸布之间燃尽。但，请别被这一抹灰烬欺骗——",
        "zh-tw":
          "絕望輪番上演於過去與未來之間，無數理想曾在紅色聖骸布之間燃盡。但，請別被這一抹灰燼欺騙——",
      },
      {
        "en-us":
          "Should someone create a phantasmal sweet dream under the guise of false ideals, then he will burn again, facing down the hypocrites of the world till the very end.",
        "zh-cn":
          "若是有人假借理想之名营造虚幻的美梦，他必将再度燃烧，与世间的伪善战斗到底。",
        "zh-tw":
          "若是有人假借理想之名營造虛幻的美夢，他必將再度燃燒，與世間的偽善戰鬥到底。",
      },
      {
        "en-us":
          "No matter where he is, he always remains the steadfast hero of justice.",
        "zh-cn": "无论身在何处，他始终是正义的伙伴。",
        "zh-tw": "無論身在何處，他始終是正義的夥伴。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 1.68,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        GBS4: 1,
        GBS2: 1,
        SLE4: 1,
        SLE2: 1,
        MWW4: 1,
        MWW2: 1,
        RA2: 1,
        SSS2: 1,
        IS2: 2,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Quantum Boost %) * (100% + CD% / 5) * (100% - CR% + CR% x (100% + CD%)) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 量子属性伤害提高 %) * (100% + 暴伤% / 5) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (速度 / 100) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 量子屬性傷害提高 %) * (100% + 暴傷% / 5) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * (速度 / 100) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * (100%+(ED)) * (100%+(CD)/5) * (100%-(CR) + (CR)*(100%+(CD))) * ((S) / 100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Hunt",
    element: "Quantum",
    pathIcon: huntIcon,
    elementIcon: quantumIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1003",
    name: "himeko",
    translation: {
      "en-us": "Himeko",
      "zh-cn": "姬子",
      "zh-tw": "姬子",
    },
    story: [
      {
        "en-us":
          "An adventurous scientist who encountered the Astral Express as a young girl when it got stranded in her home world.",
        "zh-cn": "充满冒险精神的科学家，少女时代在故乡遭遇了搁浅的星穹列车。",
        "zh-tw": "充滿冒險精神的科學家，少女時代在故鄉遭遇了擱淺的星穹列車。",
      },
      {
        "en-us":
          "Years later, Himeko finally repaired the train and began her journey to the stars, but she realized that this was only the beginning. On her trailblazing journey, she would need many more companions...",
        "zh-cn":
          "若干年后，当姬子终于修复列车驶入群星时，她意识到这只是个开始。在「开拓」新世界的道路上，需要更多的同伴——",
        "zh-tw":
          "若干年後，當姬子終於修復列車駛入群星時，她意識到這只是個開始。在「開拓」新世界的道路上，需要更多的同伴——",
      },
      {
        "en-us":
          "And while they may have different destinations, they all gaze at the same starry sky.",
        "zh-cn": "即使同行的人们面朝不同的方向，他们仍处于同一片星空下。",
        "zh-tw": "即使同行的人們面朝不同的方向，他們仍處於同一片星空下。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 1.68,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(138% X ATT) * (100% + Fire Boost %) * (100% - CR% + CR% x (100% + CD%))",
        "zh-cn":
          "(138% X 攻击力) * (100% + 火属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%))",
        "zh-tw":
          "(138% X 攻擊力) * (100% + 火屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%))",
      },
      calculation:
        "(138% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD)))",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Erudition",
    element: "Fire",
    pathIcon: eruditionIcon,
    elementIcon: fireIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1109",
    name: "hook",
    translation: {
      "en-us": "Hook",
      "zh-cn": "虎克",
      "zh-tw": "虎克",
    },
    story: [
      {
        "en-us":
          "Head of the adventure squad The Moles, she calls herself Pitch-Dark Hook the Great.",
        "zh-cn": "冒险集团「鼹鼠党」的头头，自称「漆黑的虎克大人」。",
        "zh-tw": "冒險集團「鼴鼠黨」的頭頭，自稱「漆黑的虎克大人」。",
      },
      {
        "en-us":
          'She doesn\'t like to be called a "kid" and believes she can handle things herself without any help from adults.',
        "zh-cn": "不喜欢被人称作小家伙，认为自己不依靠大人也能独挡一面。",
        "zh-tw": "不喜歡被人稱作小傢伙，認為自己不依靠大人也能獨擋一面。",
      },
      {
        "en-us":
          "Adults adventure into the Fragmentum, Sampo adventures on the surface, and patients take their risky adventure seeking treatment from Natasha...",
        "zh-cn":
          "大人们去裂界里冒险，桑博先生去地面上冒险，病人们冒险接受娜塔莎的治疗……",
        "zh-tw":
          "大人們去裂界裡冒險，桑博先生去地面上冒險，病人們冒險接受娜塔莎的治療……",
      },
      {
        "en-us":
          "Under the leadership of Hook, children can also have their own adventures!",
        "zh-cn": "在虎克的带领下，孩子们也要有自己的冒险！",
        "zh-tw": "在虎克的帶領下，孩子們也要有自己的冒險！",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 1.68,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        MWW4: 1,
        MWW2: 1,
        WBD4: 1,
        WBD2: 1,
        RA2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Fire Boost %) * (100% - CR% + CR% x (100% + CD%)) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 火属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (速度/ 100) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 火屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * (速度/ 100) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * ((S) / 100) * (RS)",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Destruction",
    element: "Fire",
    pathIcon: destructionIcon,
    elementIcon: fireIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1210",
    name: "guinaifen",
    translation: {
      "en-us": "Guinaifen",
      "zh-cn": "桂乃芬",
      "zh-tw": "桂乃芬",
    },
    story: [
      {
        "en-us":
          "An outworlder who ended up residing on the Xianzhou by accident. She is now a passionate and vivacious street performer.",
        "zh-cn": "因机缘巧合留在仙舟的化外民，如今是热情烂漫的街头艺人。",
        "zh-tw": "冒險集團「鼴鼠黨」的頭頭，自稱「漆黑的虎克大人」。",
      },
      {
        "en-us":
          "With her real name being Guinevere, Guinaifen is the Xianzhou name given to her by her good friend Sushang.",
        "zh-cn": "本名「格妮薇儿」，「桂乃芬」是好友素裳为她起的仙舟名。",
        "zh-tw": "本名「格妮薇兒」，「桂乃芬」是好友素裳為她起的仙舟名。",
      },
      {
        "en-us":
          "Faced with a whole new life on the Loufu and relying on her adoration of Xianzhou culture, Guinaifen quickly learned skills that would keep her clothed and fed — such as slurping noodles in a handstand, smashing slabs without harming the people it was placed upon,catching bullets with bare hands, and so on.",
        "zh-cn":
          "面对「罗浮」的全新人生，凭着对仙舟文化的热爱，桂乃芬很快学到了安身立命的一技之长——倒立吃面条、胸口碎大石、徒手接子弹等等。",
        "zh-tw":
          "面對「羅浮」的全新人生，憑著對仙舟文化的熱愛，桂乃芬很快學到了安身立命的一技之長——倒立吃麵條、胸口碎大石、徒手接子彈等等。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 1.68,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        MWW4: 1,
        MWW2: 1,
        WBD4: 1,
        WBD2: 1,
        RA2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Fire Boost %) * (100% - CR% + CR% x (100% + CD%)) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 火属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (速度/ 100) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 火屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * (速度/ 100) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * ((S) / 100) * (RS)",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Nihility",
    element: "Fire",
    pathIcon: nihilityIcon,
    elementIcon: fireIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1212",
    name: "jingliu",
    translation: {
      "en-us": "Jingliu",
      "zh-cn": "镜流",
      "zh-tw": "鏡流",
    },
    story: [
      {
        "en-us":
          'One of the legendary heroes making up the High-Cloud Quintet, and bestowed with the title "Transcendent Flash."',
        "zh-cn": "傳奇「雲上五驍」之一，人送尊號「無罅飛光」。",
        "zh-tw": "傳奇「雲上五驍」之一，人送尊號「無罅飛光」。",
      },
      {
        "en-us":
          "Having ascended beyond mortal concepts of victory, she chose to walk a different path to obtain the power capable of slaying gods.",
        "zh-cn":
          "超脫了人間的勝負，為了獲得斬殺「神」的力量，她選擇走上截然不同的道路。",
        "zh-tw":
          "超脫了人間的勝負，為了獲得斬殺「神」的力量，她選擇走上截然不同的道路。",
      },
      {
        "en-us":
          "Thereafter, one Sword Champion of the Luofu was removed from the Xianzhou's records, and one traitor erased from the annuals was added.",
        "zh-cn":
          "至此之後，仙舟的紀錄中少了一個羅浮「劍首」，多了一個名字被抹去的「叛徒」。",
        "zh-tw":
          "至此之後，仙舟的紀錄中少了一個羅浮「劍首」，多了一個名字被抹去的「叛徒」。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 1.68,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        GBS4: 1,
        HGF4: 1,
        SSS2: 0.9,
        RA2: 1,
      },
      name: {
        "en-us": "Talent",
        "zh-cn": "天赋",
        "zh-tw": "天賦",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Ice Boost %) * (100% + CD% / 5) * (100% - CR% + CR% x (100% + CD%)) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 冰属性伤害提高 %) * (100% + 暴伤% / 5) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (速度/ 100) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 冰屬性傷害提高 %) * (100% + 暴傷% / 5) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * (速度/ 100) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * (100%+(ED)) * (100%+(CD)/5) * (100%-(CR) + (CR)*(100%+(CD))) * ((S) / 100) * (RS) + (50%-(CR)) * 2000",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Ice",
    pathIcon: destructionIcon,
    elementIcon: iceIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1204",
    name: "jing-yuan",
    translation: {
      "en-us": "Jing Yuan",
      "zh-cn": "景元",
      "zh-tw": "景元",
    },
    story: [
      {
        "en-us":
          "Although his appearance may be one of indolence, the Cloud Knight general who commands the Xianzhou Luofu is more meticulous than seemingly meets the eye.",
        "zh-cn": "位列帝弓七天将之一的「神策将军」，外表懒散、心思缜密。",
        "zh-tw": "位列帝弓七天將之一的「神策將軍」，外表懶散、心思縝密。",
      },
      {
        "en-us":
          "He does not consider saving a situation from the brink of disaster to be a show of wisdom, and is thus fastidious with routine affairs to avoid any potential problems.",
        "zh-cn":
          "不以危局中力挽狂澜为智策，因此在常事上十分下功夫，以免节外生枝。",
        "zh-tw":
          "不以危局中力挽狂瀾為智策，因此在常事上十分下功夫，以免節外生枝。",
      },
      {
        "en-us":
          'Due to his careful management, the Xianzhou have enjoyed many years of peace, with Jing Yuan\'s seemingly lazy demeanor having earned him the moniker of "Dozing General."',
        "zh-cn":
          "因其细心谋划，仙舟承平日久，看似行事慵懒的景元反被送上绰号「闭目将军」。",
        "zh-tw":
          "因其細心謀劃，仙舟承平日久，看似行事慵懶的景元反被送上綽號「閉目將軍」。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 1.68,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        BST4: 1,
        BST2: 1,
        AGD4: 1,
        AGD2: 1,
        MWW4: 0.81,
        MWW2: 0.9,
        SSS2: 1,
        IS2: 0.95,
      },
      name: {
        "en-us": "Talent",
        "zh-cn": "天赋",
        "zh-tw": "天賦",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Lightning Boost %) * (100% - CR% + CR% x (100% + CD%)) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 雷属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (速度/ 100) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 雷屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * (速度/ 100) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * ((S) / 100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Erudition",
    element: "Lightning",
    pathIcon: eruditionIcon,
    elementIcon: lightningIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1005",
    name: "kafka",
    translation: {
      "en-us": "Kafka",
      "zh-cn": "卡芙卡",
      "zh-tw": "卡芙卡",
    },
    story: [
      {
        "en-us":
          "On the Interastral Peace Corporation's wanted list, Kafka's entry only has two things — her name, and a single sentence: \"Likes collecting coats.\"",
        "zh-cn":
          "在星际和平公司的通缉档案里，卡芙卡只留下了名字和「爱好收集大衣」的纪录。",
        "zh-tw":
          "在星際和平公司的通緝檔案裡，卡芙卡只留下了名字和「愛好收集大衣」的紀錄。",
      },
      {
        "en-us":
          "Little is known about this Stellaron Hunter, other than that she is one of Destiny's Slave Elio's most trusted members.",
        "zh-cn":
          "人们对这位星核猎手所知甚少，只知道她是「命运的奴隶」艾利欧最信任的成员之一。",
        "zh-tw":
          "人們對這位星核獵手所知甚少，只知道她是「命運的奴隸」艾利歐最信任的成員之一。",
      },
      {
        "en-us":
          "In order to achieve Elio's envisioned future, Kafka gets to work.",
        "zh-cn": "为了到达艾利欧预见的「未来」，卡芙卡开始行动。",
        "zh-tw": "為了到達艾利歐預見的「未來」，卡芙卡開始行動。",
      },
    ],
    formula: {
      stats: {
        A: 0.13,
        AR: 1.5,
        BE: 0.5,
        CR: 0.5,
        CD: 0.25,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 1.68,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 1,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        BST4: 1,
        BST2: 1,
        MWW4: 0.81,
        MWW2: 0.9,
        MTH4: 0.81,
        MTH2: 0.9,
        SSS2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Lightning Boost %) * (100% + Break Effect % / 8) * (100% + Effect Hit Rate % / 8) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 雷属性伤害提高 %) * (100% + 击破特攻 % / 8) * (100% + 效果命中 % / 8) * (速度/ 100) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 雷屬性傷害提高 %) * (100% + 擊破特攻 % / 8) * (100% + 效果命中 % / 8) * (速度/ 100) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * (100%+(ED)) * (100%+(BE)/8) * (100%+(EH)/8) * ((S) / 100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Lightning",
    pathIcon: nihilityIcon,
    elementIcon: lightningIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1111",
    name: "luka",
    translation: {
      "en-us": "Luka",
      "zh-cn": "卢卡",
      "zh-tw": "盧卡",
    },
    story: [
      {
        "en-us":
          "An optimistic and carefree fighter with a mechanical arm. Skilled in mixed martial arts and is a Wildfire member.",
        "zh-cn": "乐观阳光、不拘小节的机械臂自由格斗家，「地火」成员之一。",
        "zh-tw": "樂觀陽光、不拘小節的機械臂自由格鬥家，「地火」成員之一。",
      },
      {
        "en-us":
          "From the fight cage to the battlefield and from a fighter to a warrior, Luka uses his strength to protect the people of the Underworld.",
        "zh-cn":
          "从拳台到战场，从拳击手到战士，卢卡用这份力量去守护下层区的人们。",
        "zh-tw":
          "從拳台到戰場，從拳擊手到戰士，盧卡用這份力量去守護下層區的人們。",
      },
      {
        "en-us":
          "He wishes to bring hope to others precisely because he had experienced despair himself.",
        "zh-cn": "正因为自己曾经体会过绝望，所以他更渴望将希望带给其他人。",
        "zh-tw": "正因為自己曾經體會過絕望，所以他更渴望將希望帶給其他人。",
      },
    ],
    formula: {
      stats: {
        A: 0.13,
        AR: 1.5,
        BE: 0.5,
        CR: 0.5,
        CD: 0.25,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 1.68,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 1,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us": "(198% X ATT) * (100% + Physical Boost %)",
        "zh-cn": "(198% X 攻击力) * (100% + 物理属性伤害提高 %)",
        "zh-tw": "(198% X 攻擊力) * (100% + 物理屬性傷害提高 %)",
      },
      calculation: "(198% * (A)) * (100%+(ED))",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Nihility",
    element: "Physical",
    pathIcon: nihilityIcon,
    elementIcon: physicalIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1215",
    name: "hanya",
    translation: {
      "en-us": "Hanya",
      "zh-cn": "寒鸦",
      "zh-tw": "寒鴉",
    },
    story: [
      {
        "en-us":
          "One of the judges of the Xianzhou Luofu's Ten-Lords Commission.",
        "zh-cn": "仙舟「罗浮」十王司的判官之一",
        "zh-tw": "仙舟「羅浮」十王司的判官之一。",
      },
      {
        "en-us":
          "Ordained by the Ten-Lords and wielding the authority of the Oracle Brush, she reads the multitudes of human sins and transgressions, then issues punishments and karmic retribution.",
        "zh-cn": "受命十王，执掌冥谶天笔，读取罪业种种，并下达业报判罚。",
        "zh-tw": "受命十王，執掌冥讖天筆、讀取罪業種種，並下達業報判罰。",
      },
    ],
    formula: {
      stats: {
        A: 0.13,
        AR: 1.5,
        BE: 0.5,
        CR: 0.5,
        CD: 0.25,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 1.68,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 1,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us": "(198% X ATT) * (100% + Physical Boost %)",
        "zh-cn": "(198% X 攻击力) * (100% + 物理属性伤害提高 %)",
        "zh-tw": "(198% X 攻擊力) * (100% + 物理屬性傷害提高 %)",
      },
      calculation: "(198% * (A)) * (100%+(ED))",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Harmony",
    element: "Physical",
    pathIcon: harmonyIcon,
    elementIcon: physicalIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1203",
    name: "luocha",
    translation: {
      "en-us": "Luocha",
      "zh-cn": "罗刹",
      "zh-tw": "羅剎",
    },
    story: [
      {
        "en-us":
          "A handsome blond young man who carries a giant coffin on his back.",
        "zh-cn": "金发俊雅的年轻人，背着巨大的棺椁。",
        "zh-tw": "金發俊雅的年輕人，背著巨大的棺槨。",
      },
      {
        "en-us":
          "As an intergalactic merchant, he was unfortunately caught in the Xianzhou Luofu's Stellaron crisis.",
        "zh-cn": "身为天外行商的他，不幸被卷入仙舟罗浮的星核危机。",
        "zh-tw": "身為天外行商的他，不幸被捲入仙舟羅浮的星核危機。",
      },
      {
        "en-us":
          "And that is how he found his mastery of medicine to come in handy.",
        "zh-cn": "一手精湛医术莫名有了用武之地。",
        "zh-tw": "一手精湛醫術莫名有了用武之地。",
      },
    ],
    formula: {
      stats: {
        A: 0.1,
        AR: 1.5,
        BE: 0.1,
        CR: 0.2,
        CD: 0.1,
        D: 0.02,
        DR: 0.5,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 1.5,
        H: 0.05,
        HR: 1.5,
        O: 1.8,
        S: 2.5,
      },
      name: {
        "en-us": "Skill",
        "zh-cn": "战技",
        "zh-tw": "戰技",
      },
      description: {
        "en-us": "(40% X ATK) * (100% + Outgoing Healing Boost %)",
        "zh-cn": "(40% X 攻击力) * (100% + 治疗量加成 %)",
        "zh-tw": "(40% X 攻擊力) * (100% + 治療量加成 %)",
      },
      calculation: "(40% * (A)) * (100%+(O))",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Abundance",
    element: "Imaginary",
    pathIcon: abundanceIcon,
    elementIcon: imaginaryIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1001",
    name: "march7th",
    translation: {
      "en-us": "March 7th",
      "zh-cn": "三月七",
      "zh-tw": "三月七",
    },
    story: [
      {
        "en-us":
          "A spirited, quirky young girl who is into all the things girls her age should be interested in, for example, taking photos.",
        "zh-cn":
          "精灵古怪的少女，热衷于这个年纪的女孩子应当「热衷」的所有事，比如照相。",
        "zh-tw":
          "精靈古怪的少女，熱衷於這個年紀的女孩子應當「熱衷」的所有事，比如照相。",
      },
      {
        "en-us":
          "She was awakened from a piece of drifting eternal ice only to find out that she knows nothing about herself or her past. While initially in low spirits due to her lack of identity, she decided to name herself after the date she came into this new life.",
        "zh-cn":
          "从一块漂流的恒冰中苏醒，却发现自己对身世与过往都一无所知。短暂的消沉之后，她决定以重获新生的日期为自己命名。",
        "zh-tw":
          "從一塊漂流的恆冰中甦醒，卻發現自己對身世與過往都一無所知。短暫的消沉之後，她決定以重獲新生的日期為自己命名。",
      },
      {
        "en-us": "And thus, on that day, March 7th was born.",
        "zh-cn": "这一天，三月七「诞生」了。",
        "zh-tw": "這一天，三月七「誕生」了。",
      },
    ],
    formula: {
      stats: {
        A: 0.02,
        AR: 0.2,
        BE: 0.2,
        CR: 0.4,
        CD: 0.2,
        D: 0.04,
        DR: 1.2,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 1.5,
        ER: 1.5,
        H: 0.05,
        HR: 1.5,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        KPP4: 1,
        GWS2: 1,
        BA2: 1,
        FA2: 0.9,
        BK2: 0.9,
      },
      name: {
        "en-us": "Skill",
        "zh-cn": "战技",
        "zh-tw": "戰技",
      },
      description: {
        "en-us":
          "(100% + Energy Regeneration Rate %) * (100% + Effect Hit %) * (100% + Effect RES %) * (Speed / 100) * (HP / 100) * (DEF / 100) * Relic Set",
        "zh-cn":
          "(100% + 能量恢复效率 %) * (100% + 效果命中 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防御力 / 100) * 遗器套装",
        "zh-tw":
          "(100% + 能量恢復效率 %) * (100% + 效果命中 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防禦力 / 100) * 遺器套裝",
      },
      calculation:
        "(100%+(EG)) * (100%+(EH)) * (100%+(ER)) * ((S) / 100) * ((H)/100) * ((D)/100) * (RS)",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Preservation",
    element: "Ice",
    pathIcon: preservationIcon,
    elementIcon: iceIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1224",
    name: "march7th-hunt",
    translation: {
      "en-us": "March 7th",
      "zh-cn": "三月七",
      "zh-tw": "三月七",
    },
    story: [
      {
        "en-us":
          "March 7th in a Xianzhou-styled outfit. A sword-wielding female martial artist.",
        "zh-cn": "换上仙舟服饰的三月七，执剑的武侠少女。",
        "zh-tw": "換上仙舟服飾的三月七，執劍的武俠少女。",
      },
      {
        "en-us":
          "Learning swordplay from both Yunli and Yanqing, she is eager to create more beautiful memories on the Xianzhou.",
        "zh-cn":
          "向云璃与彦卿拜师学艺，为在仙舟留下更多美好的「回忆」而跃跃欲试。",
        "zh-tw":
          "向雲璃與彥卿拜師學藝，為在仙舟留下更多美好的「回憶」而躍躍欲試。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 1.68,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        MWW4: 1,
        MWW2: 1,
        WBD4: 1,
        WBD2: 1,
        RA2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Imaginary Boost %) * (100% - CR% + CR% x (100% + CD%)) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 虚数属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (速度/ 100) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 虛數屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * (速度/ 100) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * ((S) / 100) * (RS)",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Hunt",
    element: "Imaginary",
    pathIcon: huntIcon,
    elementIcon: imaginaryIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1225",
    name: "fugue",
    translation: {
      "en-us": "Fugue",
      "zh-cn": "忘归人",
      "zh-tw": "忘歸人",
    },
    story: [
      {
        "en-us":
          "A tactful foxian girl, whose appearance, name, and identity have all been stolen.",
        "zh-cn": "八面玲珑的狐人少女，样貌、名字、身份皆被人夺去。",
        "zh-tw": "八面玲瓏的狐人少女，樣貌、名字、身分皆被人奪去。",
      },
      {
        "en-us":
          "The fates have left her a thread of chance at survival, yet the brand of Destruction still writhes with anticipation.",
        "zh-cn": "命运为她留下一线生机，而「毁灭」的烙印仍在蠢蠢欲动。",
        "zh-tw": "命運為她留下一線生機，而「毀滅」的烙印仍在蠢蠢欲動。",
      },
      {
        "en-us":
          "The one in a fugue who has experienced life and death and is given a new life... when would she be able to return home?",
        "zh-cn": "历经生死、重获新生的忘归人，何时才能返乡？",
        "zh-tw": "歷經生死、重獲新生的忘歸人，何時才能返鄉？",
      },
    ],
    formula: {
      stats: {
        A: 0.02,
        AR: 0.2,
        BE: 1.15,
        CR: 0.2,
        CD: 0.1,
        D: 0.04,
        DR: 1.2,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 1.5,
        ER: 1.5,
        H: 0.05,
        HR: 1.5,
        O: 1.8,
        S: 2.5,
      },
      relic_set_stats: {
        SRO2: 1,
        MTH2: 1,
        WMDM2: 1,
        TSM2: 1,
        ICAS2: 1,
        FKL2: 1,
        TKB2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% + Break Effect % / 8) * (100% + Effect Hit Rate % / 8) * (Speed / 100) * (HP / 100) * (DEF / 100) * Relic Set",
        "zh-cn":
          "(100% + 击破特攻 % / 8) * (100% + 效果命中 % / 8) * (速度/ 100) * (生命值 / 100) * (防御力 / 100) * 遗器套装",
        "zh-tw":
          "(100% + 擊破特攻 % / 8) * (100% + 效果命中 % / 8) * (速度/ 100) * (生命值 / 100) * (防禦力 / 100) * 遺器套裝",
      },
      calculation:
        "(100%+(BE)/8) * (100%+(EH)/8) * ((S) / 100) * ((H)/100) * ((D)/100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Fire",
    pathIcon: nihilityIcon,
    elementIcon: fireIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1105",
    name: "natasha",
    translation: {
      "en-us": "Natasha",
      "zh-cn": "娜塔莎",
      "zh-tw": "娜塔莎",
    },
    story: [
      {
        "en-us": "A fastidious doctor who always wears a curious smile.",
        "zh-cn": "做事严谨的医生，总带着难以捉摸的微笑。",
        "zh-tw": "做事嚴謹的醫生，總帶著難以捉摸的微笑。",
      },
      {
        "en-us":
          "In the Underworld where medical resources are few and far between, Natasha is one of the very few doctors whom the people can turn to.",
        "zh-cn":
          "在医疗资源匮乏的下层区，娜塔莎作为为数不多的医生照料着地下的男女老幼。",
        "zh-tw":
          "在醫療資源匱乏的下層區，娜塔莎作為為數不多的醫生照料著地下的男女老幼。",
      },
      {
        "en-us":
          'Even the rambunctious Hook would politely greet her..."Hi, Auntie Natasha."',
        "zh-cn": "即使是最调皮的虎克，见了她也要乖乖喊一声「娜塔莎姐姐」。",
        "zh-tw": "即使是最調皮的虎克，見了她也要乖乖喊一聲「娜塔莎姐姐」。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 0.2,
        BE: 0.5,
        CR: 0.2,
        CD: 0.1,
        D: 0.04,
        DR: 1.2,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.2,
        ER: 1.5,
        H: 0.05,
        HR: 1.5,
        O: 1.8,
        S: 2.5,
      },
      relic_set_stats: {
        MTH2: 1,
        MTH4: 1,
        PWC4: 1,
        PWC2: 1,
        LD2: 1,
        FA2: 1,
        BK2: 1,
        SV2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% + Energy Regeneration Rate %) * (100% + Effect RES %) * (Speed / 100) * (100% + Outgoing Healing Boost %) * (HP / 100) * (DEF / 100)  * Relic Set",
        "zh-cn":
          "(100% + 能量恢复效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (100% + 治疗量加成 %) * (生命值 / 100) * (防御力 / 100) * 遗器套装",
        "zh-tw":
          "(100% + 能量恢復效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (100% + 治療量加成 %) * (生命值 / 100) * (防禦力 / 100) * 遺器套裝",
      },
      calculation:
        "(100%+(EG)) * (100%+(ER)) * ((S) / 100) * (100%+(O)) * ((H)/100) * ((D)/100) * (RS)",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Abundance",
    element: "Physical",
    pathIcon: abundanceIcon,
    elementIcon: physicalIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1106",
    name: "pela",
    translation: {
      "en-us": "Pela",
      "zh-cn": "佩拉",
      "zh-tw": "佩拉",
    },
    story: [
      {
        "en-us":
          "The meticulous Intelligence Officer of the Silvermane Guards. While young, she is undeniably brilliant.",
        "zh-cn": "行事周密的银鬃铁卫情报官，年纪不大但头脑出众。",
        "zh-tw": "行事周密的銀鬃鐵衛情報官，年紀不大但頭腦出眾。",
      },
      {
        "en-us":
          "Whether it relates to maneuvering troops, distributing supplies, or the terrain, Pela can answer any problems with calm certainty.",
        "zh-cn":
          "无论是部队调动、物资分配还是地形状况，佩拉都能冷静地即问即答，毫无错漏。",
        "zh-tw":
          "無論是部隊調動、物資分配還是地形狀況，佩拉都能冷靜地即問即答，毫無錯漏。",
      },
      {
        "en-us":
          'As for her phone case..."It has nothing to do with work, captain."',
        "zh-cn": "至于佩拉的手机壳…「这与工作无关，长官。」",
        "zh-tw": "至於佩拉的手機殼…「這與工作無關，長官。」",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 0.5,
        BE: 0.5,
        CR: 0.2,
        CD: 0.1,
        D: 0.04,
        DR: 1.2,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 1.5,
        ER: 1.5,
        H: 0.05,
        HR: 1.5,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        ETL4: 1,
        LD2: 1,
        MTH2: 1,
        FA2: 1,
        BK2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% + Energy Regeneration Rate %) * (100% + Effect RES %) * (Speed / 100) * (HP / 100) * (DEF / 100) * Relic Set",
        "zh-cn":
          "(100% + 能量恢复效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防御力 / 100) * 遗器套装",
        "zh-tw":
          "(100% + 能量恢復效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防禦力 / 100) * 遺器套裝",
      },
      calculation:
        "(100%+(EG)) * (100%+(ER)) * ((S) / 100) * ((H)/100) * ((D)/100) * (RS)",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Nihility",
    element: "Ice",
    pathIcon: nihilityIcon,
    elementIcon: iceIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1201",
    name: "qingque",
    translation: {
      "en-us": "Qingque",
      "zh-cn": "青雀",
      "zh-tw": "青雀",
    },
    story: [
      {
        "en-us":
          "An average Diviner of the Divination Commission, who will never slack off when it comes to slacking off.",
        "zh-cn": "太卜司的普通卜者，在「忙里偷闲」这件事上绝不偷闲。",
        "zh-tw": "太卜司的普通卜者，在「忙裡偷閒」這件事上絕不偷閒。",
      },
      {
        "en-us":
          "She passed the Divination Commission's entrance exam to please her parents, only to discover what she had originally thought to be a relaxing public servant job to instead be very intensive and a worker's nightmare.",
        "zh-cn":
          "顺应父母的期望考入太卜司，却发现本以为清闲的铁饭碗是高强度的职场苦海。",
        "zh-tw":
          "順應父母的期望考入太卜司，卻發現本以為清閒的鐵飯碗是高強度的職場苦海。",
      },
      {
        "en-us":
          "After several years of experience, Qingque had finally honed her craft — No matter which department she changes to, she remains the lowest level of Diviners.",
        "zh-cn":
          "经过数年历练，青雀终于磨砺了一身本领——无论部门流转，她仍旧是最低职级的卜者。",
        "zh-tw":
          "經過數年曆練，青雀終於磨礪了一身本領——無論部門流轉，她仍舊是最低職級的卜者。",
      },
      {
        "en-us":
          '"When there\'s nothing else left to do, why not bury your head in a book or play cards? What more could I ask for?"',
        "zh-cn": "没事翻翻书，玩玩古代牌戏…人生如此，夫复何求？",
        "zh-tw": "沒事翻翻書，玩玩古代牌戲…人生如此，夫復何求？",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 1.68,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(120% X ATT) * (100% + Quantum Boost %) * (100% - CR% + CR% x (100% + CD%))",
        "zh-cn":
          "(120% X 攻击力) * (100% + 量子属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%))",
        "zh-tw":
          "(120% X 攻擊力) * (100% + 量子屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%))",
      },
      calculation:
        "(120% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD)))",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Erudition",
    element: "Quantum",
    color: "#1C29BA",
    pathIcon: eruditionIcon,
    elementIcon: quantumIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1108",
    name: "sampo",
    translation: {
      "en-us": "Sampo",
      "zh-cn": "桑博",
      "zh-tw": "桑博",
    },
    story: [
      {
        "en-us":
          "A silver-tongued salesman. Where there is profit to be made, you can be sure Sampo is nearby.",
        "zh-cn": "口若悬河的倒货商人，只要有「利」的地方，就有桑博的身影。",
        "zh-tw": "口若懸河的倒貨商人，只要有「利」的地方，就有桑博的身影。",
      },
      {
        "en-us":
          'Sampo\'s unique knowledge makes it hard not to approach him for help, but becoming his "customer" is not necessarily a good thing.',
        "zh-cn":
          "桑博手中绝无仅有的情报让人不得不接近他，不过成为他的「客人」并不是什么好事。",
        "zh-tw":
          "桑博手中絕無僅有的情報讓人不得不接近他，不過成為他的「客人」並不是什麼好事。",
      },
      {
        "en-us":
          'After all, "customers" can quickly turn into "commodities" for the right price.',
        "zh-cn": "毕竟只要价钱合适，「客人」也随时可以转化为「商品」。",
        "zh-tw": "畢竟只要價錢合適，「客人」也隨時可以轉化為「商品」。",
      },
    ],
    formula: {
      stats: {
        A: 0.13,
        AR: 1.5,
        BE: 0.5,
        CR: 0.5,
        CD: 0.25,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 1.68,
        EG: 3.35,
        EH: 1,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us": "(96% X ATT) * (100% + Wind Boost %)",
        "zh-cn": "(96% X 攻击力) * (100% + 风属性伤害提高 %)",
        "zh-tw": "(96% X 攻擊力) * (100% + 風屬性傷害提高 %)",
      },
      calculation: "(96% * (A)) * (100%+(ED))",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Nihility",
    element: "Wind",
    pathIcon: nihilityIcon,
    elementIcon: windIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1102",
    name: "seele",
    translation: {
      "en-us": "Seele",
      "zh-cn": "希儿",
      "zh-tw": "希兒",
    },
    story: [
      {
        "en-us":
          "A spirited and valiant member of Wildfire who grew up in the perilous Underworld of Belobog. She is accustomed to being on her own.",
        "zh-cn":
          "飒爽俊逸的「地火」成员，成长于地底危险混乱的环境，习惯独来独往。",
        "zh-tw":
          "颯爽俊逸的「地火」成員，成長於地底危險混亂的環境，習慣獨來獨往。",
      },
      {
        "en-us":
          "The protectors and the protected, the oppressors and the oppressed... The world Seele grew up knowing was just a simple dichotomy...",
        "zh-cn":
          "保护与被保护，压迫与被压迫，世界向希儿展示的始终是非黑即白的那一面——",
        "zh-tw":
          "保護與被保護，壓迫與被壓迫，世界向希兒展示的始終是非黑即白的那一面——",
      },
      {
        "en-us": 'That is, until "that girl" appeared.',
        "zh-cn": "直至「那名少女」的出现。",
        "zh-tw": "直至「那名少女」的出現。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 1.68,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        GBS4: 1,
        GBS2: 1,
        RA2: 1,
        FF2: 1,
        SSS2: 0.98,
        IS2: 0.98,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Quantum Boost %) * (100% + CD% / 5) * (100% - CR% + CR% x (100% + CD%)) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 量子属性伤害提高 %) * (100% + 暴伤% / 5) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (速度 / 100) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 量子屬性傷害提高 %) * (100% + 暴傷% / 5) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * (速度 / 100) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * (100%+(ED)) * (100%+(CD)/5) * (100%-(CR) + (CR)*(100%+(CD))) * ((S) / 100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Hunt",
    element: "Quantum",
    pathIcon: huntIcon,
    elementIcon: quantumIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1103",
    name: "serval",
    translation: {
      "en-us": "Serval",
      "zh-cn": "希露瓦",
      "zh-tw": "希露瓦",
    },
    story: [
      {
        "en-us":
          "The free and rebellious eldest daughter of the Landau family, once a close friend of Cocolia, her interests has now led her to become a mechanic.",
        "zh-cn":
          "自由叛逆的朗道家长女，曾是可可利亚的挚友，如今是兴趣使然的机械师。",
        "zh-tw":
          "自由叛逆的朗道家長女，曾是可可利亞的摯友，如今是興趣使然的機械師。",
      },
      {
        "en-us":
          "In the perpetually winter-stricken Belobog, she opened a workshop called \"Neverwinter\" that puts business on hold from time to time for rock 'n' roll performances.",
        "zh-cn":
          "在永冬的贝洛伯格经营着名为「永动」的机械屋，时不时停业举办摇滚露天演出。",
        "zh-tw":
          "在永冬的貝洛伯格經營著名為「永動」的機械屋，時不時停業舉辦搖滾露天演出。",
      },
      {
        "en-us":
          "And should anyone ask her about the workshop's profitability...",
        "zh-cn": "如果有人过问机械屋怎么赚钱…",
        "zh-tw": "如果有人過問機械屋怎麼賺錢…",
      },
      {
        "en-us": '"This is just a hobby, dear. I\'m not short of money."',
        "zh-cn": "「这是兴趣，亲爱的，我不缺钱。」",
        "zh-tw": "「這是興趣，親愛的，我不缺錢。」",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 1.68,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(108% X ATT) * (100% + Lightning Boost %) * (100% - CR% + CR% x (100% + CD%))",
        "zh-cn":
          "(108% X 攻击力) * (100% + 雷属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%))",
        "zh-tw":
          "(108% X 攻擊力) * (100% + 雷屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%))",
      },
      calculation:
        "(108% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD)))",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Erudition",
    element: "Lightning",
    pathIcon: eruditionIcon,
    elementIcon: lightningIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1006",
    name: "silver-wolf",
    translation: {
      "en-us": "Silver Wolf",
      "zh-cn": "银狼",
      "zh-tw": "銀狼",
    },
    story: [
      {
        "en-us": "The universe is just another game to this super hacker.",
        "zh-cn": "将宇宙视为游戏的超级骇客。",
        "zh-tw": "將宇宙視為遊戲的超級駭客。",
      },
      {
        "en-us":
          "No matter how thorny the defense system, Silver Wolf can crack it with ease. Her hacking battle with Screwllum of the Genius Society has become stuff of legends in the hacking world.",
        "zh-cn":
          "无论怎样棘手的防御系统，银狼都能轻松破解。她与「天才俱乐部」螺丝咕姆的数据攻防战，现已成为骇客界的传说。",
        "zh-tw":
          "無論怎樣棘手的防禦系統，銀狼都能輕鬆破解。她與「天才俱樂部」螺絲咕姆的數據攻防戰，現已成為駭客界的傳說。",
      },
      {
        "en-us":
          "How many more levels are there to beat in the universe? Silver Wolf looks forward to finding out.",
        "zh-cn": "宇宙中还有多少亟待攻破的关卡？银狼对此十分期待。",
        "zh-tw": "宇宙中還有多少亟待攻破的關卡？銀狼對此十分期待。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 1.68,
        DBW: 0,
        EG: 3.35,
        EH: 1.5,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        GBS4: 1,
        GBS2: 1,
        PGCE2: 1,
        IS2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Quantum Boost %) * (100% - CR% + CR% x (100% + CD%)) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 量子属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 量子屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Quantum",
    pathIcon: nihilityIcon,
    elementIcon: quantumIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1206",
    name: "sushang",
    translation: {
      "en-us": "Sushang",
      "zh-cn": "素裳",
      "zh-tw": "素裳",
    },
    story: [
      {
        "en-us":
          "A naive and enthusiastic newcomer to the Cloud Knights who wields a greatsword.",
        "zh-cn": "单纯热心的云骑军新人，执一柄重剑。",
        "zh-tw": "單純熱心的雲騎軍新人，執一柄重劍。",
      },
      {
        "en-us":
          "She yearns for the historic legends of the Cloud Knights, and is eager to become such a legendary figure herself.",
        "zh-cn": "憧憬着云骑军历史上的传奇，渴望成为响当当的人物。",
        "zh-tw": "憧憬著雲騎軍歷史上的傳奇，渴望成為響噹噹的人物。",
      },
      {
        "en-us":
          'As such, Sushang firmly believes in the philosophies "be eager to help those in need," "do one good deed a day and reflect on oneself three times a day," leading her to busy days full of helping others.',
        "zh-cn":
          "为此，素裳坚决恪守「急人所急，有求必应；日行一善，三省吾身」的信条，过着助人为乐的忙碌日子。",
        "zh-tw":
          "為此，素裳堅決恪守「急人所急，有求必應；日行一善，三省吾身」的信條，過著助人為樂的忙碌日子。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 1.68,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(192% X ATT) * (100% + Physical Boost %) * (100% - CR% + CR% x (100% + CD%))",
        "zh-cn":
          "(192% X 攻击力) * (100% + 物理属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%))",
        "zh-tw":
          "(192% X 攻擊力) * (100% + 物理屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%))",
      },
      calculation:
        "(192% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD)))",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Hunt",
    element: "Physical",
    pathIcon: huntIcon,
    elementIcon: physicalIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1202",
    name: "tingyun",
    translation: {
      "en-us": "Tingyun",
      "zh-cn": "停云",
      "zh-tw": "停雲",
    },
    story: [
      {
        "en-us":
          "A silver-tongued Foxian girl, Tingyun is the Head Representative of the Whistling Flames, a merchant guild officially approved by the Sky-Faring Commission.",
        "zh-cn": "八面玲珑的狐人少女，天舶司商团「鸣火」的首席代表。",
        "zh-tw": "八面玲瓏的狐人少女，天舶司商團「鳴火」的首席代表。",
      },
      {
        "en-us":
          "She has such a way with words that often leaves her audience eagerly waiting for more of her captivating tales. As a result of her supervision, the Xianzhou trade fairs are now known throughout the galaxy.",
        "zh-cn":
          "停云天生生得一副慧心妙舌，但凡她开口，人们就免不了想听她多说几句。在她的调度下，仙舟的贸易庆典逐渐声名远扬。",
        "zh-tw":
          "停雲天生生得一副慧心妙舌，但凡她開口，人們就免不了想听她多說幾句。在她的調度下，仙舟的貿易慶典逐漸聲名遠揚。",
      },
      {
        "en-us":
          "\"Try one's best to avoid conflict when possible, and persuade those who can be persuaded\" — that's Tingyun's motto.",
        "zh-cn":
          "能不战斗就尽量不去战斗，能劝为己用就尽量劝为己用——这便是停云的原则。",
        "zh-tw":
          "能不戰鬥就盡量不去戰鬥，能勸為己用就盡量勸為己用——這便是停雲的原則。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 0.2,
        CD: 0.1,
        D: 0.04,
        DR: 1.2,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 1.5,
        H: 0.05,
        HR: 1.5,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        MTH4: 1,
        MTH2: 1,
        MWW4: 1,
        MWW2: 1,
        LD2: 1,
        FA2: 1,
        SV2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% + Energy Regeneration Rate %) * (100% + Effect RES %) * (Speed / 100) * (HP / 100) * (DEF / 100) * Relic Set",
        "zh-cn":
          "(100% + 能量恢复效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防御力 / 100) * 遗器套装",
        "zh-tw":
          "(100% + 能量恢復效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防禦力 / 100) * 遺器套裝",
      },
      calculation:
        "(100%+(EG)) * (100%+(ER)) * ((S) / 100) * ((H)/100) * ((D)/100) * (RS)",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Harmony",
    element: "Lightning",
    pathIcon: harmonyIcon,
    elementIcon: lightningIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1112",
    name: "topaz%26numby",
    translation: {
      "en-us": "Topaz & Numby",
      "zh-cn": "托帕&账账",
      "zh-tw": "托帕&帳賬",
    },
    story: [
      {
        "en-us":
          "Topaz, Senior Manager of the Strategic Investment Department in the Interastral Peace Corporation, and leader of the Special Debts Picket Team.",
        "zh-cn":
          "星际和平公司旗下「战略投资部」高级干部托帕，领导特殊债务纠察小组。",
        "zh-tw":
          "星際和平公司旗下「戰略投資部」高級幹部托帕，領導特殊債務糾察小組。",
      },
      {
        "en-us":
          'Already a member of the "Ten Stonehearts" at a young age, Topaz\'s core stone is the "Topaz of Debt Retrieval." Her partner, the Warp Trotter "Numby", is also capable of acutely perceiving where "riches" are located. It can even perform jobs involving security, debt collection, and actuarial sciences.',
        "zh-cn":
          "年纪轻轻便已成为「石心十人」之一，基石为「催讨黄玉」。搭档次元扑满「账账」则能敏锐感知「财富」所在，即便是安保、催债、精算等工作也不在话下。",
        "zh-tw":
          "年紀輕輕便已成為「石心十人」之一，基石為「催討黃玉」。搭檔次元撲滿「帳帳」則能敏銳感知「財富」所在，即使是保全、催債、精算等工作也不在話下。",
      },
      {
        "en-us":
          "Presently they are traversing the cosmos together, chasing down various debts and liabilities that negatively influence the IPC's commercial ventures.",
        "zh-cn":
          "如今他们正一同巡行银河，追究各类影响公司业务开展的债务纠纷。。",
        "zh-tw":
          "如今他們正一同巡行銀河，追究各類影響公司業務开展的债务纠纷。。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 1.68,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        FLF4: 1,
        FLF2: 1,
        AGD4: 1,
        AGD2: 1,
        MWW4: 0.81,
        MWW2: 0.9,
        SSS2: 1,
        IS2: 0.95,
      },
      name: {
        "en-us": "Talent",
        "zh-cn": "天赋",
        "zh-tw": "天賦",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Fire Boost %) * (100% - CR% + CR% x (100% + CD%)) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 火属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (速度/ 100) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 火屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * (速度/ 100) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * ((S) / 100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Hunt",
    element: "Fire",
    pathIcon: huntIcon,
    elementIcon: fireIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "8001",
    name: "trail-blazer-destruction",
    translation: {
      "en-us": "Trail Blazer",
      "zh-cn": "开拓者",
      "zh-tw": "開拓者",
    },
    story: [
      {
        "en-us":
          "They are awakened during the opening events of the game by Kafka and Silver Wolf,",
        "zh-cn":
          "在反物质军团入侵期间，(他/她)作为星核的载体被卡夫卡和银狼唤醒。",
        "zh-tw":
          "在反物質軍團入侵期間，(他/她)作為星核的載體被卡夫卡和銀狼喚醒。",
      },
      {
        "en-us":
          "who leave them to be found by March 7th and Dan Heng on Herta Space Station during the Antimatter Legion's invasion.",
        "zh-cn":
          "她们离开了空间站「黑塔」并将开拓者留在了这里，之后，开拓者被三月七和丹恒发现，并加入了星穹列车列车组。",
        "zh-tw":
          "她們離開了空間站「黑塔」並將開拓者留在了這裡，之後，開拓者被三月七和丹恆發現，並加入了星穹列車列車組。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 1.68,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(300% X ATT) * (100% + Physical Boost %) * (100% - CR% + CR% x (100% + CD%))",
        "zh-cn":
          "(300% X 攻击力) * (100% + 物理属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%))",
        "zh-tw":
          "(300% X 攻擊力) * (100% + 物理屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%))",
      },
      calculation:
        "(300% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD)))",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Physical",
    pathIcon: destructionIcon,
    elementIcon: physicalIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "8002",
    name: "trail-blazer-destruction",
    translation: {
      "en-us": "Trail Blazer",
      "zh-cn": "开拓者",
      "zh-tw": "開拓者",
    },
    story: [
      {
        "en-us":
          "They are awakened during the opening events of the game by Kafka and Silver Wolf,",
        "zh-cn":
          "在反物质军团入侵期间，(他/她)作为星核的载体被卡夫卡和银狼唤醒。",
        "zh-tw":
          "在反物質軍團入侵期間，(他/她)作為星核的載體被卡夫卡和銀狼喚醒。",
      },
      {
        "en-us":
          "who leave them to be found by March 7th and Dan Heng on Herta Space Station during the Antimatter Legion's invasion.",
        "zh-cn":
          "她们离开了空间站「黑塔」并将开拓者留在了这里，之后，开拓者被三月七和丹恒发现，并加入了星穹列车列车组。",
        "zh-tw":
          "她們離開了空間站「黑塔」並將開拓者留在了這裡，之後，開拓者被三月七和丹恆發現，並加入了星穹列車列車組。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 1.68,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(300% X ATT) * (100% + Physical Boost %) * (100% - CR% + CR% x (100% + CD%))",
        "zh-cn":
          "(300% X 攻击力) * (100% + 物理属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%))",
        "zh-tw":
          "(300% X 攻擊力) * (100% + 物理屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%))",
      },
      calculation:
        "(300% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD)))",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Physical",
    pathIcon: destructionIcon,
    elementIcon: physicalIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "8003",
    name: "trail-blazer-preservation",
    translation: {
      "en-us": "Trail Blazer",
      "zh-cn": "开拓者",
      "zh-tw": "開拓者",
    },
    story: [
      {
        "en-us":
          "They are awakened during the opening events of the game by Kafka and Silver Wolf,",
        "zh-cn":
          "在反物质军团入侵期间，(他/她)作为星核的载体被卡夫卡和银狼唤醒。",
        "zh-tw":
          "在反物質軍團入侵期間，(他/她)作為星核的載體被卡夫卡和銀狼喚醒。",
      },
      {
        "en-us":
          "who leave them to be found by March 7th and Dan Heng on Herta Space Station during the Antimatter Legion's invasion.",
        "zh-cn":
          "她们离开了空间站「黑塔」并将开拓者留在了这里，之后，开拓者被三月七和丹恒发现，并加入了星穹列车列车组。",
        "zh-tw":
          "她們離開了空間站「黑塔」並將開拓者留在了這裡，之後，開拓者被三月七和丹恆發現，並加入了星穹列車列車組。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.04,
        DR: 1.2,
        DBF: 1.68,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(50% X ATT * (100% + Fire Boost %) + 75% X DEF) * (100% - CR% + CR% x (100% + CD%))",
        "zh-cn":
          "(50% X 攻击力 * (100% + 火属性伤害提高 %) + 75% X 防御力) * (100% - 暴击% + 暴伤% x (100% + 暴伤%))",
        "zh-tw":
          "(50% X 攻擊力 * (100% + 火屬性傷害提高 %) + 75% X 防禦力) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%))",
      },
      calculation:
        "(50% * (A) * (100%+(ED)) + 75% * (D)) * (100%-(CR) + (CR)*(100%+(CD)))",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Preservation",
    element: "Fire",
    pathIcon: preservationIcon,
    elementIcon: fireIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "8004",
    name: "trail-blazer-preservation",
    translation: {
      "en-us": "Trail Blazer",
      "zh-cn": "开拓者",
      "zh-tw": "開拓者",
    },
    story: [
      {
        "en-us":
          "They are awakened during the opening events of the game by Kafka and Silver Wolf,",
        "zh-cn":
          "在反物质军团入侵期间，(他/她)作为星核的载体被卡夫卡和银狼唤醒。",
        "zh-tw":
          "在反物質軍團入侵期間，(他/她)作為星核的載體被卡夫卡和銀狼喚醒。",
      },
      {
        "en-us":
          "who leave them to be found by March 7th and Dan Heng on Herta Space Station during the Antimatter Legion's invasion.",
        "zh-cn":
          "她们离开了空间站「黑塔」并将开拓者留在了这里，之后，开拓者被三月七和丹恒发现，并加入了星穹列车列车组。",
        "zh-tw":
          "她們離開了空間站「黑塔」並將開拓者留在了這裡，之後，開拓者被三月七和丹恆發現，並加入了星穹列車列車組。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.04,
        DR: 1.2,
        DBF: 1.68,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(50% X ATT * (100% + Fire Boost %) + 75% X DEF) * (100% - CR% + CR% x (100% + CD%))",
        "zh-cn":
          "(50% X 攻击力 * (100% + 火属性伤害提高 %) + 75% X 防御力) * (100% - 暴击% + 暴伤% x (100% + 暴伤%))",
        "zh-tw":
          "(50% X 攻擊力 * (100% + 火屬性傷害提高 %) + 75% X 防禦力) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%))",
      },
      calculation:
        "(50% * (A) * (100%+(ED)) + 75% * (D)) * (100%-(CR) + (CR)*(100%+(CD)))",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Preservation",
    element: "Fire",
    pathIcon: preservationIcon,
    elementIcon: fireIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "8005",
    name: "trail-blazer-harmony",
    translation: {
      "en-us": "Trail Blazer",
      "zh-cn": "开拓者",
      "zh-tw": "開拓者",
    },
    story: [
      {
        "en-us":
          "They are awakened during the opening events of the game by Kafka and Silver Wolf,",
        "zh-cn":
          "在反物质军团入侵期间，(他/她)作为星核的载体被卡夫卡和银狼唤醒。",
        "zh-tw":
          "在反物質軍團入侵期間，(他/她)作為星核的載體被卡夫卡和銀狼喚醒。",
      },
      {
        "en-us":
          "who leave them to be found by March 7th and Dan Heng on Herta Space Station during the Antimatter Legion's invasion.",
        "zh-cn":
          "她们离开了空间站「黑塔」并将开拓者留在了这里，之后，开拓者被三月七和丹恒发现，并加入了星穹列车列车组。",
        "zh-tw":
          "她們離開了空間站「黑塔」並將開拓者留在了這裡，之後，開拓者被三月七和丹恆發現，並加入了星穹列車列車組。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 1,
        CR: 2,
        CD: 1,
        D: 0.04,
        DR: 1.2,
        DBF: 0,
        DBI: 0,
        DBM: 1.68,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 1.5,
        H: 0.05,
        HR: 1.5,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        WMDM4: 1,
        WMDM2: 1,
        TSM4: 1,
        TSM2: 1,
        TKB2: 1,
        LD2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Imaginary Boost %) * (100% - CR% + CR% x (100% + CD%)) * (100% + Break Effect % / 8) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 虚数属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (100% + 击破特攻 % / 8 * (速度/ 100) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 虛數屬性傷害提高 %) * (100% - 爆擊% + 暴傷% x (100% + 暴傷%)) * (100% + 擊破特攻 % / 8) * (速度/ 100) * 遺器套裝",
      },
      calculation:
        "(100% * (A))  * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * (100%+(BE)/8) * ((S) / 100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Harmony",
    element: "Imaginary",
    pathIcon: harmonyIcon,
    elementIcon: imaginaryIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "8006",
    name: "trail-blazer-harmony",
    translation: {
      "en-us": "Trail Blazer",
      "zh-cn": "开拓者",
      "zh-tw": "開拓者",
    },
    story: [
      {
        "en-us":
          "They are awakened during the opening events of the game by Kafka and Silver Wolf,",
        "zh-cn":
          "在反物质军团入侵期间，(他/她)作为星核的载体被卡夫卡和银狼唤醒。",
        "zh-tw":
          "在反物質軍團入侵期間，(他/她)作為星核的載體被卡夫卡和銀狼喚醒。",
      },
      {
        "en-us":
          "who leave them to be found by March 7th and Dan Heng on Herta Space Station during the Antimatter Legion's invasion.",
        "zh-cn":
          "她们离开了空间站「黑塔」并将开拓者留在了这里，之后，开拓者被三月七和丹恒发现，并加入了星穹列车列车组。",
        "zh-tw":
          "她們離開了空間站「黑塔」並將開拓者留在了這裡，之後，開拓者被三月七和丹恆發現，並加入了星穹列車列車組。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 1,
        CR: 2,
        CD: 1,
        D: 0.04,
        DR: 1.2,
        DBF: 0,
        DBI: 0,
        DBM: 1.68,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 1.5,
        H: 0.05,
        HR: 1.5,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        WMDM4: 1,
        WMDM2: 1,
        TSM4: 1,
        TSM2: 1,
        TKB2: 1,
        LD2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Imaginary Boost %) * (100% - CR% + CR% x (100% + CD%)) * (100% + Break Effect % / 8) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 虚数属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (100% + 击破特攻 % / 8 * (速度/ 100) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 虛數屬性傷害提高 %) * (100% - 爆擊% + 暴傷% x (100% + 暴傷%)) * (100% + 擊破特攻 % / 8) * (速度/ 100) * 遺器套裝",
      },
      calculation:
        "(100% * (A))  * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * (100%+(BE)/8) * ((S) / 100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Harmony",
    element: "Imaginary",
    pathIcon: harmonyIcon,
    elementIcon: imaginaryIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "8007",
    name: "trail-blazer-remembrance",
    translation: {
      "en-us": "Trail Blazer",
      "zh-cn": "开拓者",
      "zh-tw": "開拓者",
    },
    story: [
      {
        "en-us":
          "They are awakened during the opening events of the game by Kafka and Silver Wolf,",
        "zh-cn":
          "在反物质军团入侵期间，(他/她)作为星核的载体被卡夫卡和银狼唤醒。",
        "zh-tw":
          "在反物質軍團入侵期間，(他/她)作為星核的載體被卡夫卡和銀狼喚醒。",
      },
      {
        "en-us":
          "who leave them to be found by March 7th and Dan Heng on Herta Space Station during the Antimatter Legion's invasion.",
        "zh-cn":
          "她们离开了空间站「黑塔」并将开拓者留在了这里，之后，开拓者被三月七和丹恒发现，并加入了星穹列车列车组。",
        "zh-tw":
          "她們離開了空間站「黑塔」並將開拓者留在了這裡，之後，開拓者被三月七和丹恆發現，並加入了星穹列車列車組。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 0.1,
        CD: 1.2,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 1.68,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        HTS4: 1,
        HTS2: 1,
        TWBP2: 1,
        LSS2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% + CD) * (100% + Ice Boost %) * (100% + Energy Regeneration Rate %) * (100% + Effect RES %) * (Speed / 100) * (HP / 100) * (DEF / 100) * Relic Set",
        "zh-cn":
          "(100% + 暴伤) * (100% + 冰属性伤害提高 %) * (100% + 能量恢复效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防御力 / 100) * 遗器套装",
        "zh-tw":
          "(100% + 暴傷) * (100% + 冰屬性傷害提高 %) * (100% + 能量恢復效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防禦力 / 100) * 遺器套裝",
      },
      calculation:
        "(100%+(CD)) * (100%+(ED)) * (100%+(EG)) * (100%+(ER)) * ((S) / 100) * ((H)/100) * ((D)/100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Remembrance",
    element: "Ice",
    pathIcon: remembranceIcon,
    elementIcon: iceIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "8008",
    name: "trail-blazer-remembrance",
    translation: {
      "en-us": "Trail Blazer",
      "zh-cn": "开拓者",
      "zh-tw": "開拓者",
    },
    story: [
      {
        "en-us":
          "They are awakened during the opening events of the game by Kafka and Silver Wolf,",
        "zh-cn":
          "在反物质军团入侵期间，(他/她)作为星核的载体被卡夫卡和银狼唤醒。",
        "zh-tw":
          "在反物質軍團入侵期間，(他/她)作為星核的載體被卡夫卡和銀狼喚醒。",
      },
      {
        "en-us":
          "who leave them to be found by March 7th and Dan Heng on Herta Space Station during the Antimatter Legion's invasion.",
        "zh-cn":
          "她们离开了空间站「黑塔」并将开拓者留在了这里，之后，开拓者被三月七和丹恒发现，并加入了星穹列车列车组。",
        "zh-tw":
          "她們離開了空間站「黑塔」並將開拓者留在了這裡，之後，開拓者被三月七和丹恆發現，並加入了星穹列車列車組。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 1.68,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        HTS4: 1,
        HTS2: 1,
        TWBP2: 1,
        LSS2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Ice Boost %) * (100% - CR% + CR% x (100% + CD%)) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 冰属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (速度/ 100) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 冰屬性傷害提高 %) * (100% - 爆擊% + 暴傷% x (100% + 暴傷%)) * (速度/ 100) * 遺器套裝",
      },
      calculation:
        "(100% * (A))  * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * ((S) / 100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Remembrance",
    element: "Ice",
    pathIcon: remembranceIcon,
    elementIcon: iceIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1004",
    name: "welt",
    translation: {
      "en-us": "Welt",
      "zh-cn": "瓦尔特",
      "zh-tw": "瓦爾特",
    },
    story: [
      {
        "en-us":
          "The wise and experienced former Anti-Entropy Sovereign who inherits the name of the world — Welt. He has saved Earth from annihilation time and time again.",
        "zh-cn":
          "老成持重的前逆熵盟主，继承了「世界」之名，曾屡次拯救世界于灭亡的边缘。",
        "zh-tw":
          "老成持重的前逆熵盟主，繼承了「世界」之名，曾屢次拯救世界於滅亡的邊緣。",
      },
      {
        "en-us":
          "After the incident with St. Fountain came to a close, welt had no choice but to venture with the initiator of the incident to the other side of the portal.",
        "zh-cn": "圣方丹事件结束后，瓦尔特被迫与事件始作俑者去向星门另一侧。",
        "zh-tw": "聖方丹事件結束後，瓦爾特被迫與事件始作俑者去向星門另一側。",
      },
      {
        "en-us":
          "Perhaps even he did not expect the new journey nor companions that awaited him there.",
        "zh-cn":
          "或许连他自己也未曾料到，在那里等待着的，将是全新的旅途和同伴。",
        "zh-tw":
          "或許連他自己也未曾料到，在那裡等待著的，將是全新的旅途和同伴。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 1.68,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 1,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(90% X ATT) * (100% + Imaginary Boost %) * (100% - CR% + CR% x (100% + CD%))",
        "zh-cn":
          "(90% X 攻击力) * (100% + 虚数属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%))",
      },
      calculation: "(90% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD)))",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Nihility",
    element: "Imaginary",
    pathIcon: nihilityIcon,
    elementIcon: imaginaryIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1209",
    name: "yanqing",
    translation: {
      "en-us": "Yanqing",
      "zh-cn": "彦卿",
      "zh-tw": "彥卿",
    },
    story: [
      {
        "en-us":
          "The spirited lieutenant of the Xianzhou Luofu, and also its most proficient swordsman.",
        "zh-cn": "意气飞扬的云骑骁卫，仙舟「罗浮」最强剑士。",
        "zh-tw": "意氣飛揚的雲騎驍衛，仙舟「羅浮」最強劍士。",
      },
      {
        "en-us":
          "He is born for swords and obsessed with them. Whenever a sword rests in his hand, none would dare to underestimate this genius still in the early days of his youth.",
        "zh-cn":
          "为剑生亦为剑痴，当彦卿手中握剑时，无人敢小看这位尚在总角之年的天才。",
        "zh-tw":
          "為劍生亦為劍痴，當彥卿手中握劍時，無人敢小看這位尚在總角之年的天才。",
      },
      {
        "en-us":
          "Perhaps the only thing capable of dulling his treasured blade's sharp edge is time.",
        "zh-cn": "或许能让手中宝剑微微收敛锋芒的，只有时间。",
        "zh-tw": "或許能讓手中寶劍微微收斂鋒芒的，只有時間。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 1.68,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Skill",
        "zh-cn": "战技",
        "zh-tw": "戰技",
      },
      description: {
        "en-us":
          "(110% X ATT) * (100% + Ice Boost %) * (100% - CR% + CR% x (100% + CD%)) * (Speed / 100)",
        "zh-cn":
          "(110% X 攻击力) * (100% + 冰属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (速度/ 100)",
        "zh-tw":
          "(110% X 攻擊力) * (100% + 冰屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * (速度/ 100)",
      },
      calculation:
        "(110% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * ((S) / 100)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Hunt",
    element: "Ice",
    pathIcon: huntIcon,
    elementIcon: iceIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1207",
    name: "yukong",
    translation: {
      "en-us": "Yukong",
      "zh-cn": "驭空",
      "zh-tw": "馭空",
    },
    story: [
      {
        "en-us":
          "The Xianzhou Luofu's Head of the Sky-Faring Commission is gentle, yet seasoned and authoritative. ",
        "zh-cn": "仙舟「罗浮」天舶司的主司，性情温和，处事老练。",
        "zh-tw": "仙舟「羅浮」天舶司的主司，性情溫和，處事老練。",
      },
      {
        "en-us":
          "Having been a pilot since young, she had become the commission's head with her outstanding combat achievements, yet she no longer flies due to a particularly brutal battle. ",
        "zh-cn":
          "年轻时作为飞行士久历战阵，以优秀的战绩成为主司，却因一场惨烈的战争不再飞翔天际。",
        "zh-tw":
          "年輕時作為飛行士久歷戰陣，以優秀的戰績成為主司，卻因一場慘烈的戰爭不再飛翔天際。",
      },
      {
        "en-us":
          "Now, her shine had already dimmed as she shifted her focus to official duties, but she is always seen guiding the course of the Luofu.",
        "zh-cn":
          "如今虽已褪去锋芒，专心操持公务，但「罗浮」的航向上始终有她的身影。",
        "zh-tw":
          "如今雖已褪去鋒芒，專心操持公務，但「羅浮」的航向上始終有她的身影。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 1.68,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(228% X ATT) * (100% + Imaginary Boost %) * (100% - CR% + CR% x (100% + CD%))",
        "zh-cn":
          "(228% X 攻击力) * (100% + 虚数属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%))",
        "zh-tw":
          "(228% X 攻擊力) * (100% + 虛數屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%))",
      },
      calculation:
        "(228% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD)))",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Harmony",
    element: "Imaginary",
    pathIcon: harmonyIcon,
    elementIcon: imaginaryIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1213",
    name: "dan-heng-imbibitor-lunae",
    translation: {
      "en-us": "Dan Heng • Imbibitor Lunae",
      "zh-cn": "丹恒 • 饮月君",
      "zh-tw": "丹恆 • 飲月君",
    },
    story: [
      {
        "en-us":
          "High Elder of the Luofu, bearer of the Azure Dragon's legacy, bringing forth clouds and rain, and entrusted with the duty of guarding the Ambrosial Arbor.",
        "zh-cn": "罗浮龙尊，掌苍龙之传。行云布雨，膺责守望不死建木。",
        "zh-tw": "羅浮龍尊，掌蒼龍之傳。行雲布雨，膺責守望不死建木。",
      },
      {
        "en-us":
          'Revered with the title of "Imbibitor Lunae." — History of the Xianzhou: The Five Dragons\' Exodus',
        "zh-cn": "尊号「饮月君」。——《仙舟通鉴 • 五龙远徙》",
        "zh-tw": "尊號「飲月君」。——《仙舟通鑑 • 五龍遠徙》",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 1.68,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        MWW4: 1,
        MWW2: 1,
        WBD4: 1,
        WBD2: 1,
        RA2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% X ATT) * (100% + Imaginary Boost %) * (100% - CR% + CR% x (100% + CD%)) * (Speed / 100) * Relic Set",
        "zh-cn":
          "(100% X 攻击力) * (100% + 虚数属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%)) * (速度/ 100) * 遗器套装",
        "zh-tw":
          "(100% X 攻擊力) * (100% + 虛數屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%)) * (速度/ 100) * 遺器套裝",
      },
      calculation:
        "(100% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD))) * ((S) / 100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Destruction",
    element: "Imaginary",
    pathIcon: destructionIcon,
    elementIcon: imaginaryIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1214",
    name: "xueyi",
    translation: {
      "en-us": "Xueyi",
      "zh-cn": "雪衣",
      "zh-tw": "雪衣",
    },
    story: [
      {
        "en-us":
          "One of the judges of the Ten-Lords Commission. Of the four duties of a judge (detention, interrogation, incarceration, and punishment), she is charged with detention.",
        "zh-cn":
          "仙舟「罗浮」的十王司判官之一，负责拘、锁、刑、问的四判官中的「拘」。",
        "zh-tw":
          "仙舟「羅浮」的十王司判官之一，負責拘、鎖、刑、問的四判官中的「拘」。",
      },
      {
        "en-us":
          "Holding iron chains and a Marasunder Awl in her hands, she tirelessly tracks down wanted criminals and subdues them.",
        "zh-cn": "手持铁索与破魔锥，不知疲倦地寻索重犯，将其勾摄镇伏。",
        "zh-tw": "手持鐵索與破魔錐，不知疲倦地尋索重犯，將其勾攝鎮伏。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 1.2,
        BE: 0.5,
        CR: 2,
        CD: 1,
        D: 0.02,
        DR: 0.1,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 1.68,
        DBW: 0,
        EG: 3.35,
        EH: 0.3,
        ER: 0.5,
        H: 0.02,
        HR: 0.6,
        O: 0,
        S: 2.5,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(228% X ATT) * (100% + Imaginary Boost %) * (100% - CR% + CR% x (100% + CD%))",
        "zh-cn":
          "(228% X 攻击力) * (100% + 虚数属性伤害提高 %) * (100% - 暴击% + 暴伤% x (100% + 暴伤%))",
        "zh-tw":
          "(228% X 攻擊力) * (100% + 虛數屬性傷害提高 %) * (100% - 暴擊% + 暴傷% x (100% + 暴傷%))",
      },
      calculation:
        "(228% * (A)) * (100%+(ED)) * (100%-(CR) + (CR)*(100%+(CD)))",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Destruction",
    element: "Quantum",
    pathIcon: destructionIcon,
    elementIcon: quantumIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1208",
    name: "fuxuan",
    translation: {
      "en-us": "Fu Xuan",
      "zh-cn": "符玄",
      "zh-tw": "符玄",
    },
    story: [
      {
        "en-us":
          "The head of the Xianzhou Luofu's Divination Commission. A confident and blunt sage.",
        "zh-cn": "仙舟「罗浮」太卜司之首，自信耿直的智者。",
        "zh-tw": "仙舟「羅浮」太卜司之首，自信耿直的智者。",
      },
      {
        "en-us":
          'Using her third eye and the Matrix of Prescience, Fu Xuan calculates the Xianzhou\'s route and predicts the fortune of future events. She firmly believes that everything she does is the "best solution" for the situation.',
        "zh-cn":
          "凭借第三眼与穷观阵为仙舟占算航路，预卜事务吉凶，坚信自己所做的一切便是事情的「最优解」。",
        "zh-tw":
          "憑藉第三眼與窮觀陣為仙舟佔算航路，預卜事務吉凶，堅信自己所做的一切便是事情的「最優解」。",
      },
      {
        "en-us":
          'Fu Xuan is waiting for the general\'s promised "abdication." However, that day still seems... very far away.',
        "zh-cn":
          "符玄等待着将军承诺的「退位让贤」，然而这一天的到来…似乎还遥遥无期。",
        "zh-tw":
          "符玄等待著將軍承諾的「退位讓賢」，然而這一天的到來…似乎還遙遙無期。",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 0.2,
        BE: 0.5,
        CR: 0.2,
        CD: 0.1,
        D: 0.04,
        DR: 1.2,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.2,
        ER: 1.5,
        H: 0.05,
        HR: 1.5,
        O: 0,
        S: 2.5,
      },
      relic_set_stats: {
        GWS2: 1,
        LD2: 1,
        FA2: 1,
        BK2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% + Energy Regeneration Rate %) * (100% + Effect RES %) * (Speed / 100) * (HP / 100) * (DEF / 100) * Relic Set",
        "zh-cn":
          "(100% + 能量恢复效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防御力 / 100) * 遗器套装",
        "zh-tw":
          "(100% + 能量恢復效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (生命值 / 100) * (防禦力 / 100) * 遺器套裝",
      },
      calculation:
        "(100%+(EG)) * (100%+(ER)) * ((S) / 100) * ((H)/100) * ((D)/100) * (RS)",
    },
    rarity_number: "five-star",
    rarity: fiveStarsIcon,
    path: "Preservation",
    element: "Quantum",
    pathIcon: preservationIcon,
    elementIcon: quantumIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
  {
    id: "1110",
    name: "lynx",
    translation: {
      "en-us": "Lynx",
      "zh-cn": "玲可",
      "zh-tw": "玲可",
    },
    story: [
      {
        "en-us":
          '"In the Landau family, things are quite simple: If you want to do something, just go ahead and do it." The youngest daughter of the Landau family, and one of Belobog\'s best extreme environments explorers.',
        "zh-cn":
          "「我们朗道家的事情都很简单：想去做的话就去。」朗道家年龄最小的女孩，贝洛伯格首屈一指的极地探险家。",
        "zh-tw":
          "「我們朗道家的事情都很簡單：想去做的話就去。」朗道家年齡最小的女孩，貝洛伯格首屈一指的極地探險家。",
      },
      {
        "en-us":
          "She is highly capable of action despite her apparent lack of motivation. She's only appears introverted and lazy to avoid unnecessary socialization.",
        "zh-cn":
          "看似慵懒，实际上执行力极强。散发生人勿近的气场只是为了避免不必要的社交。",
        "zh-tw":
          "看似慵懶，實際上執行力極強。散發生人勿近的氣場只是為了避免不必要的社交。",
      },
      {
        "en-us":
          'As for what counts as unnecessary socialization — "Um, aren\'t all socialization unnecessary?"',
        "zh-cn": "至于如何定义不必要的社交——「呃…所有社交不都是没必要的吗？」",
        "zh-tw": "至於如何定義不必要的社交——「呃…所有社交不都是沒必要的嗎？」",
      },
    ],
    formula: {
      stats: {
        A: 0.04,
        AR: 0.2,
        BE: 0.5,
        CR: 0.2,
        CD: 0.1,
        D: 0.04,
        DR: 1.2,
        DBF: 0,
        DBI: 0,
        DBM: 0,
        DBP: 0,
        DBL: 0,
        DBQ: 0,
        DBW: 0,
        EG: 3.35,
        EH: 0.2,
        ER: 1.5,
        H: 0.05,
        HR: 1.5,
        O: 1.8,
        S: 2.5,
      },
      relic_set_stats: {
        MTH2: 1,
        MTH4: 1,
        PWC4: 1,
        PWC2: 1,
        LD2: 1,
        FA2: 1,
        BK2: 1,
        SV2: 1,
      },
      name: {
        "en-us": "Ultimate",
        "zh-cn": "终结技",
        "zh-tw": "終結技",
      },
      description: {
        "en-us":
          "(100% + Energy Regeneration Rate %) * (100% + Effect RES %) * (Speed / 100) * (100% + Outgoing Healing Boost %) * (HP / 100) * (DEF / 100)  * Relic Set",
        "zh-cn":
          "(100% + 能量恢复效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (100% + 治疗量加成 %) * (生命值 / 100) * (防御力 / 100) * 遗器套装",
        "zh-tw":
          "(100% + 能量恢復效率 %) * (100% + 效果抵抗 %) * (速度/ 100) * (100% + 治療量加成 %) * (生命值 / 100) * (防禦力 / 100) * 遺器套裝",
      },
      calculation:
        "(100%+(EG)) * (100%+(ER)) * ((S) / 100) * (100%+(O)) * ((H)/100) * ((D)/100) * (RS)",
    },
    rarity_number: "four-star",
    rarity: fourStarsIcon,
    path: "Abundance",
    element: "Quantum",
    pathIcon: abundanceIcon,
    elementIcon: quantumIcon,
    sortModel: [
      {
        field: "formula",
        sort: "desc",
      },
    ],
    type: "live",
  },
];
